export const info = {
  ru: {
    aeroflot: {
      pageKey: "aeroflotInfo",
      imageUrl: "/images/AK/SU.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Аэрофлот</h1>
            <h2>Дата основания и история</h2>
            <p>Аэрофлот (ПАО «Аэрофлот — Российские авиалинии») — одна из старейших авиакомпаний мира,
          основанная в 1923 году. За свою долгую историю прошла путь от монополиста в советский
          период до ведущего международного перевозчика, предлагающего авиабилеты (aviabilet) по
          множеству направлений, включая Узбекистан.</p>
            <h3>Флот Аэрофлота</h3>
            <p>В парке Аэрофлота преимущественно современные самолёты Airbus и Boeing. Линейка включает
            коротко- и среднемагистральные Airbus A320/321, а также дальнемагистральные Boeing 777 и 
            Airbus A330.</p>
            <table>
              <thead>
                <tr>
                  <th>Тип самолёта</th>
                  <th>Количество (примерно)</th>
                  <th>Особенности</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320/321</td>
                  <td>~100</td>
                  <td>Коротко- и среднемагистральные маршруты</td>
                </tr>
                <tr>
                  <td>Airbus A330</td>
                  <td>~20</td>
                  <td>Дальние рейсы, повышенная комфортность</td>
                </tr>
                <tr>
                  <td>Boeing 777</td>
                  <td>~20</td>
                  <td>Межконтинентальные направления, просторные салоны</td>
                </tr>
              </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Аэрофлот осуществляет прямые рейсы из следующих городов Узбекистана в Москву (Шереметьево):</p>
            <ul>
              <li>
                <b>Ташкент (TAS): </b>обычно ежедневно (7 раз в неделю).
              </li>
              <li>
                <b>Самарканд (SKD): </b>2–3 раза в неделю.
              </li>
              <li>
                <b>Бухара (BHK): </b>1–2 раза в неделю.
              </li>
            </ul>
            <p>Уточняйте авиабилеты и актуальные дни вылета на официальном сайте или 
          <a href="https://biletbor.me" target="_blank" rel="noreferrer">biletbor.me</a>.</p>
          <h3>Короткий вывод</h3>
          <p>Аэрофлот — это сочетание многолетнего опыта, широкой маршрутной сети и современного авиапарка. 
          Если вам нужны авиабилеты (aviabilet) в Москву или другие города, обязательно сравните цены 
          и воспользуйтесь акциями на biletbor.me или на официальном сайте.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна: </h4>
            <p>Россия</p> 
            <h4>Штаб-квартира: </h4> 
            <p>Москва</p> 
            <h4>Основной хаб: </h4>   
            <p>Аэропорт Шереметьево (терминалы B/C), откуда выполняется большинство международных и региональных рейсов</p>
            <h4>Вебсайт:</h4>
            <a href="https://www.aeroflot.ru" target="_blank" rel="noreferrer">www.aeroflot.ru</a>
          `,
        },
      ],
    },
    uzairways: {
      name: "uzairways",
      pageKey: "uzairwaysInfo",
      imageUrl: "/images/AK/HY.svg",
      generalInfo: [
        {
          content: `<article>
        <h1>Uzbekistan Airways</h1>
        <h2>Дата основания и история</h2>
        <p>Uzbekistan Airways – национальная авиакомпания Узбекистана, основанная в 1992 году. За годы работы компания расширила свою маршрутную сеть, предлагая авиаперелеты в Европу, Азию и Северную Америку.</p>
        <h2>Флот Uzbekistan Airways</h2>
        <table>
            <thead>
                <tr>
                    <th>Тип самолёта</th>
                    <th>Количество</th>
                    <th>Основные маршруты</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Boeing 787 Dreamliner</td>
                    <td>7</td>
                    <td>Дальнемагистральные маршруты</td>
                </tr>
                <tr>
                    <td>Airbus A320neo</td>
                    <td>10</td>
                    <td>Среднемагистральные маршруты</td>
                </tr>
                <tr>
                    <td>Boeing 767-300</td>
                    <td>6</td>
                    <td>Международные рейсы</td>
                </tr>
            </tbody>
        </table>
        
        <h2>Расписание рейсов из Узбекистана</h2>
        <ul>
            <li><strong>Ташкент – Москва:</strong> ежедневно</li>
            <li><strong>Ташкент – Санкт-Петербург:</strong> 3 раза в неделю</li>
            <li><strong>Самарканд – Дубай:</strong> 2 раза в неделю</li>
            <li><strong>Бухара – Стамбул:</strong> 2 раза в неделю</li>
        </ul>
        <p>Для актуального расписания и aviabilet narxlari рекомендуем посетить <a href="https://biletbor.me">biletbor.me</a> или официальный сайт авиакомпании.</p>
        <h3>Короткий вывод</h3>
        <p>Uzbekistan Airways предлагает комфортные перелеты по многим направлениям. Узнать стоимость билетов и забронировать можно на <a href="https://biletbor.me">Biletbor.me</a>.</p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Узбекистан</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Ташкент</p> 
        <h4>Основной хаб:</h4>   
        <p>Международный аэропорт Ташкент (TAS)</p>
        <h4>Вебсайт:</h4>
        <a href="https://www.uzairways.com" target="_blank" rel="noreferrer">www.uzairways.com</a>`,
        },
      ],
    },
    turkishAirlines: {
      name: "turkish",
      pageKey: "turkishInfo",
      imageUrl: "/images/AK/TK.svg",
      generalInfo: [
        {
          content: `<article>
        <h1>Turkish Airlines</h1>
        <h2>Дата основания и история</h2>
        <p>Turkish Airlines была основана в 1933 году и является национальным авиаперевозчиком Турции. Сегодня это одна из крупнейших авиакомпаний в мире.</p>
        <h2>Флот S7 Airlines</h2>
        <p>Turkish Airlines эксплуатирует один из крупнейших и самых современных парков самолетов, включая:</p>
        <table>
            <thead>
                <tr>
                    <th>Тип самолёта</th>
                    <th>Количество</th>
                    <th>Основные маршруты</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Boeing 777-300ER</td>
                    <td>33</td>
                    <td>Дальнемагистральные рейсы</td>
                </tr>
                <tr>
                    <td>Airbus A321neo</td>
                    <td>45</td>
                    <td>Средние и короткие рейсы</td>
                </tr>
                <tr>
                    <td>Boeing 737-800</td>
                    <td>36</td>
                    <td>Региональные направления</td>
                </tr>
            </tbody>
        </table>
        
        <h2>Расписание рейсов из Узбекистана</h2>
        <p>Turkish Airlines выполняет регулярные рейсы из Ташкента и других городов Узбекистана:</p>
        <ul>
            <li><strong>Ташкент – Стамбул:</strong> ежедневно</li>
            <li><strong>Самарканд – Стамбул:</strong> 2 раза в неделю</li>
            <li><strong>Бухара – Стамбул:</strong> 1-2 раза в неделю</li>
        </ul>
        <p>Для актуального расписания и aviabilet narxlari рекомендуем посетить <a href="https://biletbor.me">biletbor.me</a> или официальный сайт авиакомпании.</p>
        <h3>Короткий вывод</h3>
        <p>Turkish Airlines предлагает удобные рейсы по всему миру. Узнать расписание и забронировать билеты можно на <a href="https://biletbor.me">Biletbor.me.</a></p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Турция</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Стамбул</p> 
        <h4>Основной хаб:</h4>   
        <p>Новый аэропорт Стамбула (IST)</p>
        <h4>Вебсайт:</h4>
        <a href="https://www.turkishairlines.com/" target="_blank" rel="noreferrer">www.turkishairlines.com</a>
      `,
        },
      ],
    },
    belavia: {
      name: "belavia",
      pageKey: "belaviaInfo",
      imageUrl: "/images/AK/B2.png",
      generalInfo: [
        {
          content: `<article>
        <h1>Белавиа</h1>
        <h2>Дата основания и история</h2>
        <p>Belavia — национальная авиакомпания Республики Беларусь, основанная в 1996 году на основе советского авиаперевозчика Aeroflot. С момента своего основания Belavia активно развивается, расширяя маршрутную сеть и внедряя современные технологии для улучшения качества обслуживания пассажиров. Компания стремится предоставлять aviabilet дешевые и удобные условия для путешествий как внутри Беларуси, так и за её пределами.</p>
        <h3>Флот Azal</h3>
        <p>Флот Belavia включает современные самолёты Airbus (A320, A330) и Boeing (737, 767). Эти воздушные суда обеспечивают высокий уровень комфорта и безопасности на коротко- и дальнемагистральных маршрутах. Разнообразие флота позволяет Belavia предлагать различные aviabilet narxlari в зависимости от класса обслуживания (эконом, бизнес).</p>
        <table>
          <thead>
            <tr>
              <th>Самолёт</th>
              <th>Особенности</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Airbus A320</td>
              <td>Комфортные условия для эконом и бизнес-класса</td>
            </tr>
            <tr>
              <td>Boeing 737</td>
              <td>Надёжность и безопасность для коротко- и среднемагистральных маршрутов</td>
            </tr>
          </tbody>
        </table>
        <h3>Расписание рейсов из Узбекистана</h3>
        <p>Belavia предлагает рейсы из следующих городов Узбекистана:</p>
        <ul>
          <li>
            <b>Ташкента (TAS):</b> рейсы в Минск с пересадкой или прямые рейсы (частота зависит от сезона).
          </li>
          <li>
            <b>Самарканд (SKD):</b> сезонные рейсы в Минск и другие направления.
          </li>
        </ul>
        <p>Для актуального расписания и aviabilet narxlari рекомендуем посетить <a href="https://biletbor.me">biletbor.me</a> или официальный сайт авиакомпании.</p>
        <h3>Короткий вывод</h3>
        <p>Belavia — надёжная авиакомпания, предоставляющая доступные aviabilet narxlari и комфортные условия для пассажиров. Если вы планируете путешествие из Узбекистана в Беларусь или другие страны СНГ, сравните предложения Belavia на <a href="https://biletbor.me">biletbor.me</a> и выберите наиболее подходящий рейс.</p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Беларусь</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Минск</p> 
        <h4>Основной хаб:</h4>   
        <p>Международный аэропорт Минск (MSQ)
           Belavia выполняет рейсы из Минска в множество городов Европы, Азии и Ближнего Востока, а также осуществляет чартерные рейсы в туристические направления. Это позволяет пассажирам выбирать aviabilet moskva, aviabilet sankt peterburg и другие маршруты с удобными пересадками.</p>
        <h4>Вебсайт:</h4>
        <a href="https://belavia.by/" target="_blank" rel="noreferrer">www.belavia.by</a>
      `,
        },
      ],
    },
    uralairlines: {
      name: "ural",
      pageKey: "uralInfo",
      imageUrl: "/images/AK/U6.svg",
      generalInfo: [
        {
          content: `<article>
        <h1>Ural Airlines</h1>
        <h2>Дата основания и история</h2>
        <p>Ural Airlines была основана в 1943 году как подразделение «Аэрофлота». В 1993 году компания стала независимой авиакомпанией и с тех пор активно расширяет свою маршрутную сеть, предлагая авиабилеты (aviabilet) на международные и внутренние рейсы.</p>
        <h2>Флот Ural Airlines</h2>
        <p>Ural Airlines располагает современным парком воздушных судов:</p>
        <table>
            <thead>
                <tr>
                    <th>Тип самолёта</th>
                    <th>Количество</th>
                    <th>Основные маршруты</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Airbus A320</td>
                    <td>20</td>
                    <td>Среднемагистральные рейсы</td>
                </tr>
                <tr>
                    <td>Airbus A321</td>
                    <td>15</td>
                    <td>Дальнемагистральные маршруты</td>
                </tr>
                <tr>
                    <td>Airbus A319</td>
                    <td>10</td>
                    <td>Короткие и региональные рейсы</td>
                </tr>
            </tbody>
        </table>
        <h2>Расписание рейсов из Узбекистана</h2>
        <p>Ural Airlines выполняет регулярные рейсы из Ташкента и других городов:</p>
        <ul>
            <li><strong>Ташкент – Москва:</strong> 3 раза в неделю</li>
            <li><strong>Самарканд – Екатеринбург:</strong> 2 раза в неделю</li>
            <li><strong>Фергана – Москва:</strong> 1-2 раза в неделю</li>
        </ul>
        <p>Для актуального расписания и aviabilet narxlari рекомендуем посетить <a href="https://biletbor.me">biletbor.me</a> или официальный сайт авиакомпании.</p>
        <h3>Короткий вывод</h3>
        <p>Ural Airlines предлагает комфортные перелеты по России и за ее пределами. Узнать расписание и забронировать билеты можно на <a href="https://biletbor.me">Biletbor.me.</a></p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Россия</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Екатеринбург</p> 
        <h4>Основной хаб:</h4>   
        <p>Международный аэропорт Кольцово (SVX)</p>
        <h4>Вебсайт:</h4>
        <a href="https://www.uralairlines.ru/" target="_blank" rel="noreferrer">www.uralairlines.ru</a>
      `,
        },
      ],
    },
    s7: {
      pageKey: "s7Info",
      imageUrl: "/images/AK/S7.svg",
      generalInfo: [
        {
          content: `<article>
        <h1>S7 Airlines</h1>
        <h2>Дата основания и история</h2>
        <p>S7 Airlines – крупнейшая частная авиакомпания России, основанная в 1992 году. Сегодня это один из ведущих авиаперевозчиков страны с развитой маршрутной сетью.</p>
        <h2>Флот S7 Airlines</h2>
        <p>S7 Airlines эксплуатирует современные воздушные суда, в том числе:</p>
        <table>
            <thead>
                <tr>
                    <th>Тип самолёта</th>
                    <th>Количество</th>
                    <th>Основные маршруты</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Airbus A320neo</td>
                    <td>20</td>
                    <td>Средние и дальние маршруты</td>
                </tr>
                <tr>
                    <td>Boeing 737-800</td>
                    <td>23</td>
                    <td>Внутренние и международные рейсы</td>
                </tr>
                <tr>
                    <td>Embraer E170</td>
                    <td>17</td>
                    <td>Региональные маршруты</td>
                </tr>
            </tbody>
        </table>
        
        <h2>Расписание рейсов из Узбекистана</h2>
        <ul>
            <li><strong>Ташкент – Москва:</strong> ежедневно</li>
            <li><strong>Ташкент – Новосибирск:</strong> 2 раза в неделю</li>
            <li><strong>Самарканд – Москва:</strong> 1-2 раза в неделю</li>
        </ul>
        <p>Для актуального расписания и aviabilet narxlari рекомендуем посетить <a href="https://biletbor.me">biletbor.me</a> или официальный сайт авиакомпании.</p>
        <h3>Короткий вывод</h3>
        <p>S7 Airlines предлагает удобные рейсы по России и международным направлениям. Узнать расписание и забронировать билеты можно на <a href="https://biletbor.me">Biletbor.me.</a></p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Россия</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Москва</p> 
        <h4>Основной хаб:</h4>   
        <p>Москва (Домодедово, DME), Новосибирск (Толмачёво, OVB)</p>
        <h4>Вебсайт:</h4>
        <a href="https://www.s7.ru" target="_blank" rel="noreferrer">www.s7.ru</a>
      `,
        },
      ],
    },
    qanotsharq: {
      pageKey: "qanotsharqInfo",
      imageUrl: "/images/AK/HH.svg",
      generalInfo: [
        {
          content: `<article>
        <h1>Qanot Sharq</h1>
        <h2>Дата основания и история</h2>
        <p>Авиакомпания Qanot Sharq была основана в 1998 году и специализируется на пассажирских и грузовых перевозках. За годы работы компания зарекомендовала себя как надёжный перевозчик, обеспечивающий качественный сервис на международных и внутренних направлениях.</p>
        <h2>Флот Qanot Sharq</h2>
        <p>На сегодняшний день авиакомпания эксплуатирует следующие типы воздушных судов:</p>
        <table>
            <thead>
                <tr>
                    <th>Тип самолёта</th>
                    <th>Количество</th>
                    <th>Основные маршруты</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Airbus A320</td>
                    <td>2</td>
                    <td>Международные и внутренние рейсы</td>
                </tr>
                <tr>
                    <td>Boeing 757-200</td>
                    <td>1</td>
                    <td>Дальнемагистральные маршруты</td>
                </tr>
            </tbody>
        </table>        
        <h2>Расписание рейсов из Узбекистана</h2>
        <p>Qanot Sharq выполняет регулярные и чартерные рейсы. Основные направления:</p>
        <ul>
            <li><strong>Ташкент – Москва:</strong> ежедневно</li>
            <li><strong>Ташкент – Санкт-Петербург:</strong> 4 раза в неделю</li>
            <li><strong>Ташкент – Дубай:</strong> 3 раза в неделю</li>
            <li><strong>Ташкент – Стамбул:</strong> 2 раза в неделю</li>
        </ul>
        <p>Для актуального расписания и aviabilet narxlari рекомендуем посетить <a href="https://biletbor.me">biletbor.me</a> или официальный сайт авиакомпании.</p>
        <h3>Короткий вывод</h3>
        <p>Qanot Sharq – это удобные и доступные перелёты по популярным маршрутам. Забронируйте билеты онлайн на <a href="https://biletbor.me">biletbor.me</a> и путешествуйте с комфортом!</p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Узбекистан</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Ташкент</p> 
        <h4>Основной хаб:</h4>   
        <p>Международный аэропорт Ташкент (TAS)</p>
        <h4>Вебсайт:</h4>
        <a href="https://qanotsharq.com/" target="_blank" rel="noreferrer">www.qanotsharq.com</a>
      `,
        },
      ],
    },
    pobeda: {
      name: "pobeda",
      pageKey: "pobedaInfo",
      imageUrl: "/images/AK/DP.svg",
      generalInfo: [
        {
          content: `<article>
        <h1>Победа</h1>
        <h2>Дата основания и история</h2>
        <p>Авиакомпания <strong>Pobeda</strong> (Победа) – российский лоукостер, основанный в 2014 году. Она входит в группу "Аэрофлот" и предлагает доступные авиабилеты по России и за её пределами.</p>
        <h2>Флот Победы</h2>
        <p>Pobeda использует исключительно современные самолёты Boeing 737-800:</p>
        <table>
          <thead>
              <tr>
                  <th>Тип самолёта</th>
                  <th>Количество</th>
                  <th>Основные маршруты</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>Boeing 737-800</td>
                  <td>45</td>
                  <td>Россия, СНГ, Европа</td>
              </tr>
          </tbody>
        </table>
        <h2>Расписание рейсов из Узбекистана</h2>
        <p>Ural Airlines выполняет регулярные рейсы из Ташкента и других городов:</p>
        <ul>
            <li><strong>Ташкент – Москва (VKO):</strong> ежедневно</li>
            <li><strong>Самарканд – Москва (VKO):</strong> 3 раза в неделю</li>
            <li><strong>Фергана – Москва (VKO):</strong> 2 раза в неделю</li>
        </ul>
        <p>Для актуального расписания и aviabilet narxlari рекомендуем посетить <a href="https://biletbor.me">Biletbor.me</a> или официальный сайт авиакомпании.</p>
        <h3>Короткий вывод</h3>
        <p>Pobeda – это удобные и доступные авиаперелёты из Узбекистана в Москву и другие города. Забронируйте билеты онлайн на <a href="https://biletbor.me">Biletbor.me</a> и летайте выгодно!</p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Россия</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Москва</p> 
        <h4>Основной хаб:</h4>   
        <p>Московский аэропорт Внуково (VKO)</p>
        <h4>Вебсайт:</h4>
        <a href="https://www.flypobeda.ru/" target="_blank" rel="noreferrer">www.flypobeda.ru</a>
      `,
        },
      ],
    },
    airastana: {
      name: "airastana",
      pageKey: "airastanaInfo",
      imageUrl: "/images/AK/KC.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air Astana</h1>
            <h2>Дата основания и история</h2>
            <p>Air Astana — национальная авиакомпания Республики Казахстан, основанная в 2001 году. С момента запуска она активно развивает маршрутную сеть, предлагая aviabilet дешевые и премиальные тарифы. Компания постоянно совершенствует сервис на борту и качество обслуживания.</p>
            <h3>Флот Air Astana</h3>
            <p>Air Astana эксплуатирует современные самолёты семейств Airbus (A320, A321, A321LR/neo), Boeing (757, 767) и Embraer (E190-E2). Такой флот обеспечивает гибкость в выборе маршрутов и комфорт для пассажиров, ищущих как aviabilet narxlari эконом-класса, так и более просторные места бизнес-класса.</p>
            <table>
              <thead>
                <tr>
                  <th>Тип самолёта</th>
                  <th>Особенности</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320 / A321 / A321LR</td>
                  <td>Современные модели для ближне- и среднемагистральных рейсов</td>
                </tr>
                <tr>
                  <td>Boeing 757 / 767</td>
                  <td>Надёжные дальнемагистральные лайнеры</td>
                </tr>
                <tr>
                  <td>Embraer E190-E2</td>
                  <td>Удобные региональные самолёты для коротких перелётов</td>
                </tr>
              </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Air Astana предлагает прямые и стыковочные рейсы из:</p>
            <ul>
              <li>
                <b>Ташкента (TAS):</b> в Алматы или Астану (несколько раз в неделю)
              </li>
              <li>
                <b>Самарканд (SKD): </b>периодически сезонные рейсы (уточняйте на biletbor.me)
              </li>
              <li>
                <b>Бухара (BHK): </b>1–2 раза в неделю.
              </li>
            </ul>
            <p>Далее возможны пересадки на другие маршруты, включая aviabilet moskva, aviabilet sankt peterburg и другие направления. Актуальное расписание смотрите на  
          <a href="https://biletbor.me" target="_blank" rel="noreferrer">biletbor.me</a>.</p>
            <h3>Короткий вывод</h3>
            <p>Air Astana — динамично развивающаяся авиакомпания Казахстана, предлагающая удобные рейсы между Узбекистаном и многими городами мира. Если вы ищете комфорт и доступные цены, стоит обратить внимание на их aviabilet narxlari и стыковочные возможности для дальнейших перелётов.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна: </h4>
            <p>Казахстан</p> 
            <h4>Штаб-квартира: </h4> 
            <p>Алматы</p> 
            <h4>Основной хаб: </h4>   
            <p>Международные аэропорты Алматы и Астаны
              Air Astana осуществляет рейсы в страны СНГ, Азии, Ближнего Востока и Европы, давая пассажирам возможность сравнивать aviabilet moskva и aviabilet sankt peterburg с другими направлениями
            </p>
            <h4>Вебсайт:</h4>
            <a href="https://www.airastana.com" target="_blank" rel="noreferrer">www.airastana.com</a>
          `,
        },
      ],
    },
    flyaristan: {
      pageKey: "flyaristanInfo",
      imageUrl: "/images/AK/FS.png",
      generalInfo: [
        {
          content: `<article>
            <h1>FlyAirstan</h1>
            <h2>Дата основания и история</h2>
            <p>FlyAirstan — казахстанская авиакомпания, основанная в 2020 году. Компания базируется в Алматы и осуществляет внутренние рейсы по Казахстану, а также международные рейсы в соседние страны Центральной Азии и на Ближний Восток. FlyAirstan ориентирована на бюджетные путешествия и предоставляет пассажирам доступные цены на авиабилеты.</p>
            <h3>Флот FlyAirstan</h3>
            <p>Флот авиакомпании состоит из современных воздушных судов:</p>
            <table>
              <thead>
                <tr>
                  <th>Тип самолёта</th>
                  <th>Количество (примерно)</th>
                  <th>Особенности</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320</td>
                  <td>~5</td>
                  <td>Среднемагистральные рейсы</td>
                </tr>
                <tr>
                  <td>Airbus A321</td>
                  <td>~3</td>
                  <td>Среднемагистральные рейсы с увеличенной вместимостью</td>
                </tr>
              </tbody>
            </table>
            <h3>Маршрутная сеть</h3>
            <p>FlyAirstan выполняет регулярные рейсы как внутри Казахстана, так и на международных маршрутах:</p>
            <ul>
              <li><b>Алматы – Нур-Султан:</b> несколько раз в неделю.</li>
              <li><b>Алматы – Ташкент (TAS):</b> регулярные рейсы.</li>
              <li><b>Алматы – Дубай (DXB):</b> международные рейсы.</li>
            </ul>
            <p>Актуальное расписание и бронирование билетов доступны на официальном сайте авиакомпании.</p>
            <h3>Вывод</h3>
            <p>FlyAirstan предоставляет доступные и удобные рейсы как по Казахстану, так и за рубеж, обеспечивая качественное обслуживание на борту и конкурентоспособные цены на авиабилеты.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4>
            <p>Казахстан</p>
            <h4>Штаб-квартира:</h4>
            <p>Алматы</p>
            <h4>Основной хаб:</h4>
            <p>Международный аэропорт Алматы (ALA)</p>
            <h4>Вебсайт:</h4>
            <a href="https://flyairstan.com" target="_blank" rel="noreferrer">www.flyairstan.com</a>
          `,
        },
      ],
    },
    aircairo: {
      name: "aircairo",
      pageKey: "airCairoInfo",
      imageUrl: "/images/AK/SM.png",
      generalInfo: [
        {
          content: `<article>
            <h1>Air Cairo</h1>
            <h2>Дата основания и история</h2>
            <p>Air Cairo — египетская авиакомпания, основанная в 2003 году. Первоначально компания развивалась как чартерный перевозчик, ориентированный на туристические направления, но впоследствии стала выполнять и регулярные рейсы. Air Cairo предлагает aviabilet дешевые направления, включая вылеты из Узбекистана.</p>
            <h3>Флот Air Cairo</h3>
            <p>Air Cairo использует современные самолёты семейства Airbus A320/321. Флот ориентирован на средние дистанции и обеспечивает комфорт в салонах экономического класса и отдельных бизнес-направлениях. При выборе aviabilet narxlari можно найти как базовые, так и улучшенные тарифы.</p>
            <table>
              <thead>
                <tr>
                  <th>Тип самолёта</th>
                  <th>Особенности</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320</td>
                  <td>Среднемагистральные рейсы, базовый эконом и отдельные бизнес-тарифы</td>
                </tr>
                <tr>
                  <td>Airbus A321</td>
                  <td>Увеличенная пассажировместимость для популярных направлений</td>
                </tr>
              </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Air Cairo периодически предлагает рейсы из Узбекистана в Египет (Каир, Шарм-эш-Шейх и т.д.) в зависимости от туристического сезона и спроса.</p>
            <ul>
              <li>
                <b>Ташкента (TAS):</b> может выполняться в туристический сезон (уточняйте на <a href="https://biletbor.me">biletbor.me)</a>.
              </li>
              <li>
                <b>Другие города: </b>возможны чартеры в пиковые даты.
              </li>
            </ul>
            <p>Далее возможны пересадки на другие маршруты, включая aviabilet moskva, aviabilet sankt peterburg и другие направления. Актуальное расписание смотрите на  
          <a href="https://biletbor.me" target="_blank" rel="noreferrer">biletbor.me</a>.</p>
            <h3>Короткий вывод</h3>
            <p>Air Cairo — удобный выбор для путешествий между Узбекистаном и Египтом, особенно в туристический сезон. Авиакомпания сочетает доступные aviabilet narxlari с регулярными спецпредложениями, что может быть интересно как любителям пляжного отдыха, так и тем, кто ищет новые маршруты.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна: </h4>
            <p>Египет</p> 
            <h4>Штаб-квартира: </h4> 
            <p>Каир</p> 
            <h4>Основной хаб: </h4>   
            <p>Международный аэропорт Каир (CAI)
               Авиакомпания известна рейсами в Ближний Восток, Европу и некоторые города в Азии, что даёт возможность сравнить aviabilet moskva и aviabilet sankt peterburg при планировании стыковок.
            </p>
            <h4>Вебсайт:</h4>
            <a href="https://www.aircairo.com" target="_blank" rel="noreferrer">www.aircairo.com</a>
          `,
        },
      ],
    },
    airchina: {
      pageKey: "airchinaInfo",
      imageUrl: "/images/AK/CA.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air China – национальный авиаперевозчик Китая</h1>
            <h2>Дата основания и история</h2>
            <p>Air China была основана в 1988 году и является флагманским авиаперевозчиком КНР. Компания входит в Star Alliance и осуществляет международные, межконтинентальные и внутренние рейсы, связывая Китай с более чем 60 странами.</p>
            <h3>Флот Air China</h3>
            <p>Флот авиакомпании включает как узкофюзеляжные, так и широкофюзеляжные самолёты Boeing и Airbus. Это позволяет выполнять рейсы на всех уровнях — от внутренних до трансконтинентальных.</p>
            <table>
              <thead>
                <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
              </thead>
              <tbody>
                <tr><td>Boeing 737</td><td>~120</td><td>Внутренние и региональные маршруты</td></tr>
                <tr><td>Airbus A330 / A350</td><td>~70</td><td>Международные рейсы</td></tr>
                <tr><td>Boeing 777 / 787</td><td>~60</td><td>Дальнемагистральные маршруты</td></tr>
              </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Air China возобновила рейсы в Ташкент после пандемии и планирует увеличение частоты:</p>
            <ul>
              <li><b>Ташкент (TAS):</b> 2–3 раза в неделю в Пекин</li>
            </ul>
            <p>Билеты и актуальное расписание ищите на <a href="https://biletbor.me" target="_blank">biletbor.me</a>.</p>
            <h3>Короткий вывод</h3>
            <p>Air China предлагает надёжные соединения между Китаем и Узбекистаном с удобными стыковками на международные рейсы.</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Китай</p>
            <h4>Штаб-квартира:</h4><p>Пекин</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Пекин Столичный (PEK)</p>
            <h4>Вебсайт:</h4><a href="https://www.airchina.com.cn" target="_blank">www.airchina.com.cn</a>`,
        },
      ],
    },
    airmanas: {
      name: "airmanas",
      pageKey: "airmanasInfo",
      imageUrl: "/images/AK/ZM.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air Manas</h1>
            <h2>Дата основания и история</h2>
            <p>Air Manas — киргизская авиакомпания, начавшая свою деятельность в 2006 году. С момента основания компания развивала сеть внутриреспубликанских и международных рейсов, стремясь предлагать aviabilet дешевые и гибкие условия перелётов.</p>
            <h3>Флот Air China</h3>
            <p>Флот Air Manas обычно включает несколько самолётов Boeing 737 различных модификаций. Эти воздушные суда хорошо подходят для кратко- и среднемагистральных маршрутов, обеспечивая пассажирам доступные aviabilet narxlari и комфортное путешествие.</p>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Air Manas периодически открывает и обновляет рейсы из Узбекистана, особенно из:</p>
            <ul>
              <li>
                <b>Ташкента (TAS):</b> до Бишкека и в обратном направлении (график зависит от сезона и спроса)..
              </li>
              <li>
                <b>Другие города: </b>могут предлагаться сезонно или в формате чартерных программ.
              </li>
            </ul>
            <h3>Короткий вывод</h3>
            <p>Air Manas — динамично развивающаяся киргизская авиакомпания, которая может стать удобным вариантом для перелётов между Узбекистаном и Кыргызстаном, а также для стыковок в другие города. Сравнивайте aviabilet narxlari на <a href="https://biletbor.me">biletbor.me</a> и выбирайте наиболее подходящий рейс.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна: </h4>
            <p>Кыргызстан</p> 
            <h4>Штаб-квартира: </h4> 
            <p>Бишкек</p> 
            <h4>Основной хаб: </h4>   
            <p>Международный аэропорт Манас (FRU)
               Air Manas выполняет рейсы в страны СНГ и ближайшие регионы, что даёт возможность сравнивать aviabilet moskva или aviabilet sankt peterburg при планировании дальних перелётов.
            </p>
            <h4>Вебсайт:</h4>
            <a href="https://www.airmanas.com" target="_blank" rel="noreferrer">www.airmanas.com</a>
          `,
        },
      ],
    },
    asianaAirlines: {
      name: "asianaAirlines",
      pageKey: "asianaAirlinesInfo",
      imageUrl: "/images/AK/OZ.png",
      generalInfo: [
        {
          content: `<article>
        <h1>Asiana Airlines</h1>
        <h2>Дата основания и история</h2>
        <p>Asiana Airlines — крупная авиакомпания Республики Корея, основанная в 1988 году. За время своей работы компания получила широкое признание за высокий уровень сервиса и безопасности, предлагая aviabilet дешевые и премиальные классы на разнообразные направления, включая рейсы в Узбекистан.</p>
        <h3>Флот Asiana Airlines</h3>
        <p>В парк Asiana Airlines входят современные самолёты Airbus (A320, A350) и Boeing (B747, B777). Подобное разнообразие позволяет обслуживать как короткие региональные маршруты, так и дальнемагистральные рейсы. При выборе aviabilet narxlari можно найти билеты в эконом-, бизнес- или первом классе.</p>
        <h3>Расписание рейсов из Узбекистана</h3>
        <p>Asiana Airlines периодически предлагает прямые или стыковочные рейсы из:</p>
        <ul>
          <li>
            <b>Ташкента (TAS):</b> с пересадкой в Сеуле (в разное время года, в зависимости от сезона).
          </li>
          <li>
            <b>Другие города:</b> возможны чартерные или сезонные рейсы при повышенном туристическом спросе.
          </li>
        </ul>
        <h3>Короткий вывод</h3>
        <p>Asiana Airlines — подходящий выбор для тех, кто ценит комфорт и безопасность. Если вы планируете полёт из Узбекистана в Сеул или далее, сравните aviabilet narxlari и выбирайте удобный класс обслуживания. Подробности и акции ищите на <a href="https://biletbor.me">biletbor.me</a>.</p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Республика Корея</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Сеул</p> 
        <h4>Основной хаб:</h4>   
        <p>Международный аэропорт Инчхон (ICN). Asiana Airlines также имеет важные маршруты из аэропорта Гимпо и других корейских городов, что позволяет пассажирам выбрать удобные aviabilet moskva или aviabilet sankt peterburg при планировании дальних перелётов.</p>
        <h4>Вебсайт:</h4>
        <a href="https://www.flyasiana.com" target="_blank" rel="noreferrer">www.flyasiana.com</a>
      `,
        },
      ],
    },
    aviaTraffic: {
      name: "aviaTraffic",
      pageKey: "aviaTrafficInfo",
      imageUrl: "/images/AK/AT.png",
      generalInfo: [
        {
          content: `<article>
        <h1>Avia Traffic</h1>
        <h2>Дата основания и история</h2>
        <p>Avia Traffic Company — киргизская авиакомпания, ведущая свою деятельность с 2003 года. Она постепенно расширяла маршрутную сеть, предлагая aviabilet дешевые и различные сервисные опции, ориентируясь на удобство и безопасность пассажиров.</p>
        <h3>Флот Avia Traffic</h3>
        <p>В распоряжении Avia Traffic Company обычно несколько самолётов Boeing 737 и Airbus A320:</p>
        <table>
          <thead>
            <tr>
              <th>Самолёт</th>
              <th>Особенности</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Boeing 737</td>
              <td>Идеален для коротко- и среднемагистральных маршрутов</td>
            </tr>
            <tr>
              <td>Airbus A320</td>
              <td>Удобный салон, варианты эконом и бизнес-класса</td>
            </tr>
          </tbody>
        </table>
        <h3>Расписание рейсов из Узбекистана</h3>
        <p>Avia Traffic Company предлагает рейсы из:</p>
        <ul>
          <li>
            <b>Ташкента (TAS):</b> В Бишкек (и обратно), частота зависит от сезона.
          </li>
          <li>
            <b>Другие города Узбекистана:</b> Возможны чартеры или дополнительные рейсы в пиковые периоды.
          </li>
        </ul>
        <h3>Короткий вывод</h3>
        <p>Avia Traffic Company — удобный вариант для перелётов между Кыргызстаном и Узбекистаном. Если вы ищете доступные aviabilet narxlari и приемлемые условия полёта, обязательно обратите внимание на рейсы этой авиакомпании, проверив доступные варианты на <a href="https://biletbor.me">biletbor.me</a>.</p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Республика Корея</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Сеул</p> 
        <h4>Основной хаб:</h4>   
        <p>Международный аэропорт Инчхон (ICN). Asiana Airlines также имеет важные маршруты из аэропорта Гимпо и других корейских городов, что позволяет пассажирам выбрать удобные aviabilet moskva или aviabilet sankt peterburg при планировании дальних перелётов.</p>
        <h4>Вебсайт:</h4>
        <a href="https://www.aero.kg/" target="_blank" rel="noreferrer">www.aviatraffic.com</a>
      `,
        },
      ],
    },
    azal: {
      name: "azal",
      pageKey: "azalInfo",
      imageUrl: "/images/AK/J2.png",
      generalInfo: [
        {
          content: `<article>
        <h1>Azal</h1>
        <h2>Дата основания и история</h2>
        <p>AZAL (Azerbaijan Airlines) — национальный авиаперевозчик Азербайджана, основанный в 1992 году на базе государственной авиационной структуры. С тех пор авиакомпания активно развивается, предлагая пассажирам aviabilet дешевые и премиальные тарифы на разных направлениях.</p>
        <h3>Флот Azal</h3>
        <p>Во флоте AZAL в основном самолёты семейства Airbus (A319, A320, A321) и Boeing (757, 767, 787). Такой состав позволяет обслуживать как ближнемагистральные, так и дальние направления, обеспечивая пассажирам комфорт и разнообразие aviabilet narxlari.</p>
        <h3>Расписание рейсов из Узбекистана</h3>
        <p>AZAL периодически выполняет прямые и стыковочные рейсы:</p>
        <ul>
          <li>
            <b>Ташкента (TAS):</b> рейсы в Баку (частота и дни вылета зависят от сезона).
          </li>
          <li>
            <b>Другие города Узбекистана:</b> могут быть чартерные или сезонные рейсы по мере увеличения спроса.
          </li>
        </ul>
        <h3>Короткий вывод</h3>
        <p>AZAL (Azerbaijan Airlines) — удобный выбор для перелётов между Узбекистаном и Азербайджаном, а также для дальних рейсов с пересадкой в Баку. Сравните aviabilet narxlari и найдите подходящие варианты на <a href="https://biletbor.me">biletbor.me</a>.</p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Азербайджан</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Азербайджан</p> 
        <h4>Основной хаб:</h4>   
        <p>Международный аэропорт Гейдар Алиев (GYD)
           AZAL выполняет рейсы во многие города Европы, Азии и СНГ, что позволяет сравнивать aviabilet moskva или aviabilet sankt peterburg, а также планировать стыковки при полётах из Узбекистана.</p>
        <h4>Вебсайт:</h4>
        <a href="https://www.azal.az/" target="_blank" rel="noreferrer">www.azal.az</a>
      `,
        },
      ],
    },
    azimuth: {
      name: "azimuth",
      pageKey: "azimuthInfo",
      imageUrl: "/images/AK/A4.png",
      generalInfo: [
        {
          content: `<article>
        <h1>Azimuth</h1>
        <h2>Дата основания и история</h2>
        <p>Azimuth — российская авиакомпания, основанная в 1993 году. С момента своего основания компания специализируется на региональных перевозках, предоставляя пассажирам aviabilet дешевые и удобные условия для путешествий по России и соседним странам.</p>
        <h3>Флот Azal</h3>
        <p>Флот Azimuth состоит из современных самолётов Embraer ERJ-145 и ATR 72. Эти воздушные суда идеально подходят для коротко- и среднемагистральных маршрутов, обеспечивая пассажирам комфорт и безопасность. При выборе aviabilet narxlari можно найти как эконом, так и бизнес-классы.</p>
        <table>
          <thead>
            <tr>
              <th>Самолёт</th>
              <th>Особенности</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Embraer ERJ-145</td>
              <td>Идеален для региональных и средне-магистральных маршрутов</td>
            </tr>
            <tr>
              <td>ATR 72</td>
              <td>Экономичные самолёты для коротких рейсов</td>
            </tr>
          </tbody>
        </table>
        <h3>Расписание рейсов из Узбекистана</h3>
        <p>Azimuth предлагает рейсы из следующих городов Узбекистана:</p>
        <ul>
          <li>
            <b>Ташкента (TAS):</b> рейсы в Москву с пересадкой в Домодедово (частота зависит от сезона).
          </li>
          <li>
            <b>Самарканд (SKD):</b> сезонные рейсы в Москву и другие направления.
          </li>
        </ul>
        <h3>Короткий вывод</h3>
        <p>Azimuth — надёжная российская авиакомпания, предоставляющая доступные aviabilet narxlari и комфортные условия для пассажиров. Если вы планируете путешествие из Узбекистана в Россию или другие страны СНГ, сравните предложения Azimuth на <a href="https://biletbor.me">biletbor.me</a> и выберите наиболее подходящий рейс.</p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Россия</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Москва</p> 
        <h4>Основной хаб:</h4>   
        <p>Аэропорт Домодедово (DME)
           Azimuth выполняет рейсы в различные регионы России, а также в страны СНГ. Это позволяет пассажирам выбирать aviabilet moskva, aviabilet sankt peterburg и другие направления с удобными пересадками.</p>
        <h4>Вебсайт:</h4>
        <a href="https://azimuth.ru" target="_blank" rel="noreferrer">www.azimuth.ru</a>
      `,
        },
      ],
    },
    azurair: {
      name: "azurair",
      pageKey: "azurairInfo",
      imageUrl: "/images/AK/ZF.png",
      generalInfo: [
        {
          content: `<article>
        <h1>Azur Air</h1>
        <h2>Дата основания и история</h2>
        <p>Azur Air — российская авиакомпания, основанная в 2006 году. С момента своего основания компания специализировалась на чартерных рейсах, обслуживая туристические направления. В последние годы Azur Air расширила свой маршрутный график, предлагая регулярные рейсы и новые направления, что позволяет пассажирам воспользоваться aviabilet дешевые и удобными условиями полёта.</p>
        <h3>Флот Azal</h3>
        <p>Флот Azur Air включает современные самолёты Airbus A320 и Boeing 737. Эти воздушные суда обеспечивают комфорт и безопасность пассажиров на коротко- и среднемагистральных маршрутах. Разнообразие флота позволяет Azur Air предлагать различные aviabilet narxlari в зависимости от класса обслуживания (эконом, бизнес).</p>
        <table>
          <thead>
            <tr>
              <th>Самолёт</th>
              <th>Особенности</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Airbus A320</td>
              <td>Комфортные условия для эконом и бизнес-класса</td>
            </tr>
            <tr>
              <td>Boeing 737</td>
              <td>Надёжность и безопасность для коротко- и среднемагистральных маршрутов</td>
            </tr>
          </tbody>
        </table>
        <h3>Расписание рейсов из Узбекистана</h3>
        <p>Azur Air предлагает рейсы из следующих городов Узбекистана:</p>
        <ul>
          <li>
            <b>Ташкента (TAS):</b> рейсы в Москву с пересадкой в Домодедово (частота зависит от сезона).
          </li>
          <li>
            <b>Самарканд (SKD):</b> сезонные рейсы в Москву и другие направления.
          </li>
        </ul>
        <p>Для актуального расписания и aviabilet narxlari рекомендуем посетить <a href="https://biletbor.me">biletbor.me</a> или официальный сайт авиакомпании.</p>
        <h3>Короткий вывод</h3>
        <p>Azur Air — надёжная российская авиакомпания, предоставляющая доступные aviabilet narxlari и комфортные условия для пассажиров. Если вы планируете путешествие из Узбекистана в Россию или другие страны СНГ, сравните предложения Azur Air на <a href="https://biletbor.me">biletbor.me</a> и выберите наиболее подходящий рейс.</p>
      </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Страна:</h4>
        <p>Россия</p> 
        <h4>Штаб-квартира:</h4> 
        <p>Москва</p> 
        <h4>Основной хаб:</h4>   
        <p>Аэропорт Домодедово (DME)
           Azur Air выполняет рейсы из Москвы в различные туристические направления по всему миру, а также осуществляет перелёты из других городов России. Это позволяет пассажирам выбирать aviabilet moskva, aviabilet sankt peterburg и другие маршруты с удобными пересадками.</p>
        <h4>Вебсайт:</h4>
        <a href="https://azur-airlines.com/" target="_blank" rel="noreferrer">www.azur-airlines.com</a>
      `,
        },
      ],
    },
    spicejet: {
      pageKey: "spicejetInfo",
      imageUrl: "/images/AK/SG.png",
      generalInfo: [
        {
          content: `<article>
          <h1>SpiceJet: Доступные авиаперелеты в Индию и за её пределы</h1>
          <p><a href="https://biletbor.me/airlines/spicejet" target="_blank" rel="noopener noreferrer">https://biletbor.me/airlines/spicejet</a></p>
  
          <h2>Дата основания и история</h2>
          <p>SpiceJet – одна из крупнейших бюджетных авиакомпаний Индии, основанная в 2005 году. Авиакомпания предлагает доступные тарифы на внутренние и международные рейсы, ориентируясь на широкий круг пассажиров.</p>
          <h2>Флот SpiceJet</h2>
          <table>
            <thead>
              <tr>
                <th>Самолет</th>
                <th>Количество</th>
                <th>Основное назначение</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Boeing 737</td>
                <td>~50</td>
                <td>Международные и внутренние рейсы</td>
              </tr>
              <tr>
                <td>Bombardier Q400</td>
                <td>~30</td>
                <td>Короткие региональные маршруты</td>
              </tr>
            </tbody>
          </table>
  
          <h2>Расписание рейсов из Узбекистана</h2>
          <ul>
            <li><b>Ташкент – Дели (DEL):</b> 3 раза в неделю</li>
          </ul>
          <p>Подробное расписание и цены можно посмотреть на <a href="https://biletbor.me" target="_blank" rel="noopener noreferrer">biletbor.me</a>.</p>
  
          <h2>Вывод</h2>
          <p>SpiceJet – это удобный и экономичный вариант для путешествий по Индии и за её пределы. Забронируйте билет на <a href="https://biletbor.me" target="_blank" rel="noopener noreferrer">biletbor.me</a> прямо сейчас.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
          <h4>Страна:</h4>
          <p>Индия</p>
          <h4>Штаб-квартира:</h4>
          <p>Гургаон, штат Харьяна</p>
          <h4>Главные хабы:</h4>
          <p>Международный аэропорт Дели (DEL), Международный аэропорт Хайдерабада (HYD)</p>
          <h4>Веб-сайт:</h4>
          <a href="https://www.spicejet.com" target="_blank" rel="noopener noreferrer">www.spicejet.com</a>
        `,
        },
      ],
    },
    iraero: {
      pageKey: "iraeroInfo",
      imageUrl: "/images/AK/IO.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>IrAero – региональные и международные рейсы из Сибири</h1>
            <h2>Дата основания и история</h2>
            <p>Авиакомпания IrAero была основана в 1999 году в Иркутске. Она обслуживает города Сибири и Дальнего Востока, а также выполняет чартерные рейсы в Узбекистан и другие страны.</p>
            <h3>Флот авиакомпании IrAero</h3>
            <p>IrAero использует как российские, так и зарубежные самолёты: Sukhoi Superjet 100 и Bombardier CRJ-200.</p>
            <table>
              <thead>
                <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
              </thead>
              <tbody>
                <tr><td>Sukhoi Superjet 100</td><td>~10</td><td>Короткие и средние маршруты</td></tr>
                <tr><td>CRJ-200</td><td>~6</td><td>Региональные рейсы</td></tr>
              </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>IrAero выполняет сезонные чартерные рейсы в летний период:</p>
            <ul>
              <li><b>Ташкент (TAS):</b> 1–2 раза в неделю</li>
              <li><b>Самарканд (SKD):</b> в высокий сезон</li>
            </ul>
            <p>Билеты и расписание доступны на <a href="https://biletbor.me" target="_blank">biletbor.me</a>.</p>
            <h3>Короткий вывод</h3>
            <p>IrAero – надёжный российский перевозчик с маршрутами в Сибирь и Дальний Восток, а также сезонными рейсами из Узбекистана.</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Россия</p>
            <h4>Штаб-квартира:</h4><p>Иркутск</p>
            <h4>Основной хаб:</h4><p>Аэропорт Иркутск (IKT)</p>
            <h4>Вебсайт:</h4><a href="https://iraero.ru" target="_blank">www.iraero.ru</a>`,
        },
      ],
    },
    auroraAirlines: {
      pageKey: "auroraAirlinesInfo",
      imageUrl: "/images/AK/HZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Aurora Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>Aurora Airlines — российская региональная авиакомпания, основанная в 2013 году и начавшая полёты 8 декабря 2013 года. Создана путём слияния SAT Airlines и Vladivostok Avia по инициативе Правительства Сахалинской области и Аэрофлота.</p>
            <h3>Флот Aurora Airlines</h3>
            <p>По состоянию на 2024 год в парке Авроры:</p>
            <table>
                <thead>
                    <tr>
                        <th>Тип самолёта</th>
                        <th>Количество (примерно)</th>
                        <th>Особенности</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A319-100</td>
                        <td>8</td>
                        <td>Среднемагистральные лайнеры, до 128 пассажиров</td>
                    </tr>
                    <tr>
                        <td>Bombardier Dash 8 Q400</td>
                        <td>5</td>
                        <td>Турбовинтовой, оптимален для коротких взлётов и посадок</td>
                    </tr>
                    <tr>
                        <td>De Havilland Canada DHC-6 Twin Otter</td>
                        <td>3</td>
                        <td>Турбовинтовой, штурвальные маршруты к труднодоступным аэродромам</td>
                    </tr>
                </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Прямых рейсов Aurora Airlines из Узбекистана не выполняется. Для перелётов в Дальний Восток и Сибирь можно стыковаться через Москву или Владивосток.</p>
            <h3>Короткий вывод</h3>
            <p>Aurora Airlines обеспечивает надёжные региональные перевозки по Дальнему Востоку и Сибири России на современном флоте, но прямых международных рейсов из Узбекистана нет.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4>
            <p>Россия</p>
            <h4>Штаб-квартира:</h4>
            <p>Южно-Сахалинск</p>
            <h4>Основные хабы:</h4>
            <p>Международные аэропорты Владивосток (VVO), Южно-Сахалинск (UUS)</p>
            <h4>Вебсайт:</h4>
            <a href="https://www.flyaurora.ru" target="_blank" rel="noreferrer">flyaurora.ru</a>`,
        },
      ],
    },
    yamalAirlines: {
      pageKey: "yamalAirlinesInfo",
      imageUrl: "/images/AK/YC.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Yamal Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>Yamal Airlines (ОАО «Авиационная транспортная компания “Ямал”») — российская авиакомпания, основана в 1997 году. Штаб-квартира находится в Салехарде, Ямало-Ненецкий автономный округ. Выполняет региональные и международные пассажирские рейсы.</p>
            <h3>Флот Yamal Airlines</h3>
            <p>По состоянию на октябрь 2020 года флот включает следующие типы самолётов:</p>
            <table>
                <thead>
                    <tr>
                        <th>Тип самолёта</th>
                        <th>Количество (примерно)</th>
                        <th>Особенности</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A320</td>
                        <td>8</td>
                        <td>Среднемагистральные лайнеры</td>
                    </tr>
                    <tr>
                        <td>Airbus A321</td>
                        <td>3</td>
                        <td>Среднемагистральные лайнеры</td>
                    </tr>
                    <tr>
                        <td>Sukhoi Superjet 100</td>
                        <td>15</td>
                        <td>Региональные и среднемагистральные маршруты</td>
                    </tr>
                    <tr>
                        <td>Bombardier CRJ200</td>
                        <td>9</td>
                        <td>Короткие региональные рейсы</td>
                    </tr>
                    <tr>
                        <td>Bombardier Challenger 850</td>
                        <td>1</td>
                        <td>VIP-перевозки</td>
                    </tr>
                </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Прямых рейсов Yamal Airlines из Узбекистана не выполняется.</p>
            <h3>Короткий вывод</h3>
            <p>Yamal Airlines — ведущая региональная авиакомпания Ямало-Ненецкого округа, соединяющая его с ключевыми городами России, однако прямых рейсов из Узбекистана нет.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
      <h4>Страна:</h4>
      <p>Россия</p>
      <h4>Штаб-квартира:</h4>
      <p>Салехард</p>
      <h4>Основной хаб:</h4>
      <p>Международный аэропорт Тюмень–Рощино (TJM)</p>
      <h4>Вебсайт:</h4>
      <a href="https://yamal.aero" target="_blank" rel="noreferrer">www.yamal.aero</a>`,
        },
      ],
    },
    yakutiaAirlines: {
      pageKey: "yakutiaAirlinesInfo",
      imageUrl: "/images/AK/R3.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Якутия Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>АО «Авиакомпания “Якутия”» было образовано в 2002 году в результате объединения Sakha Avia и Yakut Airlines. Сейчас принадлежит Республике Саха (Якутия). </p>
            <h3>Флот Yakutia Airlines</h3>
            <p>По состоянию на февраль 2025 года парк включает:</p>
            <table>
                <thead>
                    <tr>
                        <th>Тип самолёта</th>
                        <th>Количество (примерно)</th>
                        <th>Особенности</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Boeing 737-700</td>
                        <td>2</td>
                        <td>Среднемагистральный лайнер до 126 пассажиров</td>
                    </tr>
                    <tr>
                        <td>Boeing 737-800</td>
                        <td>2</td>
                        <td>Увеличенная дальность полёта</td>
                    </tr>
                    <tr>
                        <td>Sukhoi Superjet 100</td>
                        <td>5</td>
                        <td>Региональные и среднемагистральные маршруты</td>
                    </tr>
                    <tr>
                        <td>Иркут MC-21-300</td>
                        <td>0 (ожидаются поставки)</td>
                        <td>Перспективные дальнемагистральные лайнеры</td>
                    </tr>
                </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Прямых рейсов из Узбекистана нет. Рекомендуются стыковки через Москву (SVO) или Новосибирск (OVB).</p>
            <h3>Короткий вывод</h3>
            <p>Yakutia Airlines — ключевой региональный перевозчик Дальнего Востока и Сибири России с современным флотом, но прямых рейсов из Узбекистана пока нет.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4>
            <p>Россия</p>
            <h4>Штаб-квартира:</h4>
            <p>Якутск</p>
            <h4>Основной хаб:</h4>
            <p>Аэропорт Якутск (YKS)</p>
            <h4>Вебсайт:</h4>
            <a href="https://yakutia.aero" target="_blank" rel="noreferrer">www.yakutia.aero</a>`,
        },
      ],
    },
    rossiyaAirlines: {
      pageKey: "rossiyaAirlinesInfo",
      imageUrl: "/images/AK/FV.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Российские авиалинии</h1>
            <h2>Дата основания и история</h2>
            <p>Российские авиалинии (Rossiya Airlines) были созданы в 1992 году как дочерняя компания Аэрофлота. В 2011–2016 годах полностью вошли в состав группы Аэрофлот, став основным региональным перевозчиком по России и ближнему зарубежью.  [oai_citation:0‡Wikipedia](https://en.wikipedia.org/wiki/Rossiya_Airlines)</p>
            <h3>Флот Rossiya Airlines</h3>
            <p>По состоянию на сентябрь 2024 года парк включает:</p>
            <table>
                <thead>
                    <tr>
                        <th>Тип самолёта</th>
                        <th>Количество (примерно)</th>
                        <th>Особенности</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A319-100</td>
                        <td>18</td>
                        <td>Коротко- и среднемагистральные маршруты</td>
                    </tr>
                    <tr>
                        <td>Airbus A320-200</td>
                        <td>8</td>
                        <td>Среднемагистральные рейсы с повышенной вместимостью</td>
                    </tr>
                    <tr>
                        <td>Boeing 737-800</td>
                        <td>12</td>
                        <td>Самый массовый узкофюзеляжный самолёт</td>
                    </tr>
                    <tr>
                        <td>Sukhoi Superjet 100-95B/LR</td>
                        <td>78</td>
                        <td>Региональные маршруты, крупнейший оператор в мире</td>
                    </tr>
                </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Прямых рейсов Rossiya Airlines из Узбекистана нет. Для перелётов в Россию рекомендуется стыковаться через Москву (VKO) или Санкт-Петербург (LED).</p>
            <h3>Короткий вывод</h3>
            <p>Rossiya Airlines — ключевой региональный перевозчик группы Аэрофлот с современным флотом, но прямые рейсы из Узбекистана отсутствуют.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4>
            <p>Россия</p>
            <h4>Штаб-квартира:</h4>
            <p>Санкт-Петербург</p>
            <h4>Основные хабы:</h4>
            <p>Пулково (LED), Внуково (VKO)</p>
            <h4>Вебсайт:</h4>
            <a href="https://www.rossiya-airlines.com" target="_blank" rel="noreferrer">www.rossiya-airlines.com</a>`,
        },
      ],
    },
    nordwindAir: {
      pageKey: "nordwindAirInfo",
      imageUrl: "/images/AK/N4.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Nordwind Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>ООО «Северный Ветер», работающее под брендом Nordwind Airlines, основано в 2008 году дочерними структурами туроператора Pegas Touristik. Компания быстро выросла в одного из лидеров чартерных перевозок в России.</p>
            <h3>Флот Nordwind Airlines</h3>
            <p>Флот насчитывает 28 воздушных судов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A321-200</td><td>5</td><td>Среднемагистральные рейсы</td></tr>
                    <tr><td>Airbus A330-200/300</td><td>5</td><td>Дальнемагистральные рейсы</td></tr>
                    <tr><td>Boeing 737-800</td><td>11</td><td>Чартерные направления</td></tr>
                    <tr><td>Boeing 777-200/300</td><td>4</td><td>Большая вместимость и дальность</td></tr>
                </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Летом доступны чартерные рейсы из Ташкента (TAS) в Анталию и Бодрум — 2–3 раза в неделю.</p>
            <h3>Короткий вывод</h3>
            <p>Nordwind Airlines — российская чартерная авиакомпания с широким выбором направлений для туристов и современным авиапарком.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Россия</p>
            <h4>Штаб-квартира:</h4><p>Москва</p>
            <h4>Основной хаб:</h4><p>Аэропорт Шереметьево (SVO)</p>
            <h4>Вебсайт:</h4><a href="https://nordwindairlines.ru" target="_blank" rel="noreferrer">www.nordwindairlines.ru</a>`,
        },
      ],
    },
    lufthansaAir: {
      pageKey: "lufthansaAirInfo",
      imageUrl: "/images/AK/LH.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Lufthansa</h1>
            <h2>Дата основания и история</h2>
            <p>Lufthansa (Deutsche Lufthansa AG) — крупнейшая авиакомпания Германии и одна из ведущих в Европе. Основана в 1953 году, первый рейс выполнен в 1955 году. Является основателем альянса Star Alliance и признана за высокий уровень сервиса.</p>
            <h3>Флот Lufthansa</h3>
            <p>Флот состоит из более чем 280 самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 Family</td><td>~150</td><td>Внутри-европейские и региональные рейсы</td></tr>
                    <tr><td>Airbus A350-900</td><td>~21</td><td>Дальнемагистральные, экологичные</td></tr>
                    <tr><td>Boeing 747-8</td><td>~19</td><td>Флагман на дальних маршрутах</td></tr>
                </tbody>
            </table>
            <h3>Расписание рейсов из Узбекистана</h3>
            <p>Рейсы Lufthansa выполняются из Ташкента (TAS) во Франкфурт (FRA) 3–4 раза в неделю с удобными стыковками по всей Европе и в США.</p>
            <h3>Короткий вывод</h3>
            <p>Lufthansa — это надёжность, комфорт и широкий выбор международных направлений для путешественников из Узбекистана.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Германия</p>
            <h4>Штаб-квартира:</h4><p>Кёльн</p>
            <h4>Основной хаб:</h4><p>Аэропорт Франкфурт-на-Майне (FRA)</p>
            <h4>Вебсайт:</h4><a href="https://www.lufthansa.com" target="_blank" rel="noreferrer">www.lufthansa.com</a>`,
        },
      ],
    },
    silkAir: {
      pageKey: "silkAirInfo",
      imageUrl: "/images/AK/MI.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SilkAir</h1>
            <h2>Дата основания и история</h2>
            <p>SilkAir была основана в 1976 году как Tradewinds Charters и стала региональной дочерней авиакомпанией Singapore Airlines в 1989 году. До слияния с SIA в 2021 году SilkAir выполняла полёты по 40 направлениям в Азиатско-Тихоокеанском регионе.</p>
            <h3>Флот SilkAir</h3>
            <p>До объединения с Singapore Airlines флот включал:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>17</td><td>Региональные рейсы</td></tr>
                    <tr><td>Boeing 737 MAX 8</td><td>6</td><td>Экономичность и комфорт</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>SilkAir не осуществляет прямые рейсы из Узбекистана, но рейсы через Singapore Airlines доступны с пересадкой в Сингапуре.</p>
            <h3>Короткий вывод</h3>
            <p>SilkAir — это часть истории сингапурской авиации. Сегодня её маршруты и флот полностью интегрированы в Singapore Airlines.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Сингапур</p>
            <h4>Штаб-квартира:</h4><p>Сингапур</p>
            <h4>Основной хаб:</h4><p>Аэропорт Чанги (SIN)</p>
            <h4>Вебсайт:</h4><a href="https://www.singaporeair.com" target="_blank" rel="noreferrer">www.singaporeair.com</a>`,
        },
      ],
    },
    tajikAir: {
      pageKey: "tajikAirInfo",
      imageUrl: "/images/AK/7J.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Tajik Air</h1>
            <h2>Дата основания и история</h2>
            <p>Tajik Air — национальная авиакомпания Таджикистана. Основана в 1924 году и является одной из старейших авиакомпаний Центральной Азии. С 2023 года постепенно восстанавливает регулярные и чартерные рейсы.</p>
            <h3>Флот Tajik Air</h3>
            <p>Флот в процессе обновления, но включал:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-300/500</td><td>2</td><td>Региональные маршруты</td></tr>
                    <tr><td>Ан-26</td><td>1</td><td>Грузовые перевозки</td></tr>
                    <tr><td>Як-40 (ранее)</td><td>-</td><td>Сняты с эксплуатации</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Прямые рейсы в Душанбе из Ташкента выполняются нерегулярно или по заказу. Рекомендуется проверять расписание.</p>
            <h3>Короткий вывод</h3>
            <p>Tajik Air — авиакомпания с богатой историей и возрождающимся авиапарком, обеспечивающая соединение Таджикистана с соседними странами.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Таджикистан</p>
            <h4>Штаб-квартира:</h4><p>Душанбе</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Душанбе (DYU)</p>
            <h4>Вебсайт:</h4><a href="https://tajikair.tj" target="_blank" rel="noreferrer">www.tajikair.tj</a>`,
        },
      ],
    },
    somonAir: {
      pageKey: "somonAirInfo",
      imageUrl: "/images/AK/SZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Somon Air</h1>
            <h2>Дата основания и история</h2>
            <p>Somon Air — частная таджикская авиакомпания, основанная в 2007 году. Она стала первой частной авиакомпанией Таджикистана, начавшей выполнять регулярные международные рейсы. Базируется в Душанбе и выполняет рейсы в страны СНГ, Ближнего Востока и Европы.</p>
            <h3>Флот Somon Air</h3>
            <p>По состоянию на 2024 год, флот состоит из:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>4</td><td>Среднемагистральные маршруты</td></tr>
                    <tr><td>Boeing 737-900ER</td><td>2</td><td>Увеличенная вместимость</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Somon Air выполняет нерегулярные рейсы из Ташкента в Душанбе, а также предлагает удобные транзитные маршруты через Таджикистан.</p>
            <h3>Короткий вывод</h3>
            <p>Somon Air — динамично развивающийся авиаперевозчик, обеспечивающий надежное авиасообщение между Таджикистаном и другими странами региона.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Таджикистан</p>
            <h4>Штаб-квартира:</h4><p>Душанбе</p>
            <h4>Основной хаб:</h4><p>Аэропорт Душанбе (DYU)</p>
            <h4>Вебсайт:</h4><a href="https://www.somonair.com" target="_blank" rel="noreferrer">www.somonair.com</a>`,
        },
      ],
    },
    kamair: {
      pageKey: "kamairInfo",
      imageUrl: "/images/AK/RQ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Kam Air</h1>
            <h2>Дата основания и история</h2>
            <p>Kam Air — первая частная авиакомпания Афганистана, основанная в 2003 году. Штаб-квартира расположена в Кабуле. Kam Air быстро расширила свою маршрутную сеть, включая рейсы по Афганистану, в страны Азии и Ближнего Востока.</p>
            <h3>Флот Kam Air</h3>
            <p>По состоянию на 2024 год флот включает:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A340-300</td><td>2</td><td>Дальнемагистральные рейсы</td></tr>
                    <tr><td>Boeing 737-300</td><td>2</td><td>Региональные направления</td></tr>
                    <tr><td>Boeing 767-300ER</td><td>1</td><td>Международные рейсы</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Kam Air периодически выполняет рейсы из Ташкента в Кабул, особенно в пиковые сезоны или по чартеру.</p>
            <h3>Короткий вывод</h3>
            <p>Kam Air — надёжный афганский перевозчик с международными амбициями и широким спектром направлений, включая Центральную Азию.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Афганистан</p>
            <h4>Штаб-квартира:</h4><p>Кабул</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт имени Хамида Карзая (KBL)</p>
            <h4>Вебсайт:</h4><a href="https://www.kamair.com" target="_blank" rel="noreferrer">www.kamair.com</a>`,
        },
      ],
    },
    ikarAir: {
      pageKey: "ikarAirInfo",
      imageUrl: "/images/AK/IL.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Ikar Air</h1>
            <h2>Дата основания и история</h2>
            <p>Ikar Air — молодая частная авиакомпания, ориентированная на региональные и чартерные перевозки в Центральной Азии и на Ближнем Востоке. Основана в 2021 году с базой в Стамбуле.</p>
            <h3>Флот Ikar Air</h3>
            <p>На 2024 год флот небольшой, но эффективный:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Embraer E190</td><td>2</td><td>Короткие и средние маршруты</td></tr>
                    <tr><td>Boeing 737-700</td><td>1</td><td>Гибкость маршрутов</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Авиакомпания планирует чартерные рейсы из Ташкента в Анталию и Баку в пиковые сезоны. Регулярные маршруты в стадии разработки.</p>
            <h3>Короткий вывод</h3>
            <p>Ikar Air — перспективный авиаперевозчик, фокусирующийся на доступных и гибких региональных рейсах.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Турция</p>
            <h4>Штаб-квартира:</h4><p>Стамбул</p>
            <h4>Основной хаб:</h4><p>Аэропорт Сабиха Гёкчен (SAW)</p>
            <h4>Вебсайт:</h4><a href="https://www.ilkarair.com" target="_blank" rel="noreferrer">www.ilkarair.com</a>`,
        },
      ],
    },
    flydubaiAir: {
      pageKey: "flydubaiAirInfo",
      imageUrl: "/images/AK/FZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>flydubai</h1>
            <h2>Дата основания и история</h2>
            <p>flydubai — бюджетная авиакомпания Объединённых Арабских Эмиратов, основанная в 2008 году и начавшая полёты в 2009 году. Она является государственной компанией и тесно сотрудничает с Emirates Group. flydubai обслуживает более 100 направлений на Ближнем Востоке, в Азии, Африке и Европе.</p>
            <h3>Флот flydubai</h3>
            <p>По состоянию на 2024 год флот включает:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>30+</td><td>Классические маршруты</td></tr>
                    <tr><td>Boeing 737 MAX 8</td><td>40+</td><td>Экономия топлива, новые кабины</td></tr>
                    <tr><td>Boeing 737 MAX 9</td><td>~10</td><td>Увеличенная дальность</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>flydubai выполняет прямые рейсы из Ташкента в Дубай ежедневно, а также сезонные рейсы из Самарканда и других городов.</p>
            <h3>Короткий вывод</h3>
            <p>flydubai предлагает удобные и доступные перелёты из Узбекистана в ОАЭ и далее — по всему миру благодаря партнёрству с Emirates.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>ОАЭ</p>
            <h4>Штаб-квартира:</h4><p>Дубай</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Дубай (DXB), Терминал 2</p>
            <h4>Вебсайт:</h4><a href="https://www.flydubai.com" target="_blank" rel="noreferrer">www.flydubai.com</a>`,
        },
      ],
    },
    kuwaitAirways: {
      pageKey: "kuwaitAirwaysInfo",
      imageUrl: "/images/AK/KU.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Kuwait Airways</h1>
            <h2>Дата основания и история</h2>
            <p>Kuwait Airways — национальная авиакомпания Государства Кувейт, основанная в 1954 году. Она начала работу как частная компания, но вскоре была национализирована. Сегодня Kuwait Airways предлагает рейсы в более чем 50 стран мира, включая Европу, Азию, Ближний Восток и Северную Африку.</p>
            <h3>Флот Kuwait Airways</h3>
            <p>Авиапарк активно обновляется и включает:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>11</td><td>Кратко- и среднемагистральные маршруты</td></tr>
                    <tr><td>Airbus A330-800neo</td><td>4</td><td>Улучшенный комфорт и дальность</td></tr>
                    <tr><td>Boeing 777-300ER</td><td>10</td><td>Дальнемагистральные рейсы</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Kuwait Airways выполняет регулярные рейсы из Ташкента в Кувейт-Сити, с удобными пересадками в страны Персидского залива, Индию и Европу.</p>
            <h3>Короткий вывод</h3>
            <p>Kuwait Airways — один из старейших и уважаемых авиаперевозчиков Персидского залива, предлагающий качественный сервис и современный флот.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Кувейт</p>
            <h4>Штаб-квартира:</h4><p>Кувейт-Сити</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Кувейта (KWI)</p>
            <h4>Вебсайт:</h4><a href="https://www.kuwaitairways.com" target="_blank" rel="noreferrer">www.kuwaitairways.com</a>`,
        },
      ],
    },
    emiratesAir: {
      pageKey: "emiratesAirInfo",
      imageUrl: "/images/AK/EK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Emirates</h1>
            <h2>Дата основания и история</h2>
            <p>Emirates — крупнейшая авиакомпания Объединённых Арабских Эмиратов, основана в 1985 году. Базируется в Дубае и известна высоким уровнем сервиса, инновациями и одной из самых молодых дальнемагистральных флотилий в мире.</p>
            <h3>Флот Emirates</h3>
            <p>Флот насчитывает более 250 самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A380-800</td><td>100+</td><td>Двухэтажный лайнер, повышенный комфорт</td></tr>
                    <tr><td>Boeing 777-300ER</td><td>130+</td><td>Межконтинентальные рейсы</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Emirates выполняет прямые рейсы из Ташкента в Дубай 5–7 раз в неделю, предлагая удобные пересадки в Европу, США, Азию и Австралию.</p>
            <h3>Короткий вывод</h3>
            <p>Emirates — один из лидеров мировой авиации, предлагающий премиум-сервис и отличные возможности для путешествий из Узбекистана в любую точку мира.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>ОАЭ</p>
            <h4>Штаб-квартира:</h4><p>Дубай</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Дубай (DXB), Терминал 3</p>
            <h4>Вебсайт:</h4><a href="https://www.emirates.com" target="_blank" rel="noreferrer">www.emirates.com</a>`,
        },
      ],
    },
    centrumAir: {
      pageKey: "centrumAirInfo",
      imageUrl: "/images/AK/UT.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Centrum Air</h1>
            <h2>Дата основания и история</h2>
            <p>Centrum Air — новая узбекская авиакомпания, основанная в 2023 году. Базируется в Ташкенте и позиционирует себя как лоукостер с доступными тарифами и современным подходом к авиаперевозкам внутри страны и за её пределами.</p>
            <h3>Флот Centrum Air</h3>
            <p>По состоянию на 2024 год флот формируется и включает:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>2+</td><td>Короткие и средние маршруты</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Centrum Air выполняет рейсы внутри Узбекистана (включая Нукус, Самарканд, Ургенч) и за его пределы: в Россию, Турцию и Казахстан. Билеты доступны онлайн по привлекательным ценам.</p>
            <h3>Короткий вывод</h3>
            <p>Centrum Air — амбициозный узбекский лоукостер, стремящийся сделать авиаперелёты более доступными для широкой аудитории.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Узбекистан</p>
            <h4>Штаб-квартира:</h4><p>Ташкент</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Ташкент (TAS)</p>
            <h4>Вебсайт:</h4><a href="https://centrum.uz" target="_blank" rel="noreferrer">centrum.uz</a>`,
        },
      ],
    },
    egyptAir: {
      pageKey: "egyptAirInfo",
      imageUrl: "/images/AK/MS.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>EgyptAir</h1>
            <h2>Дата основания и история</h2>
            <p>EgyptAir — национальная авиакомпания Египта, основанная в 1932 году. Это одна из старейших действующих авиакомпаний в мире. Базируется в Каире и является участником глобального авиаальянса Star Alliance с 2008 года.</p>
            <h3>Флот EgyptAir</h3>
            <p>Флот компании насчитывает более 65 самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A220-300</td><td>12</td><td>Краткие и средние рейсы, высокая топливная эффективность</td></tr>
                    <tr><td>Airbus A320neo</td><td>8</td><td>Современные европейские маршруты</td></tr>
                    <tr><td>Boeing 787-9 Dreamliner</td><td>6</td><td>Дальнемагистральные рейсы</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>EgyptAir предлагает рейсы из Ташкента в Каир с пересадкой в других городах, а также удобные стыковки в Африку, Европу и Северную Америку.</p>
            <h3>Короткий вывод</h3>
            <p>EgyptAir — авторитетная африканская авиакомпания с глобальной сетью маршрутов и современным флотом.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Египет</p>
            <h4>Штаб-квартира:</h4><p>Каир</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Каира (CAI)</p>
            <h4>Вебсайт:</h4><a href="https://www.egyptair.com" target="_blank" rel="noreferrer">www.egyptair.com</a>`,
        },
      ],
    },
    chinaSouthern: {
      pageKey: "chinaSouthernInfo",
      imageUrl: "/images/AK/CZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>China Southern Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>China Southern Airlines — одна из крупнейших авиакомпаний Азии, основана в 1988 году. Штаб-квартира находится в Гуанчжоу, Китай. Авиакомпания ранее была участником альянса SkyTeam (до 2019 года) и обслуживает более 200 направлений по всему миру.</p>
            <h3>Флот China Southern</h3>
            <p>Один из самых крупных флотов в Азии, включает более 600 самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 family</td><td>250+</td><td>Региональные маршруты</td></tr>
                    <tr><td>Boeing 777-300ER</td><td>14</td><td>Дальнемагистральные рейсы</td></tr>
                    <tr><td>Airbus A350-900</td><td>20+</td><td>Новые технологии, дальность</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>China Southern выполняет рейсы из Ташкента в Гуанчжоу, а также транзитные рейсы через Урумчи в Пекин, Шанхай и другие города Китая.</p>
            <h3>Короткий вывод</h3>
            <p>China Southern — лидер китайской гражданской авиации с глобальной маршрутной сетью и надёжным сервисом для пассажиров из Узбекистана.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Китай</p>
            <h4>Штаб-квартира:</h4><p>Гуанчжоу</p>
            <h4>Основной хаб:</h4><p>Аэропорт Гуанчжоу Байюнь (CAN)</p>
            <h4>Вебсайт:</h4><a href="https://www.csair.com" target="_blank" rel="noreferrer">www.csair.com</a>`,
        },
      ],
    },
    pia: {
      pageKey: "piaInfo",
      imageUrl: "/images/AK/PK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Pakistan International Airlines (PIA)</h1>
            <h2>Дата основания и история</h2>
            <p>Pakistan International Airlines, или PIA, — национальный авиаперевозчик Пакистана, основанный в 1946 году. Является одной из старейших авиакомпаний Азии, начавшей международные рейсы в 1955 году. Штаб-квартира находится в Карачи.</p>
            <h3>Флот PIA</h3>
            <p>На 2024 год флот состоит из более 30 самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>11</td><td>Внутренние и региональные маршруты</td></tr>
                    <tr><td>Boeing 777-200ER / -300ER</td><td>9</td><td>Дальнемагистральные международные рейсы</td></tr>
                    <tr><td>ATR 42/72</td><td>12</td><td>Местные короткие рейсы</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>PIA периодически выполняет чартерные и сезонные рейсы из Ташкента в Исламабад, Лахор или Карачи. Рекомендуется уточнять актуальное расписание.</p>
            <h3>Короткий вывод</h3>
            <p>PIA — государственная авиакомпания Пакистана с богатой историей, соединяющая страны Южной Азии с Центральной Азией, Ближним Востоком и Европой.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Пакистан</p>
            <h4>Штаб-квартира:</h4><p>Карачи</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Джинна (KHI)</p>
            <h4>Вебсайт:</h4><a href="https://www.piac.com.pk" target="_blank" rel="noreferrer">www.piac.com.pk</a>`,
        },
      ],
    },
    airblue: {
      pageKey: "airblueInfo",
      imageUrl: "/images/AK/PA.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Airblue</h1>
            <h2>Дата основания и история</h2>
            <p>Airblue — одна из крупнейших частных авиакомпаний Пакистана, основанная в 2003 году. Базируется в Исламабаде и предлагает внутренние и международные рейсы по доступным ценам, ориентируясь на комфорт и цифровые технологии.</p>
            <h3>Флот Airblue</h3>
            <p>На 2024 год авиапарк состоит из следующих самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>5</td><td>Короткие и средние маршруты</td></tr>
                    <tr><td>Airbus A321</td><td>3</td><td>Увеличенная вместимость</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Airblue планирует расширение на Центральную Азию, включая возможные маршруты Ташкент–Исламабад и Ташкент–Лахор. В настоящее время доступны стыковки через ОАЭ и Саудовскую Аравию.</p>
            <h3>Короткий вывод</h3>
            <p>Airblue — современная и динамичная авиакомпания, предоставляющая конкурентные тарифы и удобные маршруты для пассажиров из Южной и Центральной Азии.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Пакистан</p>
            <h4>Штаб-квартира:</h4><p>Исламабад</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт имени Беназир Бхутто (ISB)</p>
            <h4>Вебсайт:</h4><a href="https://www.airblue.com" target="_blank" rel="noreferrer">www.airblue.com</a>`,
        },
      ],
    },
    sereneAir: {
      pageKey: "sereneAirInfo",
      imageUrl: "/images/AK/ER.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SereneAir</h1>
            <h2>Дата основания и история</h2>
            <p>SereneAir — частная пакистанская авиакомпания, основанная в 2016 году. Она быстро завоевала репутацию за высокий уровень сервиса, пунктуальность и комфорт на внутренних рейсах. Базируется в Исламабаде.</p>
            <h3>Флот SereneAir</h3>
            <p>На 2024 год авиапарк состоит из:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>5</td><td>Среднемагистральные маршруты, комфортный салон</td></tr>
                    <tr><td>Airbus A330-200</td><td>1</td><td>Для международных рейсов, увеличенная дальность</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>На данный момент SereneAir не выполняет прямых рейсов из Ташкента, однако обсуждаются чартерные программы и возможные маршруты в Исламабад или Карачи.</p>
            <h3>Короткий вывод</h3>
            <p>SereneAir — стремительно развивающаяся авиакомпания с фокусом на качество и комфорт, готовая выйти на рынки Центральной Азии.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Пакистан</p>
            <h4>Штаб-квартира:</h4><p>Исламабад</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт имени Беназир Бхутто (ISB)</p>
            <h4>Вебсайт:</h4><a href="https://www.sereneair.com" target="_blank" rel="noreferrer">www.sereneair.com</a>`,
        },
      ],
    },
    airIndia: {
      pageKey: "airIndiaInfo",
      imageUrl: "/images/AK/AI.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air India</h1>
            <h2>Дата основания и история</h2>
            <p>Air India — национальная авиакомпания Индии, основанная в 1932 году как Tata Airlines. В 1946 году получила своё нынешнее название и стала флагманским перевозчиком страны. В 2022 году авиакомпания вернулась в состав Tata Group и начала масштабную модернизацию.</p>
            <h3>Флот Air India</h3>
            <p>По состоянию на 2024 год флот активно обновляется:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 family</td><td>70+</td><td>Внутренние и ближнемагистральные рейсы</td></tr>
                    <tr><td>Boeing 787 Dreamliner</td><td>27</td><td>Дальнемагистральные маршруты</td></tr>
                    <tr><td>Boeing 777</td><td>15</td><td>Флагманские направления в Европу и США</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Air India предлагает рейсы из Ташкента в Дели через партнёрские авиакомпании и хабы. Обсуждается возобновление прямого сообщения.</p>
            <h3>Короткий вывод</h3>
            <p>Air India — крупнейший государственный авиаперевозчик Индии с глобальной маршрутной сетью и растущим флотом современных самолётов.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Индия</p>
            <h4>Штаб-квартира:</h4><p>Нью-Дели</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт имени Индиры Ганди (DEL)</p>
            <h4>Вебсайт:</h4><a href="https://www.airindia.com" target="_blank" rel="noreferrer">www.airindia.com</a>`,
        },
      ],
    },
    vistara: {
      pageKey: "vistaraInfo",
      imageUrl: "/images/AK/UK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Vistara</h1>
            <h2>Дата основания и история</h2>
            <p>Vistara — премиальная индийская авиакомпания, основанная в 2013 году как совместное предприятие Tata Sons и Singapore Airlines. С момента начала полётов в 2015 году Vistara зарекомендовала себя как авиакомпания с высоким уровнем сервиса и современным подходом.</p>
            <h3>Флот Vistara</h3>
            <p>На 2024 год авиапарк насчитывает более 60 самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>45+</td><td>Внутренние и региональные рейсы</td></tr>
                    <tr><td>Boeing 787-9 Dreamliner</td><td>6</td><td>Дальнемагистральные маршруты с премиум-комфортом</td></tr>
                    <tr><td>Airbus A321neo</td><td>4</td><td>Среднемагистральные рейсы, увеличенная дальность</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Прямых рейсов из Ташкента пока нет, однако Vistara предлагает удобные стыковки через Дели в Европу, Азию и страны Персидского залива.</p>
            <h3>Короткий вывод</h3>
            <p>Vistara — премиум-бренд среди индийских авиакомпаний с акцентом на комфорт, точность и инновации.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Индия</p>
            <h4>Штаб-квартира:</h4><p>Гуруграм, Харьяна</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт имени Индиры Ганди (DEL), Дели</p>
            <h4>Вебсайт:</h4><a href="https://www.airvistara.com" target="_blank" rel="noreferrer">www.airvistara.com</a>`,
        },
      ],
    },
    gulfAir: {
      pageKey: "gulfAirInfo",
      imageUrl: "/images/AK/GF.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Gulf Air</h1>
            <h2>Дата основания и история</h2>
            <p>Gulf Air — национальная авиакомпания Королевства Бахрейн, основанная в 1950 году. Это одна из старейших авиакомпаний Ближнего Востока, играющая ключевую роль в авиационном сообщении между Персидским заливом, Азией, Европой и Африкой.</p>
            <h3>Флот Gulf Air</h3>
            <p>На 2024 год авиапарк состоит из более чем 35 современных самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>10+</td><td>Короткие и средние маршруты, экономия топлива</td></tr>
                    <tr><td>Airbus A321neo</td><td>8+</td><td>Увеличенная дальность и вместимость</td></tr>
                    <tr><td>Boeing 787-9 Dreamliner</td><td>7+</td><td>Межконтинентальные маршруты, премиум-салон</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Gulf Air нацелена на расширение присутствия в Центральной Азии. Ведутся переговоры о запуске рейсов Ташкент–Манама. На данный момент доступны удобные стыковки через Дубай и Дели.</p>
            <h3>Короткий вывод</h3>
            <p>Gulf Air — надёжный перевозчик из Бахрейна, предлагающий современный сервис и качественные стыковки по всему миру.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Бахрейн</p>
            <h4>Штаб-квартира:</h4><p>Манама</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Бахрейна (BAH)</p>
            <h4>Вебсайт:</h4><a href="https://www.gulfair.com" target="_blank" rel="noreferrer">www.gulfair.com</a>`,
        },
      ],
    },
    omanAir: {
      pageKey: "omanAirInfo",
      imageUrl: "/images/AK/WY.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Oman Air</h1>
            <h2>Дата основания и история</h2>
            <p>Oman Air — национальная авиакомпания Султаната Оман, основана в 1993 году. С тех пор она выросла в уважаемого международного перевозчика, известного качественным обслуживанием, пунктуальностью и высоким уровнем комфорта.</p>
            <h3>Флот Oman Air</h3>
            <p>Флот на 2024 год состоит из более чем 40 современных самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800 / MAX</td><td>25+</td><td>Региональные и ближнемагистральные маршруты</td></tr>
                    <tr><td>Boeing 787-8 / -9 Dreamliner</td><td>10+</td><td>Межконтинентальные рейсы, премиальный салон</td></tr>
                    <tr><td>Airbus A330 (в выведении из эксплуатации)</td><td>оставшиеся единицы</td><td>Ранее использовались на дальних направлениях</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>На 2024 год Oman Air не выполняет прямых рейсов из Ташкента, однако предлагает удобные стыковки через Дубай и Доху в Маскат с дальнейшими направлениями в Европу, Индию и Юго-Восточную Азию.</p>
            <h3>Короткий вывод</h3>
            <p>Oman Air — это сочетание арабского гостеприимства, надёжности и высокого уровня сервиса. Отличный вариант для путешествий с пересадкой из Узбекистана.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Оман</p>
            <h4>Штаб-квартира:</h4><p>Маскат</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Маскат (MCT)</p>
            <h4>Вебсайт:</h4><a href="https://www.omanair.com" target="_blank" rel="noreferrer">www.omanair.com</a>`,
        },
      ],
    },
    salamAir: {
      pageKey: "salamAirInfo",
      imageUrl: "/images/AK/OV.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SalamAir</h1>
            <h2>Дата основания и история</h2>
            <p>SalamAir — первая бюджетная авиакомпания Султаната Оман, основана в 2016 году. С момента своего основания она стремительно развивается и обслуживает как внутренние, так и международные маршруты, делая акцент на доступность и эффективность.</p>
            <h3>Флот SalamAir</h3>
            <p>На 2024 год флот SalamAir состоит из следующих самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>6+</td><td>Экономичные самолёты для ближних и средних маршрутов</td></tr>
                    <tr><td>Airbus A321neo</td><td>4+</td><td>Повышенная вместимость и дальность</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>SalamAir выполняет сезонные и чартерные рейсы из Ташкента и Самарканда в Маскат. Также доступны удобные пересадки в Дубай, Карачи и Коломбо.</p>
            <h3>Короткий вывод</h3>
            <p>SalamAir — надёжный лоукостер Омана с фокусом на качество и доступность, включая рейсы в Центральную Азию.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Оман</p>
            <h4>Штаб-квартира:</h4><p>Маскат</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Маскат (MCT)</p>
            <h4>Вебсайт:</h4><a href="https://www.salamair.com" target="_blank" rel="noreferrer">www.salamair.com</a>`,
        },
      ],
    },
    iranAsemanAirlines: {
      pageKey: "iranAsemanAirlinesInfo",
      imageUrl: "/images/AK/EP.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Iran Aseman Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>Iran Aseman Airlines — одна из ведущих иранских авиакомпаний, основанная в 1980 году. Она специализируется на внутренних и региональных рейсах, особенно в труднодоступные районы Ирана. Базируется в Тегеране и управляется под контролем правительства.</p>
            <h3>Флот Iran Aseman Airlines</h3>
            <p>Флот компании состоит преимущественно из региональных и среднемагистральных самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>ATR 72-500</td><td>5+</td><td>Короткие внутренние маршруты</td></tr>
                    <tr><td>Fokker 100</td><td>15+</td><td>Региональные направления</td></tr>
                    <tr><td>Airbus A320 (в эксплуатации частично)</td><td>несколько</td><td>Международные направления</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>На данный момент Iran Aseman не выполняет регулярных рейсов из Узбекистана, однако возможно сотрудничество по чартерным и стыковочным маршрутам через Тегеран и Мешхед.</p>
            <h3>Короткий вывод</h3>
            <p>Iran Aseman Airlines — надёжный региональный перевозчик с акцентом на внутренние авиалинии и социальную значимость.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Иран</p>
            <h4>Штаб-квартира:</h4><p>Тегеран</p>
            <h4>Основной хаб:</h4><p>Аэропорт Мехрабад (THR)</p>
            <h4>Вебсайт:</h4><a href="http://www.iaa.ir" target="_blank" rel="noreferrer">www.iaa.ir</a>`,
        },
      ],
    },
    kishAir: {
      pageKey: "kishAirInfo",
      imageUrl: "/images/AK/Y9.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Kish Air</h1>
            <h2>Дата основания и история</h2>
            <p>Kish Air — региональная иранская авиакомпания, основанная в 1989 году. Первоначально предназначалась для обслуживания туристического острова Киш, но со временем расширила свои маршруты на весь Иран и некоторые международные направления.</p>
            <h3>Флот Kish Air</h3>
            <p>Флот состоит в основном из ближне- и среднемагистральных самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>McDonnell Douglas MD-82 / MD-83</td><td>10+</td><td>Обслуживание внутренних рейсов</td></tr>
                    <tr><td>Fokker 100</td><td>5+</td><td>Региональные маршруты</td></tr>
                    <tr><td>Airbus A321</td><td>несколько</td><td>Международные направления</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>На 2024 год Kish Air не выполняет прямых рейсов из Узбекистана, но может быть использована для внутренних перелётов в Иране после прилёта в Тегеран или Мешхед другими авиакомпаниями.</p>
            <h3>Короткий вывод</h3>
            <p>Kish Air — надёжная авиакомпания для внутренних путешествий по Ирану и некоторых зарубежных маршрутов, особенно с курортным уклоном.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Иран</p>
            <h4>Штаб-квартира:</h4><p>Тегеран / Киш</p>
            <h4>Основной хаб:</h4><p>Аэропорт Киш (KIH), также Мехрабад (THR)</p>
            <h4>Вебсайт:</h4><a href="http://www.kishairlines.ir" target="_blank" rel="noreferrer">www.kishairlines.ir</a>`,
        },
      ],
    },
    qeshmAir: {
      pageKey: "qeshmAirInfo",
      imageUrl: "/images/AK/QF.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Qeshm Air</h1>
            <h2>Дата основания и история</h2>
            <p>Qeshm Air — иранская авиакомпания, основанная в 1993 году. Первоначально предназначалась для обслуживания острова Кешм и южных регионов страны, но со временем расширила свою маршрутную сеть на весь Иран и несколько международных направлений.</p>
            <h3>Флот Qeshm Air</h3>
            <p>Флот состоит преимущественно из среднемагистральных самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A300-600</td><td>2+</td><td>Международные маршруты, большая вместимость</td></tr>
                    <tr><td>Fokker 100</td><td>7+</td><td>Региональные и внутренние рейсы</td></tr>
                    <tr><td>RJ-85</td><td>несколько</td><td>Малые аэропорты, внутренняя сеть</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>На 2024 год прямых рейсов Qeshm Air из Узбекистана нет, но возможны стыковки через Тегеран или Мешхед. Компания активно развивает чартерные и сезонные маршруты.</p>
            <h3>Короткий вывод</h3>
            <p>Qeshm Air — стабильная региональная авиакомпания Ирана с надёжным флотом и удобными внутренними и региональными рейсами.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Иран</p>
            <h4>Штаб-квартира:</h4><p>Тегеран</p>
            <h4>Основной хаб:</h4><p>Аэропорт Мехрабад (THR), аэропорт Кешм (GSM)</p>
            <h4>Вебсайт:</h4><a href="http://www.qeshm-air.com" target="_blank" rel="noreferrer">www.qeshm-air.com</a>`,
        },
      ],
    },
    syrianAir: {
      pageKey: "syrianAirInfo",
      imageUrl: "/images/AK/SY.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SyrianAir</h1>
            <h2>Дата основания и история</h2>
            <p>SyrianAir, официально Syrian Arab Airlines, — национальная авиакомпания Сирии, основанная в 1946 году. Несмотря на сложную политическую ситуацию в регионе, компания продолжает обслуживать внутренние и международные маршруты, включая страны Ближнего Востока, Северной Африки и Европы.</p>
            <h3>Флот SyrianAir</h3>
            <p>Флот компании скромен и включает в себя:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>2</td><td>Основные международные направления</td></tr>
                    <tr><td>Tupolev Tu-134 / Yak-40 (в ограниченном использовании)</td><td>несколько</td><td>Внутренние и чартерные рейсы</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Прямые рейсы из Узбекистана отсутствуют, однако возможны пересадки через Тегеран, Дубай и Стамбул с последующей посадкой на рейсы SyrianAir в Дамаск.</p>
            <h3>Короткий вывод</h3>
            <p>SyrianAir — национальный перевозчик с историческим наследием, выполняющий ключевые рейсы несмотря на ограниченные ресурсы.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Сирия</p>
            <h4>Штаб-квартира:</h4><p>Дамаск</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Дамаск (DAM)</p>
            <h4>Вебсайт:</h4><a href="http://www.syriaair.com" target="_blank" rel="noreferrer">www.syriaair.com</a>`,
        },
      ],
    },
    middleEastAirlines: {
      pageKey: "middleEastAirlinesInfo",
      imageUrl: "/images/AK/ME.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Middle East Airlines (MEA)</h1>
            <h2>Дата основания и история</h2>
            <p>Middle East Airlines — национальная авиакомпания Ливана, основанная в 1945 году. MEA входит в альянс SkyTeam и считается одной из самых стабильных и уважаемых авиакомпаний Ближнего Востока. Основной хаб — аэропорт имени Рафика Харири в Бейруте.</p>
            <h3>Флот MEA</h3>
            <p>На 2024 год MEA использует современный флот Airbus:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo / A321neo</td><td>15+</td><td>Короткие и средние маршруты</td></tr>
                    <tr><td>Airbus A330-200</td><td>5</td><td>Дальнемагистральные маршруты в Европу и Африку</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>MEA не выполняет прямых рейсов из Узбекистана, но предлагает удобные стыковки в Бейрут через Дубай, Доху или Стамбул совместно с партнёрами по SkyTeam.</p>
            <h3>Короткий вывод</h3>
            <p>Middle East Airlines — это надёжный выбор для путешествий на Ближний Восток, в Европу и Африку с высоким уровнем сервиса.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
          <h4>Страна:</h4><p>Ливан</p>
          <h4>Штаб-квартира:</h4><p>Бейрут</p>
          <h4>Основной хаб:</h4><p>Международный аэропорт Бейрута им. Рафика Харири (BEY)</p>
          <h4>Вебсайт:</h4><a href="https://www.mea.com.lb" target="_blank" rel="noreferrer">www.mea.com.lb</a>`,
        },
      ],
    },
    aircompanyArmenia: {
      pageKey: "aircompanyArmeniaInfo",
      imageUrl: "/images/AK/6A.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Aircompany Armenia</h1>
            <h2>Дата основания и история</h2>
            <p>Aircompany Armenia — национальный авиаперевозчик Армении, основанный в декабре 2015 года. Первый коммерческий рейс состоялся в апреле 2016 года. Компания стремится обеспечить качественное воздушное сообщение между Арменией и странами ближнего и дальнего зарубежья.</p>
            <h3>Флот Aircompany Armenia</h3>
            <p>Флот состоит из надёжных самолётов советской и европейской сборки:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-500</td><td>2</td><td>Коротко- и среднемагистральные маршруты</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>На 2024 год Aircompany Armenia не выполняет прямых рейсов из Узбекистана, однако через Тбилиси, Минеральные Воды или Москву возможны стыковочные маршруты в Ереван.</p>
            <h3>Короткий вывод</h3>
            <p>Aircompany Armenia — небольшой, но стабильный перевозчик, обеспечивающий связь Армении с важными международными направлениями.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Армения</p>
            <h4>Штаб-квартира:</h4><p>Ереван</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Звартноц (EVN)</p>
            <h4>Вебсайт:</h4><a href="https://www.armeniaairways.am" target="_blank" rel="noreferrer">www.armeniaairways.am</a>`,
        },
      ],
    },
    arianaAfghanAirlines: {
      pageKey: "arianaAfghanAirlinesInfo",
      imageUrl: "/images/AK/FG.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Ariana Afghan Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>Ariana Afghan Airlines — национальная авиакомпания Афганистана, основанная в 1955 году. Это старейшая авиакомпания страны, сыгравшая ключевую роль в развитии воздушного сообщения Афганистана с соседними государствами и миром. В течение своей истории компания сотрудничала с рядом международных партнёров, включая Индийские и Советские авиалинии.</p>
            <h3>Флот Ariana Afghan Airlines</h3>
            <p>На 2024 год авиапарк включает:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-400 / 500</td><td>3+</td><td>Международные и внутренние рейсы</td></tr>
                    <tr><td>Airbus A310 (в ограниченном использовании)</td><td>1</td><td>Исторически использовался на дальнемагистральных направлениях</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>На данный момент Ariana не выполняет прямых рейсов из Узбекистана, но возможны стыковки через Кабул или другие центральноазиатские хабы.</p>
            <h3>Короткий вывод</h3>
            <p>Ariana Afghan Airlines — важный элемент транспортной системы Афганистана, предоставляющий базовые услуги по внутренним и ограниченным международным маршрутам.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Афганистан</p>
            <h4>Штаб-квартира:</h4><p>Кабул</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Кабул (KBL)</p>
            <h4>Вебсайт:</h4><a href="http://www.flyariana.com" target="_blank" rel="noreferrer">www.flyariana.com</a>`,
        },
      ],
    },
    georgianAirways: {
      pageKey: "georgianAirwaysInfo",
      imageUrl: "/images/AK/A9.png",
      generalInfo: [
        {
          content: `<article>
            <h1>Georgian Airways</h1>
            <h2>Дата основания и история</h2>
            <p>Georgian Airways — национальная авиакомпания Грузии, основанная в 1994 году (ранее Airzena). С 1999 года компания действует под текущим названием и предлагает регулярные и чартерные рейсы из Тбилиси в Европу, Ближний Восток и СНГ.</p>
            <h3>Флот Georgian Airways</h3>
            <p>На 2024 год флот включает:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Embraer 190</td><td>3</td><td>Маршруты средней дальности, до 100 пассажиров</td></tr>
                    <tr><td>Boeing 737-700</td><td>1</td><td>Рейсы в Европу и Ближний Восток</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Georgian Airways выполняет регулярные рейсы по маршруту Ташкент – Тбилиси (в сезон — 2–3 раза в неделю). Также возможны удобные пересадки в Европу через Тбилиси.</p>
            <h3>Короткий вывод</h3>
            <p>Georgian Airways — стабильный перевозчик Южного Кавказа с удобным сообщением между Узбекистаном и Грузией.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Грузия</p>
            <h4>Штаб-квартира:</h4><p>Тбилиси</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Тбилиси (TBS)</p>
            <h4>Вебсайт:</h4><a href="https://www.georgian-airways.com" target="_blank" rel="noreferrer">www.georgian-airways.com</a>`,
        },
      ],
    },
    myWayAirlines: {
      pageKey: "myWayAirlinesInfo",
      imageUrl: "/images/AK/MW.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>MyWay Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>MyWay Airlines — частная грузинская авиакомпания, основанная в 2018 году. С момента начала операций компания позиционирует себя как лоукост-перевозчик и делает акцент на рейсы в СНГ, Ближний Восток и Центральную Азию.</p>
            <h3>Флот MyWay Airlines</h3>
            <p>На 2024 год авиапарк скромен и состоит из:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>2</td><td>Универсальные среднемагистральные самолёты</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>MyWay Airlines ранее выполняла чартерные рейсы из Ташкента и Самарканда в Тбилиси. На 2024 год полёты зависят от сезона и спроса, уточняйте на сайте перевозчика.</p>
            <h3>Короткий вывод</h3>
            <p>MyWay Airlines — недорогой перевозчик с гибкой маршрутной сеткой, ориентированной на страны СНГ и ближние зарубежные направления.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Грузия</p>
            <h4>Штаб-квартира:</h4><p>Тбилиси</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Тбилиси (TBS)</p>
            <h4>Вебсайт:</h4><a href="https://www.mywayairlines.com" target="_blank" rel="noreferrer">www.mywayairlines.com</a>`,
        },
      ],
    },
    koreanAir: {
      pageKey: "koreanAirInfo",
      imageUrl: "/images/AK/KE.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Korean Air</h1>
            <h2>Дата основания и история</h2>
            <p>Korean Air — крупнейшая авиакомпания Южной Кореи и одна из ведущих в Азии. Основана в 1969 году, компания активно развивает международную маршрутную сеть, является членом альянса SkyTeam и обслуживает направления на всех континентах.</p>
            <h3>Флот Korean Air</h3>
            <p>Флот — один из самых современных в Азии, включает:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 777-200/300</td><td>25+</td><td>Межконтинентальные рейсы</td></tr>
                    <tr><td>Airbus A330-200/300</td><td>20+</td><td>Азиатские и дальневосточные маршруты</td></tr>
                    <tr><td>Boeing 747-8i / Airbus A380</td><td>10+</td><td>Флагманские лайнеры на самых загруженных направлениях</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Korean Air выполняет прямые рейсы по маршруту Ташкент — Сеул (Incheon) несколько раз в неделю. Это один из самых удобных маршрутов в Восточную Азию.</p>
            <h3>Короткий вывод</h3>
            <p>Korean Air — премиальная авиакомпания с высоким уровнем сервиса, прямыми рейсами из Узбекистана и обширной сетью по всему миру.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Южная Корея</p>
            <h4>Штаб-квартира:</h4><p>Сеул</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Инчхон (ICN)</p>
            <h4>Вебсайт:</h4><a href="https://www.koreanair.com" target="_blank" rel="noreferrer">www.koreanair.com</a>`,
        },
      ],
    },
    jazeeraAirways: {
      pageKey: "jazeeraAirwaysInfo",
      imageUrl: "/images/AK/J9.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Jazeera Airways</h1>
            <h2>Дата основания и история</h2>
            <p>Jazeera Airways — частная бюджетная авиакомпания Кувейта, основанная в 2004 году. Она стала первой частной авиакомпанией в регионе Персидского залива, получившей лицензию на осуществление регулярных пассажирских перевозок.</p>
            <h3>Флот Jazeera Airways</h3>
            <p>Авиапарк компании полностью состоит из современных узкофюзеляжных самолётов Airbus:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 / A320neo</td><td>20+</td><td>Короткие и средние маршруты, низкие расходы на топливо</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Jazeera Airways выполняет прямые рейсы Ташкент — Кувейт (KWI) несколько раз в неделю. Также возможны пересадки в Дубай, Джидду, Эр-Рияд, Мумбаи и Стамбул.</p>
            <h3>Короткий вывод</h3>
            <p>Jazeera Airways — доступный и надёжный перевозчик с отличным сервисом, выполняющий прямые рейсы из Узбекистана в страны Персидского залива.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Кувейт</p>
            <h4>Штаб-квартира:</h4><p>Кувейт-Сити</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Кувейта (KWI), Терминал 5 (собственный)</p>
            <h4>Вебсайт:</h4><a href="https://www.jazeeraairways.com" target="_blank" rel="noreferrer">www.jazeeraairways.com</a>`,
        },
      ],
    },
    mahanAir: {
      pageKey: "mahanAirInfo",
      imageUrl: "/images/AK/W5.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Mahan Air</h1>
            <h2>Дата основания и история</h2>
            <p>Mahan Air — одна из крупнейших частных авиакомпаний Ирана, основана в 1991 году с базой в городе Керман, а главный хаб находится в Тегеране. Компания активно выполняет рейсы по внутренним и международным направлениям, включая Азию и Европу.</p>
            <h3>Флот Mahan Air</h3>
            <p>Флот авиакомпании состоит из широкофюзеляжных и среднемагистральных самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A310 / A300</td><td>20+</td><td>Дальние и чартерные рейсы</td></tr>
                    <tr><td>BAe 146</td><td>5+</td><td>Короткие маршруты, малые аэропорты</td></tr>
                    <tr><td>Airbus A340</td><td>10+</td><td>Межконтинентальные маршруты</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>На 2024 год Mahan Air выполняет периодические рейсы из Ташкента в Тегеран (ИМАМ ХОМЕЙНИ). Также возможны пересадки на рейсы в Турцию, Китай и Ливан.</p>
            <h3>Короткий вывод</h3>
            <p>Mahan Air — крупный иранский перевозчик с широкой маршрутной сетью и флотом для разных направлений, включая Центральную Азию.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Иран</p>
            <h4>Штаб-квартира:</h4><p>Тегеран</p>
            <h4>Основной хаб:</h4><p>Аэропорт Имам Хомейни (IKA)</p>
            <h4>Вебсайт:</h4><a href="https://www.mahanair.ir" target="_blank" rel="noreferrer">www.mahanair.ir</a>`,
        },
      ],
    },
    indigoAirlines: {
      pageKey: "indigoAirlinesInfo",
      imageUrl: "/images/AK/6E.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>IndiGo Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>IndiGo — крупнейшая авиакомпания Индии, основанная в 2006 году. Это один из самых быстрорастущих лоукост-перевозчиков в Азии, известный своей пунктуальностью, низкими тарифами и широкой маршрутной сетью как внутри Индии, так и за её пределами.</p>
            <h3>Флот IndiGo</h3>
            <p>Флот авиакомпании полностью состоит из узкофюзеляжных самолётов Airbus:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo / A321neo</td><td>300+</td><td>Коротко- и среднемагистральные рейсы, эффективное топливопотребление</td></tr>
                    <tr><td>ATR 72-600</td><td>40+</td><td>Региональные маршруты и малые аэропорты</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>IndiGo начала выполнять прямые рейсы Ташкент — Дели в 2023 году. Перелёты осуществляются несколько раз в неделю с удобными пересадками на рейсы по всей Индии.</p>
            <h3>Короткий вывод</h3>
            <p>IndiGo — надёжный и доступный выбор для путешествий между Узбекистаном и Индией, а также для внутренних индийских перелётов.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Индия</p>
            <h4>Штаб-квартира:</h4><p>Гуруграм, Харьяна</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Индиры Ганди (DEL)</p>
            <h4>Вебсайт:</h4><a href="https://www.goindigo.in" target="_blank" rel="noreferrer">www.goindigo.in</a>`,
        },
      ],
    },
    alrosaAirlines: {
      pageKey: "alrosaAirlinesInfo",
      imageUrl: "/images/AK/6R.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Alrosa Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>Alrosa Airlines — российская авиакомпания, основанная в 1992 году. Является дочерней структурой алмазодобывающей компании АЛРОСА. Основное направление деятельности — обеспечение транспортной доступности труднодоступных районов Якутии и Сибири.</p>
            <h3>Флот Alrosa</h3>
            <p>Флот состоит из советских и российских самолетов, адаптированных под суровые климатические условия:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Ту-154М</td><td>1</td><td>Один из последних эксплуатируемых Ту-154 в мире</td></tr>
                    <tr><td>Боинг 737-800</td><td>3+</td><td>Межрегиональные маршруты</td></tr>
                    <tr><td>Ан-24 / Ан-38</td><td>5+</td><td>Короткие полосы, региональные рейсы</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>На 2024 год Alrosa не выполняет регулярных рейсов из Узбекистана, но возможны сезонные чартеры в Сибирь или Якутск.</p>
            <h3>Короткий вывод</h3>
            <p>Alrosa Airlines — важный региональный перевозчик России, обеспечивающий связь с отдалёнными районами Сибири и Якутии.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Россия</p>
            <h4>Штаб-квартира:</h4><p>Мирный, Республика Саха (Якутия)</p>
            <h4>Основной хаб:</h4><p>Аэропорт Мирный (MJZ)</p>
            <h4>Вебсайт:</h4><a href="https://www.alrosa.aero" target="_blank" rel="noreferrer">www.alrosa.aero</a>`,
        },
      ],
    },
    turkmenistanAirlines: {
      pageKey: "turkmenistanAirlinesInfo",
      imageUrl: "/images/AK/T5.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Turkmenistan Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>Turkmenistan Airlines — национальная авиакомпания Туркменистана, основанная в 1992 году. Она является монополистом на рынке гражданской авиации страны и выполняет как внутренние, так и международные рейсы, в том числе в Европу, Азию и страны СНГ.</p>
            <h3>Флот Turkmenistan Airlines</h3>
            <p>Флот состоит из современных самолётов производства Boeing:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-700/800</td><td>10+</td><td>Коротко- и среднемагистральные маршруты</td></tr>
                    <tr><td>Boeing 757-200</td><td>3</td><td>Среднемагистральные рейсы с повышенной вместимостью</td></tr>
                    <tr><td>Boeing 777-200LR</td><td>3</td><td>Дальнемагистральные направления, включая Лондон и Пекин</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Turkmenistan Airlines периодически выполняет рейсы по маршруту Ташкент — Ашхабад. Также возможны стыковки в Европу, Индию и Китай через Ашхабад.</p>
            <h3>Короткий вывод</h3>
            <p>Turkmenistan Airlines — государственный авиаперевозчик с устойчивой маршрутной сетью, соединяющей Центральную Азию с другими регионами мира.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Туркменистан</p>
            <h4>Штаб-квартира:</h4><p>Aшхабад</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт Ашхабад (ASB)</p>
            <h4>Вебсайт:</h4><a href="https://turkmenistanairlines.tm" target="_blank" rel="noreferrer">turkmenistanairlines.tm</a>`,
        },
      ],
    },
    saudiaAirlines: {
      pageKey: "saudiaAirlinesInfo",
      imageUrl: "/images/AK/SV.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Saudia Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>Saudia (ранее Saudi Arabian Airlines) — национальная авиакомпания Саудовской Аравии, основанная в 1945 году. Входит в альянс SkyTeam и считается одним из крупнейших перевозчиков Ближнего Востока. Обслуживает десятки международных направлений, включая Азию, Европу, Африку и Северную Америку.</p>
            <h3>Флот Saudia</h3>
            <p>Флот компании один из самых технологичных в регионе:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 777-300ER</td><td>30+</td><td>Дальнемагистральные рейсы, высокий уровень комфорта</td></tr>
                    <tr><td>Airbus A330-300</td><td>30+</td><td>Региональные и дальние маршруты</td></tr>
                    <tr><td>Airbus A320/A321</td><td>50+</td><td>Средне- и ближнемагистральные направления</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Saudia выполняет прямые рейсы по маршруту Ташкент — Джидда (JED), особенно в сезон Хаджа и Умры. Также возможны пересадки в Даммаме, Эр-Рияде и Медине.</p>
            <h3>Короткий вывод</h3>
            <p>Saudia — флагманский перевозчик Саудовской Аравии с высококлассным сервисом и удобными рейсами из Узбекистана в Ближний Восток и далее.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Саудовская Аравия</p>
            <h4>Штаб-квартира:</h4><p>Джидда</p>
            <h4>Основной хаб:</h4><p>Международный аэропорт им. короля Абдулазиза (JED)</p>
            <h4>Вебсайт:</h4><a href="https://www.saudia.com" target="_blank" rel="noreferrer">www.saudia.com</a>`,
        },
      ],
    },
    pegasusAir: {
      pageKey: "pegasusAirInfo",
      imageUrl: "/images/AK/PC.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Pegasus Airlines</h1>
            <h2>Дата основания и история</h2>
            <p>Pegasus Airlines — турецкая бюджетная авиакомпания, основанная в 1990 году. Является одной из крупнейших лоукост-компаний региона, активно расширяющей маршрутную сеть по всей Европе, Азии и Ближнему Востоку.</p>
            <h3>Флот Pegasus</h3>
            <p>Флот состоит из современных узкофюзеляжных самолётов:</p>
            <table>
                <thead>
                    <tr><th>Тип самолёта</th><th>Количество</th><th>Особенности</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo / A321neo</td><td>90+</td><td>Топливная эффективность, средние и дальние маршруты</td></tr>
                    <tr><td>Boeing 737-800</td><td>30+</td><td>Используется на ближнемагистральных рейсах</td></tr>
                </tbody>
            </table>
            <h3>Рейсы из Узбекистана</h3>
            <p>Pegasus выполняет регулярные рейсы Ташкент — Стамбул (аэропорт Сабиха Гёкчен) и предлагает удобные пересадки по всей Турции и за её пределами.</p>
            <h3>Короткий вывод</h3>
            <p>Pegasus — один из лучших вариантов для недорогих перелётов из Узбекистана в Турцию и Европу с современным флотом и гибкой системой тарифов.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна:</h4><p>Турция</p>
            <h4>Штаб-квартира:</h4><p>Стамбул</p>
            <h4>Основной хаб:</h4><p>Аэропорт Сабиха Гёкчен (SAW)</p>
            <h4>Вебсайт:</h4><a href="https://www.flypgs.com" target="_blank" rel="noreferrer">www.flypgs.com</a>`,
        },
      ],
    },
  },
  uz: {
    aeroflot: {
      pageKey: "aeroflotInfo",
      imageUrl: "/images/AK/SU/SU.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Aeroflot</h1>
            <h2>Tashkil topgan yili va qisqacha tarix</h2>
            <p>Aeroflot (PAO «Aeroflot — Rossiya havo yo‘llari») dunyodagi eng eski aviakompaniyalardan biri bo‘lib, 1923-yilda asos solingan. Bu davr mobaynida u sobiq ittifoq davridagi monopol aviakompaniyadan tortib, hozirda butun dunyoga parvoz qiladigan yirik xalqaro tashuvchiga aylandi. Aviabilet uzbekistan yo‘nalishlarida ham ko‘p qulay reyslar mavjud.</p>
            <h3>Aeroflot flotiga qisqacha nazar</h3>
            <p>Aeroflot floti Airbus A320/321 kabi qisqa va o‘rta masofali samolyotlar, shuningdek, Boeing 777 va Airbus A330 kabi uzoq masofali samolyotlardan iborat. Zamonaviy laynerlar parvozni yanada qulay qiladi, ayniqsa aviabilet narxlari Toshkent yoki boshqa shaharlardan izlayotgan bo‘lsangiz.</p>
            <table>
              <thead>
                <tr>
                  <th>Samolyot turi</th>
                  <th>Soni (taxminan)</th>
                  <th>O'ziga xos xususiyatlar</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320/321</td>
                  <td>~100</td>
                  <td>Qisqa va o‘rta masofali yo‘nalishlar</td>
                </tr>
                <tr>
                  <td>Airbus A330</td>
                  <td>~20</td>
                  <td>Uzoq masofali reyslar, oshirilgan qulaylik</td>
                </tr>
                <tr>
                  <td>Boeing 777</td>
                  <td>~20</td>
                  <td>Qit’alararo yo‘nalishlar, keng salonlar</td>
                </tr>
              </tbody>
            </table>
            <h3>O‘zbekistondan parvoz jadvali</h3>
            <p>Aeroflot quyidagi shaharlar orqali Moskva (Sheremetyevo) yo‘nalishida parvozlar amalga oshiradi:</p>
            <ul>
              <li>
                <b>Toshkent (TAS): </b>odatda har kuni (haftasiga 7 kun).
              </li>
              <li>
                <b>Samarqand (SKD): </b>haftasiga 2–3 marta (masalan, seshanba, payshanba, shanba).
              </li>
              <li>
                <b>Buxoro (BHK): </b>haftada 1–2 marta (ko‘pincha chorshanba va yakshanba).
              </li>
            </ul>
            <p>Aniq sana va vaqtlarni <a href="https://biletbor.me" target="_blank" rel="noreferrer">biletbor.me</a> yoki rasmiy saytdan toping (Moskva aviabilet narxlari va boshqalar).</p>
            <h3>Xulosa</h3>
            <p>Aeroflot uzoq tarix, keng ko‘lamli yo‘nalishlar va zamonaviy samolyotlar bilan mashhur. Agar sizga aviabilet дешевые yoki moskva aviabilet narxlari kerak bo‘lsa, biletbor.me yoki aviakompaniyaning rasmiy sayti orqali izlashni tavsiya etamiz.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat: </h4>
            <p>Rossiya</p> 
            <h4>Bosh ofis: </h4> 
            <p>Moskva</p> 
            <h4>Asosiy xablar: </h4>   
            <p>Sheremetyevo aeroporti (B/C terminallari), xalqaro va mintaqaviy reyslarning ko‘pchiligi shu yerdan amalga oshiriladi.</p>
            <h4>Veb-sayt:</h4>
            <a href="https://www.aeroflot.ru" target="_blank" rel="noreferrer">www.aeroflot.ru</a>
          `,
        },
      ],
    },
    uzairways: {
      name: "uzairways",
      pageKey: "uzairwaysInfo",
      imageUrl: "/images/AK/HY.svg",
      generalInfo: [
        {
          content: `
            <article>
              <h1>O'zbekiston Havo Yo'llari</h1>
              <h2>Tashkil topgan yili va tarixi</h2>
              <p>Uzbekistan Airways 1992 yilda tashkil etilgan bo‘lib, O‘zbekistonning milliy aviakompaniyasidir. Kompaniya keng yo‘nalish tarmog‘i va yuqori xizmat ko‘rsatish darajasi bilan mashhur.</p>
              <h2>Uzbekistan Airways samolyot parki</h2>
        <table>
            <thead>
                <tr>
                    <th>Samolyot turi</th>
                    <th>Soni</th>
                    <th>Yo‘nalishlar</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Boeing 787 Dreamliner</td>
                    <td>7</td>
                    <td>Uzoq masofali reyslar</td>
                </tr>
                <tr>
                    <td>Airbus A320neo</td>
                    <td>10</td>
                    <td>O‘rta masofali yo‘nalishlar</td>
                </tr>
                <tr>
                    <td>Boeing 767-300</td>
                    <td>6</td>
                    <td>Xalqaro reyslar</td>
                </tr>
            </tbody>
        </table>
        
        <h2>O‘zbekistondan reyslar jadvali</h2>
        <ul>
            <li><strong>Toshkent – Moskva:</strong> har kuni</li>
            <li><strong>Toshkent – Sankt-Peterburg:</strong> haftasiga 3 marta</li>
            <li><strong>Samarqand – Dubay:</strong> haftasiga 2 marta</li>
            <li><strong>Buxoro – Istanbul:</strong> haftasiga 2 marta</li>
        </ul>
              <h2>Xulosa</h2>
        <p>Uzbekistan Airways yo‘lovchilarga keng yo‘nalishlar tarmog‘ini va yuqori darajadagi xizmatni taklif etadi. Chipta narxlari va bron qilish uchun <a href="https://biletbor.me">Biletbor.me</a> saytiga tashrif buyuring.</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Davlat:</h4>
        <p>O‘zbekiston</p> 
        <h4>Bosh ofis:</h4> 
        <p>Toshkent</p> 
        <h4>Asosiy xab:</h4>   
        <p>Toshkent xalqaro aeroporti (TAS)</p>
        <h4>Вебсайт:</h4>
        <a href="https://www.uzairways.com" target="_blank" rel="noreferrer">www.uzairways.com</a>
      `,
        },
      ],
    },
    turkishAirlines: {
      pageKey: "turkishAirlinesInfo",
      imageUrl: "/images/AK/TK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Turkish Airlines – Turkiyaning milliy havo tashuvchisi</h1>
            <h2>Tashkil topgan yili va qisqacha tarix</h2>
            <p>1933 yilda tashkil etilgan Turkish Airlines bugungi kunda dunyodagi eng yirik aviakompaniyalardan biri hisoblanadi. Kompaniya 120 dan ortiq davlatda 300+ yo‘nalishga parvozlarni amalga oshiradi.</p>
            <h3>Turkish Airlines floti</h3>
            <p>Turkish Airlines floti Airbus va Boeing samolyotlaridan iborat. Keng va tor fuzelyajli samolyotlar orqali qisqa va uzoq masofali reyslarni amalga oshiradi.</p>
            <table>
              <thead>
                <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
              </thead>
              <tbody>
                <tr><td>Airbus A321</td><td>~90</td><td>Yevropa va ichki yo‘nalishlar</td></tr>
                <tr><td>Boeing 737</td><td>~80</td><td>O‘rta masofali reyslar</td></tr>
                <tr><td>Boeing 777 / A350</td><td>~60</td><td>Uzoq masofali yo‘nalishlar</td></tr>
              </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Turkish Airlines quyidagi shaharlardan Istanbulga muntazam reyslarni amalga oshiradi:</p>
            <ul>
              <li><b>Toshkent (TAS):</b> har kuni</li>
              <li><b>Samarkand (SKD):</b> haftasiga 3–4 marta</li>
              <li><b>Farg‘ona (FEG):</b> haftasiga 2 marta</li>
            </ul>
            <p>Yaqin reyslar va narxlar bilan <a href="https://biletbor.me" target="_blank">biletbor.me</a> orqali tanishing.</p>
            <h3>Xulosa</h3>
            <p>Turkish Airlines Istanbul orqali dunyoga qulay parvozlar taklif qiladi. Uzoq yoki yaqin safarlar uchun ideal tanlov!</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Mamlakat:</h4><p>Turkiya</p>
            <h4>Bosh ofis:</h4><p>Istanbul</p>
            <h4>Asosiy xab:</h4><p>Istanbul aeroporti (IST)</p>
            <h4>Veb-sayt:</h4><a href="https://www.turkishairlines.com" target="_blank">www.turkishairlines.com</a>`,
        },
      ],
    },
    belavia: {
      name: "belavia",
      pageKey: "belaviaInfo",
      imageUrl: "/images/AK/B2.png",
      generalInfo: [
        {
          content: `<article>
            <h1>Belavia</h1>
            <h2>Tashkil topgan yili va qisqacha tarix</h2>
            <p>Belavia — Belarus Respublikasining milliy aviakompaniyasi bo‘lib, 1996-yilda sobiq Sovet aviakompaniyasi Aeroflot asosida tashkil etilgan. Tashkil topganidan buyon Belavia faol ravishda rivojlanib, yo‘nalishlar tarmog‘ini kengaytirib, yo‘lovchilarga yuqori sifatli xizmat ko‘rsatishni maqsad qilgan. Kompaniya yo‘lovchilarga aviabilet дешевые va qulay parvoz sharoitlarini taqdim etishga intiladi.</p>
            <h3>Flot</h3>
            <p>Belavia floti zamonaviy Airbus (A320, A330) va Boeing (737, 767) samolyotlaridan iborat. Ushbu samolyotlar qisqa va uzoq masofalardagi yo‘nalishlar uchun yuqori darajadagi komfort va xavfsizlikni ta’minlaydi. Flotning xilma-xilligi Belavia’ga turli toifadagi aviabilet narxlarini taklif etishga imkon beradi (ekonom, biznes).</p>
            <table>
              <thead>
                <tr>
                  <th>Samolyot</th>
                  <th>Xususiyatlari</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320</td>
                  <td>Ekonom va biznes-klass uchun qulay sharoitlar</td>
                </tr>
                <tr>
                  <td>Boeing 737</td>
                  <td>Qisqa va o‘rta masofali yo‘nalishlar uchun ishonchlilik va xavfsizlik</td>
                </tr>
              </tbody>
            </table>
            <h3>O‘zbekistondan parvoz jadvali</h3>
            <p>Belavia O‘zbekistondan quyidagi shaharlar orqali reyslarni amalga oshirishi mumkin:</p>
            <ul>
              <li>
                <b>Toshkent (TAS):</b> Minsk yo‘nalishi bilan parvozlar (mavsumga qarab chastota o‘zgarishi mumkin).
              </li>
              <li>
                <b>Samarqand (SKD):</b> Minsk va boshqa yo‘nalishlarga mavsumiy reyslar.
              </li>
            </ul>
            <p>Aniq jadval va aviabilet narxlarini <a href="https://biletbor.me">biletbor.me</a> yoki aviakompaniya rasmiy saytidan tekshirish tavsiya etiladi.</p>
            <h3>Xulosa</h3>
            <p>Belavia — ishonchli aviakompaniya bo‘lib, yo‘lovchilarga arzon aviabilet narxlari va qulay sharoitlarni taqdim etadi. Agar siz O‘zbekistonlik bo‘lsangiz va Belarusga yoki boshqa MDH davlatlariga sayohat qilmoqchi bo‘lsangiz, Belavia’ning takliflarini <a href="https://biletbor.me">biletbor.me</a> orqali solishtiring va eng mos reysni tanlang.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat: </h4>
            <p>Belarus</p> 
            <h4>Bosh ofis: </h4> 
            <p>Minsk</p> 
            <h4>Asosiy xab: </h4>   
            <p>Minsk xalqaro aeroporti (MSQ)
               Belavia Minskdan Yevropa, Osiyo va Yaqin Sharqning ko‘plab shaharlarga reyslar amalga oshiradi, shuningdek, turistik yo‘nalishlarga charter reyslarni ham taqdim etadi. Bu yo‘lovchilarga aviabilet moskva, aviabilet sankt peterburg kabi yo‘nalishlarni qulay ulanishlar bilan tanlash imkonini beradi.
            </p>
            <h4>Vebsayt:</h4>
            <a href="https://belavia.by/" target="_blank" rel="noreferrer">www.belavia.by</a>
          `,
        },
      ],
    },
    uralairlines: {
      pageKey: "uralInfo",
      imageUrl: "/images/AK/U6.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Ural Havo Yo'llari</h1>
            <h2>Tashkil topgan yili va qisqacha tarix</h2>
            <p>Ural Airlines 1943 yilda tashkil etilgan bo‘lib, dastlab «Aeroflot» tarkibida bo‘lgan. 1993 yildan boshlab mustaqil aviakompaniya sifatida faoliyat yuritmoqda. Kompaniya Rossiya, MDH, Yevropa va Osiyoga muntazam parvozlarni amalga oshiradi.</p>
            <h3>Ural Airlines samolyot parki</h3>
            <p>Ural Airlines zamonaviy samolyotlarga ega:</p>
            <table>
              <thead>
                <tr>
                  <th>Samolyot turi</th>
                  <th>Soni (taxminan)</th>
                  <th>O'ziga xos xususiyatlar</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320</td>
                  <td>~20</td>
                  <td>o‘rta va uzoq masofali yo‘nalishlar uchun</td>
                </tr>
                <tr>
                  <td>Airbus A321</td>
                  <td>~15</td>
                  <td>keng sig‘imli parvozlar uchun</td>
                </tr>
                <tr>
                  <td>Airbus A319</td>
                  <td>~10</td>
                  <td>qisqa masofali reyslar uchun</td>
                </tr>
              </tbody>
            </table>
            <h3>O‘zbekistondan parvoz jadvali</h3>
            <p>Ural Airlines O‘zbekistonning yirik shaharlari bilan bog‘lanishni ta’minlaydi:</p>
            <ul>
              <li>
                <b>Toshkent – Moskva: </b>haftasiga 3 marta.
              </li>
              <li>
                <b>Samarqand – Yekaterinburg: </b>haftasiga 2 marta.
              </li>
              <li>
                <b>Farg‘ona – Moskva: </b>1-2 marta haftasiga.
              </li>
            </ul>
            <p>Aniq sana va vaqtlarni <a href="https://biletbor.me" target="_blank" rel="noreferrer">Biletbor.me</a> yoki rasmiy saytdan toping (Moskva aviabilet narxlari va boshqalar).</p>
            <h3>Xulosa</h3>
            <p>Ural Airlines – O‘zbekiston va Rossiya o‘rtasidagi ishonchli havo yo‘lovchi tashuvchisi. Aviabilet narxlari va bron qilish uchun <a href="https://biletbor.me">Biletbor.me</a> saytiga tashrif buyuring.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat: </h4>
            <p>Rossiya</p> 
            <h4>Bosh ofis: </h4> 
            <p>Yekaterinburg</p> 
            <h4>Asosiy xablar: </h4>   
            <p>Keltso xalqaro aeroporti (SVX)</p>
            <h4>Veb-sayt:</h4>
            <a href="https://www.uralairlines.ru/" target="_blank" rel="noreferrer">www.uralairlines.ru</a>
          `,
        },
      ],
    },
    s7: {
      pageKey: "s7Info",
      imageUrl: "/images/AK/S7.svg",
      generalInfo: [
        {
          content: `
            <article>
              <h1>S7 Airlines</h1>
              <h2>Tashkil topgan yili va tarixi</h2>
              <p>S7 Airlines 1992 yilda tashkil etilgan bo‘lib, Rossiyaning eng yirik xususiy aviakompaniyalaridan biridir. Kompaniya muntazam ravishda xizmat tarmog‘ini kengaytirib bormoqda.</p>
              <h2>S7 Airlines samolyot parki</h2>
              <p>S7 Airlines zamonaviy samolyotlarga ega:</p>
        <table>
            <thead>
                <tr>
                    <th>Samolyot turi</th>
                    <th>Soni</th>
                    <th>Yo‘nalishlar</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Airbus A320neo</td>
                    <td>20</td>
                    <td>O‘rta va uzoq masofali reyslar</td>
                </tr>
                <tr>
                    <td>Boeing 737-800</td>
                    <td>23</td>
                    <td>Ichki va xalqaro yo‘nalishlar</td>
                </tr>
                <tr>
                    <td>Embraer E170</td>
                    <td>17</td>
                    <td>Mintaqaviy reyslar</td>
                </tr>
            </tbody>
        </table>
        
        <h2>O‘zbekistondan reyslar jadvali</h2>
        <ul>
            <li><strong>Toshkent – Moskva:</strong> har kuni</li>
            <li><strong>Toshkent – Novosibirsk:</strong> haftasiga 2 marta</li>
            <li><strong>Samarqand – Moskva:</strong> 1-2 marta haftasiga</li>
        </ul>
              <h2>Xulosa</h2>
        <p>S7 Airlines – O‘zbekiston va Rossiya o‘rtasidagi ishonchli havo yo‘lovchi tashuvchisi. Aviabilet narxlari va bron qilish uchun <a href="https://biletbor.me">Biletbor.me</a> saytiga tashrif buyuring.</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Davlat:</h4>
        <p>Rossiya</p> 
        <h4>Bosh ofis:</h4> 
        <p>Moskva</p> 
        <h4>Asosiy xab:</h4>   
        <p>Moskva (Domodedovo, DME), Novosibirsk (Tolmachëvo, OVB)</p>
        <h4>Вебсайт:</h4>
        <a href="https://www.s7.ru/" target="_blank" rel="noreferrer">www.s7.ru</a>
      `,
        },
      ],
    },
    qanotsharq: {
      pageKey: "qanotsharqInfo",
      imageUrl: "/images/HH.svg",
      generalInfo: [
        {
          content: `
            <article>
              <h1>Qanot Sharq</h1>
              <h2>Tashkil topgan yili va tarixi</h2>
              <p>Qanot Sharq aviakompaniyasi 1998 yilda tashkil etilgan bo‘lib, yo‘lovchi va yuk tashish xizmatlarini ko‘rsatadi. Yillar davomida kompaniya ishonchli tashuvchi sifatida o‘z mavqeini mustahkamladi.</p>
              <h2>Qanot Sharq samolyot parki</h2>
              <p>Bugungi kunda kompaniya quyidagi samolyotlarni ekspluatatsiya qiladi:</p>
              <table>
                  <thead>
                      <tr>
                          <th>Samolyot turi</th>
                          <th>Soni</th>
                          <th>Asosiy yo‘nalishlar</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td>Airbus A320</td>
                          <td>2</td>
                          <td>Xalqaro va mahalliy reyslar</td>
                      </tr>
                      <tr>
                          <td>Boeing 757-200</td>
                          <td>1</td>
                          <td>Uzoq masofali yo‘nalishlar</td>
                      </tr>
                  </tbody>
              </table>
        <h2>O‘zbekistondan reyslar jadvali</h2>
        <ul>
            <li><strong>Toshkent – Moskva:</strong> har kuni</li>
            <li><strong>Toshkent – Sankt-Peterburg:</strong> haftada 4 marta</li>
            <li><strong>Toshkent – Dubay:</strong> haftada 3 marta</li>
            <li><strong>Toshkent – Istanbul:</strong> haftada 2 marta</li>
        </ul>
        <h2>Xulosa</h2>
        <p>Qanot Sharq – mashhur yo‘nalishlar bo‘ylab qulay va arzon parvozlarni taklif etadi. Aviabiletlarni onlayn band qilish uchun <a href="https://biletbor.me">Biletbor.me</a> saytiga tashrif buyuring!</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
        <h4>Davlat:</h4>
        <p>O‘zbekiston</p> 
        <h4>Bosh ofis:</h4> 
        <p>Toshkent</p> 
        <h4>Asosiy xab:</h4>   
        <p>Toshkent xalqaro aeroporti (TAS)</p>
        <h4>Вебсайт:</h4>
        <a href="https://qanotsharq.com/" target="_blank" rel="noreferrer">www.qanotsharq.com</a>
      `,
        },
      ],
    },
    pobeda: {
      pageKey: "pobedaInfo",
      imageUrl: "/images/AK/DP.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Pobeda</h1>
            <h2>Tashkil topgan yili va qisqacha tarix</h2>
            <p><strong>Pobeda</strong> aviakompaniyasi 2014 yilda tashkil etilgan bo‘lib, Rossiyaning eng yirik loukosterlaridan biridir. "Aeroflot" guruhi tarkibiga kiradi va arzon parvozlar taklif etadi.</p>
            <h3>Pobeda samolyot parki</h3>
            <p>Ural Airlines zamonaviy samolyotlarga ega:</p>
            <table>
              <thead>
                  <tr>
                      <th>Samolyot turi</th>
                      <th>Soni</th>
                      <th>Asosiy yo‘nalishlar</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>Boeing 737-800</td>
                      <td>45</td>
                      <td>Rossiya, MDH, Yevropa</td>
                  </tr>
              </tbody>
            </table>
            <h3>O‘zbekistondan parvoz jadvali</h3>
            <p>Ural Airlines O‘zbekistonning yirik shaharlari bilan bog‘lanishni ta’minlaydi:</p>
            <ul>
              <li><strong>Toshkent – Moskva (VKO):</strong> har kuni</li>
              <li><strong>Samarqand – Moskva (VKO):</strong> haftada 3 marta</li>
              <li><strong>Farg‘ona – Moskva (VKO):</strong> haftada 2 marta</li>
            </ul> 
            <p>Aniq sana va vaqtlarni <a href="https://biletbor.me" target="_blank" rel="noreferrer">Biletbor.me</a> yoki rasmiy saytdan toping (Moskva aviabilet narxlari va boshqalar).</p>
            <h3>Xulosa</h3>
            <p>Pobeda – O‘zbekistondan Moskvaga va boshqa shaharlar bo‘yicha arzon va qulay parvozlarni taklif etadi. Aviabiletlarni onlayn band qilish uchun <a href="https://biletbor.me">Biletbor.me</a> saytiga tashrif buyuring!</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat: </h4>
            <p>Rossiya</p> 
            <h4>Bosh ofis: </h4> 
            <p>Moskva</p> 
            <h4>Asosiy xablar: </h4>   
            <p>Moskva Vnukovo aeroporti (VKO)</p>
            <h4>Veb-sayt:</h4>
            <a href="https://www.flypobeda.ru/" target="_blank" rel="noreferrer">www.flypobeda.ru</a>
          `,
        },
      ],
    },
    airastana: {
      name: "airastana",
      pageKey: "airastanaInfo",
      imageUrl: "/images/AK/KC/KC.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air Astana</h1>
            <h2>Tashkil topgan yili va qisqacha tarix</h2>
            <p>Air Astana — Qozog‘istonning milliy aviakompaniyasi bo‘lib, 2001-yilda asos solingan. Kompaniya ishga tushirilgan paytdan boshlab xizmatlar sifatini yaxshilab, aviabilet дешевые va premium tariflarini taqdim etib keladi.</p>
            <h3>Flot</h3>
            <p>Air Astana Airbus (A320, A321, A321LR/neo), Boeing (757, 767) va Embraer (E190-E2) samolyotlaridan foydalanadi. Bu turdagi zamonaviy laynerlar yo‘lovchilarga qulay parvoz imkonini beradi, xususan aviabilet narxlari borasida tanlov kengligi yuqori.</p>
            <table>
              <thead>
                <tr>
                  <th>Samolyot turi</th>
                  <th>Xizmat xususiyatlari</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320 / A321 / A321LR</td>
                  <td>Qisqa va o‘rta masofalarga mo‘ljallangan zamonaviy laynerlar</td>
                </tr>
                <tr>
                  <td>Boeing 757 / 767</td>
                  <td>Uzoq masofali, yuqori ishonchlilikka ega samolyotlar</td>
                </tr>
                <tr>
                  <td>Embraer E190-E2</td>
                  <td>Qisqa masofaga uchish uchun qulay regiоnal samolyotlar</td>
                </tr>
              </tbody>
            </table>
            <h3>O‘zbekistondan parvoz jadvali</h3>
            <p>Air Astana O‘zbekistondan to‘g‘ridan-to‘g‘ri yoki ulanishli reyslar taklif etadi:</p>
            <ul>
              <li>
                <b>Toshkent (TAS):</b> Olmaota yoki Astana (haftada bir necha marta)
              </li>
              <li>
                <b>Samarqand (SKD):</b> mavsumiy reyslar (aniq ma’lumotni biletbor.me saytidan bilib oling)
              </li>
            </ul>
            <p>Ushbu reyslardan keyin Moskvaga (aviabilet moskva), Sankt-Peterburgga (aviabilet sankt peterburg) yoki boshqa yo‘nalishlarga uchishni <a href="https://biletbor.me" target="_blank" rel="noreferrer">biletbor.me</a> saytida davom ettirish mumkin.</p>
            <h3>Xulosa</h3>
            <p>Air Astana — Qozog‘istonning zamonaviy va jadal rivojlanayotgan aviakompaniyasi bo‘lib, O‘zbekiston hamda dunyoning boshqa ko‘plab shaharlariga qulay reyslar taqdim etadi. Agar siz qulaylik va maqbul aviabilet narxlarini qidirsangiz, Air Astana reyslariga e’tibor berishingiz mumkin.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Страна: </h4>
            <p>Казахстан</p> 
            <h4>Штаб-квартира: </h4> 
            <p>Алматы</p> 
            <h4>Основной хаб: </h4>   
            <p>Международные аэропорты Алматы и Астаны
              Air Astana осуществляет рейсы в страны СНГ, Азии, Ближнего Востока и Европы, давая пассажирам возможность сравнивать aviabilet moskva и aviabilet sankt peterburg с другими направлениями
            </p>
            <h4>Вебсайт:</h4>
            <a href="https://www.airastana.com" target="_blank" rel="noreferrer">www.airastana.com</a>
          `,
        },
      ],
    },
    flyaristan: {
      pageKey: "flyaristanInfo",
      imageUrl: "/images/AK/FS.png",
      generalInfo: [
        {
          content: `<article>
            <h1>FlyAirstan</h1>
            <h2>Asos solingan sana va tarixi</h2>
            <p>FlyAirstan — 2020-yilda tashkil etilgan Oʻzbekiston aviakompaniyasi boʻlib, kompaniya Almatida joylashgan va Oʻzbekiston ichida, shuningdek Markaziy Osiyo va Yaqin Sharq davlatlariga xalqaro parvozlarni amalga oshiradi. FlyAirstan arzon sayohatlarni taklif etadi va yoʻlovchilarga qulay narxlarda aviachiptalarni taqdim etadi.</p>
            <h3>FlyAirstan floti</h3>
            <p>Aviakompaniya zamonaviy havo kemalaridan iborat:</p>
            <table>
              <thead>
                <tr>
                  <th>Samolyot turi</th>
                  <th>Miqdori (taxminan)</th>
                  <th>Xususiyatlari</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320</td>
                  <td>~5</td>
                  <td>Oʻrtacha masofali reyslar</td>
                </tr>
                <tr>
                  <td>Airbus A321</td>
                  <td>~3</td>
                  <td>Oʻrtacha masofali reyslar, kengaytirilgan sigʻim bilan</td>
                </tr>
              </tbody>
            </table>
            <h3>Yoʻnalish tarmogʻi</h3>
            <p>FlyAirstan Qozogʻiston ichidagi va xalqaro reyslarni muntazam amalga oshiradi:</p>
            <ul>
              <li><b>Almaty – Nur-Sulton:</b> haftada bir necha marta.</li>
              <li><b>Almaty – Toshkent (TAS):</b> muntazam reyslar.</li>
              <li><b>Almaty – Dubay (DXB):</b> xalqaro reyslar.</li>
            </ul>
            <p>Aktual jadval va chipta bronlash imkoniyatlari aviakompaniyaning rasmiy veb-saytida mavjud.</p>
            <h3>Xulosa</h3>
            <p>FlyAirstan Oʻzbekistonda va chet elda qulay narxlarda va sifatli xizmat bilan parvozlarni taqdim etadi, yoʻlovchilarga qulay imkoniyatlar yaratadi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4>
            <p>Qozogʻiston</p>
            <h4>Markaz:</h4>
            <p>Almaty</p>
            <h4>Asosiy havo maydoni:</h4>
            <p>Almaty Xalqaro Aeroporti (ALA)</p>
            <h4>Veb-sayt:</h4>
            <a href="https://flyairstan.com" target="_blank" rel="noreferrer">flyairstan.com</a>
          `,
        },
      ],
    },
    aircairo: {
      pageKey: "airCairoInfo",
      imageUrl: "/images/AK/SM.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air Cairo – Misrning arzon aviatashuvchisi</h1>
            <h2>Tashkil topgan yili va qisqacha tarix</h2>
            <p>2003 yilda tashkil etilgan Air Cairo hozirda Misrning eng faol arzon aviakompaniyasi hisoblanadi. U charter va muntazam xalqaro reyslarga ixtisoslashgan.</p>
            <h3>Air Cairo floti</h3>
            <p>Flotning asosiy qismini Airbus A320 samolyotlari tashkil etadi. Ushbu samolyotlar qisqa va o‘rta masofali parvozlar uchun moslashtirilgan.</p>
            <table>
              <thead>
                <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
              </thead>
              <tbody>
                <tr><td>Airbus A320</td><td>~30</td><td>Qisqa va o‘rta masofali yo‘nalishlar</td></tr>
              </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Air Cairo yozgi mavsumda quyidagi yo‘nalishlarda parvozlarni amalga oshiradi:</p>
            <ul>
              <li><b>Toshkent (TAS):</b> haftasiga 1–2 marta — Qohira va Sharm el-Shayxga</li>
              <li><b>Samarkand (SKD):</b> mavsumiy</li>
            </ul>
            <p>Parvozlar va chiptalarni <a href="https://biletbor.me" target="_blank">biletbor.me</a> saytida toping.</p>
            <h3>Xulosa</h3>
            <p>Air Cairo – arzon va qulay parvozlar uchun ajoyib tanlov. Misrga sayohatlar uchun ayni muddao.</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Mamlakat:</h4><p>Misr</p>
            <h4>Bosh ofis:</h4><p>Qohira</p>
            <h4>Asosiy xab:</h4><p>Qohira xalqaro aeroporti (CAI)</p>
            <h4>Veb-sayt:</h4><a href="https://www.flyaircairo.com" target="_blank">flyaircairo.com</a>`,
        },
      ],
    },
    airchina: {
      pageKey: "airChinaInfo",
      imageUrl: "/images/AK/CA.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air China – Xitoyning milliy aviakompaniyasi</h1>
            <h2>Tashkil topgan yili va qisqacha tarix</h2>
            <p>Air China 1988 yilda tashkil etilgan va hozirda Xitoy Xalq Respublikasining rasmiy havo tashuvchisi hisoblanadi. Kompaniya Star Alliance a'zosi bo‘lib, Osiyo, Yevropa va Amerikaga doimiy reyslarni amalga oshiradi.</p>
            <h3>Air China floti</h3>
            <p>Flotda Boeing va Airbus’ning zamonaviy samolyotlari mavjud. Kompaniya qisqa va uzoq masofali reyslarni bajarishga qodir.</p>
            <table>
              <thead>
                <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
              </thead>
              <tbody>
                <tr><td>Boeing 737</td><td>~120</td><td>Ichki va mintaqaviy yo‘nalishlar</td></tr>
                <tr><td>Airbus A330 / A350</td><td>~70</td><td>Xalqaro reyslar</td></tr>
                <tr><td>Boeing 777 / 787</td><td>~60</td><td>Uzoq masofali yo‘nalishlar</td></tr>
              </tbody>
            </table>
            <h3>O‘zbekistondan reyslar</h3>
            <p>Air China Tashkentdan Pekinga reyslarni qayta tikladi:</p>
            <ul>
              <li><b>Toshkent (TAS):</b> haftasiga 2–3 marta</li>
            </ul>
            <p>Chiptalarni <a href="https://biletbor.me" target="_blank">biletbor.me</a> orqali toping.</p>
            <h3>Xulosa</h3>
            <p>Air China – Xitoy va butun Osiyoga qulay aviaparvozlar uchun ishonchli tanlov.</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Mamlakat:</h4><p>Xitoy</p>
            <h4>Bosh ofis:</h4><p>Pekin</p>
            <h4>Asosiy xab:</h4><p>Pekin poytaxt aeroporti (PEK)</p>
            <h4>Veb-sayt:</h4><a href="https://www.airchina.com.cn" target="_blank">www.airchina.com.cn</a>`,
        },
      ],
    },
    airmanas: {
      name: "airmanas",
      pageKey: "airmanasInfo",
      imageUrl: "/images/AK/ZM.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air Manas</h1>
            <h2>Tashkil topgan yili va qisqacha tarix</h2>
            <p>Air Manas — Qirg‘iziston aviakompaniyasi bo‘lib, 2006-yilda faoliyatini boshlagan. Dastlab ichki va qo‘shni davlatlarga parvoz qilgan kompaniya, hozirda yo‘lovchilarga aviabilet дешевые va qulay shart-sharoitlar taklif qiladi.</p>
            <h3>Air Manas floti</h3>
            <p>Air Manas odatda Boeing 737 turidagi samolyotlardan foydalanadi. Ushbu laynerlar qisqa va o‘rta masofaga mo‘ljallangan bo‘lib, aviabilet narxlari bo‘yicha hamyonbop parvozlarni amalga oshirishga imkon beradi.</p>
            <h3>O‘zbekistondan parvoz jadvali</h3>
            <p>Air Manas O‘zbekistondan:</p>
            <ul>
              <li>
                <b>Toshkent (TAS):</b> Bishkek yo‘nalishida reyslar (mavsumga va talabga qarab o‘zgarishi mumkin)..
              </li>
              <li>
                <b>Boshqa shaharlar: </b>ba’zan mavsumiy yoki charter reyslar ham bo‘lishi mumkin.
              </li>
            </ul>
            <h3>Xulosa</h3>
            <p>Air Manas — Qirg‘iziston va O‘zbekiston o‘rtasida parvozni rejalashtirayotgan yoki iqtisodiy jihatdan aviabilet narxlari qulay bo‘lgan reys qidirayotganlar uchun yaxshi tanlov. biletbor.me orqali tariflarni solishtirish mumkin.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat: </h4>
            <p>Qirg‘iziston</p> 
            <h4>Bosh ofis: </h4> 
            <p>Bishkek</p> 
            <h4>Asosiy xab: </h4>   
            <p>Manas xalqaro aeroporti (FRU)
               Air Manas MDH davlatlari va mintaqadagi boshqa davlatlarga parvozlar amalga oshiradi. Bu aviabilet moskva yoki aviabilet sankt peterburg kabi yo‘nalishlarda ham qulay ulanish imkonini beradi.
            </p>
            <h4>Veb-sayt:</h4>
            <a href="https://www.airmanas.com" target="_blank" rel="noreferrer">www.airmanas.com</a>
          `,
        },
      ],
    },
    asianaAirlines: {
      name: "asianaAirlines",
      pageKey: "asianaAirlinesInfo",
      imageUrl: "/images/AK/OZ.png",
      generalInfo: [
        {
          content: `<article>
            <h1>Asiana Airlines</h1>
            <h2>Asiana Airlines tashkil topgan yili va qisqacha tarix</h2>
            <p>Asiana Airlines — 1988-yilda asos solingan Koreya Respublikasi (Janubiy Koreya)ning yirik aviakompaniyalaridan biri. Kompaniya yuqori darajadagi xizmat va xavfsizlikni ta’minlagani bois e’tibor qozongan, shu jumladan, aviabilet дешевые va turli toifadagi tariflarni O‘zbekiston yo‘nalishiga ham taklif etadi.</p>
            <h3>Flot</h3>
            <p>Asiana Airlines Airbus (A320, A350) va Boeing (B747, B777) samolyotlaridan foydalanadi. Bu turli yo‘nalishlar — qisqa masofadan tortib uzoq masofagacha — uchun qulay. Aviabilet narxlariga ko‘ra, ekonom, biznes yoki birinchi klassni tanlash imkoniyati mavjud.</p>
            <h3>O‘zbekistondan parvoz jadvali</h3>
            <p>Asiana Airlines O‘zbekistondan to‘g‘ridan-to‘g‘ri yoki ulanishli reyslarni taklif qilishi mumkin:</p>
            <ul>
              <li>
                <b>Toshkent (TAS):</b> ko‘pincha Seul (Incheon) orqali (mavsumga qarab).
              </li>
              <li>
                <b>Boshqa shaharlar: </b>mavsumiy charter reyslar bo‘lishi ehtimoli bor.
              </li>
            </ul>
            <h3>Xulosa</h3>
            <p>Asiana Airlines Koreya bozoridagi eng mashhur aviakompaniyalardan biri bo‘lib, O‘zbekiston yo‘lovchilari uchun ham qulay parvozlar taklif qiladi. Agar siz uzoq masofali yoki aviabilet narxlari bo‘yicha tanlovni qidirsangiz, Asiana Airlines’ning rasmiy sayti yoki <a href="https://biletbor.me">biletbor.me</a> sizga yordam beradi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat: </h4>
            <p>Koreya Respublikasi</p> 
            <h4>Bosh ofis: </h4> 
            <p>Seul</p> 
            <h4>Asosiy xab: </h4>   
            <p>Incheon xalqaro aeroporti (ICN)
               Asiana Airlines Seul Gimpo aeroporti va boshqa shaharlardan ham reyslar amalga oshiradi. Bu orqali aviabilet moskva yoki aviabilet sankt peterburg yo‘nalishlarida qulay ulanishlar topish mumkin.
            </p>
            <h4>Vebsayt:</h4>
            <a href="https://www.flyasiana.com" target="_blank" rel="noreferrer">www.flyasiana.com</a>
          `,
        },
      ],
    },
    aviaTraffic: {
      name: "aviaTraffic",
      pageKey: "aviaTrafficInfo",
      imageUrl: "/images/AK/AT.png",
      generalInfo: [
        {
          content: `<article>
            <h1>Avia Traffic Company</h1>
            <h2>Avia Traffic Company tashkil topgan yili va qisqacha tarix</h2>
            <p>Avia Traffic Company — Qirg‘iziston aviakompaniyasi bo‘lib, 2003-yildan buyon faoliyat yuritadi. U bosqichma-bosqich o‘z yo‘nalishlarini kengaytirib, aviabilet дешевые va turli qulay xizmatlarni taqdim etishga intiladi.</p>
            <h3>Flot</h3>
            <p>Avia Traffic Company floti odatda Boeing 737 va Airbus A320 samolyotlaridan iborat:</p>
            <table>
              <thead>
                <tr>
                  <th>Samolyot</th>
                  <th>Xizmat xususiyatlari</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Boeing 737</td>
                  <td>Qisqa va o‘rta masofalardagi yo‘nalishlar uchun</td>
                </tr>
                <tr>
                  <td>Airbus A320</td>
                  <td>Ekonom va biznes-klass, qulay salon</td>
                </tr>
              </tbody>
            </table>
            <h3>O‘zbekistondan parvoz jadvali</h3>
            <p>Avia Traffic Company O‘zbekistondan:</p>
            <ul>
              <li>
                <b>Toshkent (TAS):</b> Bishkek (va qaytish) yo‘nalishida reyslar, mavsumga qarab turli chastota.
              </li>
              <li>
                <b>Boshqa shaharlar: </b>Ba’zan charter yoki mavsumiy reyslar mavjud bo‘lishi mumkin.
              </li>
            </ul>
            <h3>Xulosa</h3>
            <p>Avia Traffic Company — Qirg‘iziston va O‘zbekiston o‘rtasida parvoz qiluvchi qulay aviakompaniya. Agar siz tejamkor aviabilet narxlari va hamyonbop tariflarni qidirsangiz, <a href="https://biletbor.me">biletbor.me</a> orqali ushbu kompaniya reyslarini ko‘rib chiqishingiz mumkin.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat: </h4>
            <p>Qirg‘iziston</p> 
            <h4>Bosh ofis: </h4> 
            <p>Bishkek</p> 
            <h4>Asosiy xab: </h4>   
            <p>Manas xalqaro aeroporti (FRU)
               Kompaniya MDH davlatlariga muntazam va charter reyslar amalga oshiradi. Kelajakda yo‘nalishlar sonini ko‘paytirish rejalari bor, bu esa aviabilet moskva yoki aviabilet sankt peterburg yo‘nalishlarini ham qulay ulanish bilan ta’minlashi mumkin.
            </p>
            <h4>Vebsayt:</h4>
            <a href="https://www.aero.kg/" target="_blank" rel="noreferrer">www.aviatraffic.com</a>
          `,
        },
      ],
    },
    auroraAirlines: {
      pageKey: "auroraAirlinesInfo",
      imageUrl: "/images/AK/HZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Aurora Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Aurora Airlines — Rossiya mintaqaviy aviakompaniyasi, 2013 yilda tashkil etilgan va 2013 yil 8 dekabrda parvozlarni boshlagan. SAT Airlines va Vladivostok Avia birlashuvi natijasida tashkil topgan.</p>
            <h3>Aurora Airlines floti</h3>
            <p>2024 yil holatiga ko‘ra flot tarkibi:</p>
            <table>
                <thead>
                    <tr>
                        <th>Samolyot turi</th>
                        <th>Soni (taxminan)</th>
                        <th>Xususiyatlari</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A319-100</td>
                        <td>8</td>
                        <td>O‘rta masofali samolyot, 128 yo‘lovchi</td>
                    </tr>
                    <tr>
                        <td>Bombardier Dash 8 Q400</td>
                        <td>5</td>
                        <td>Qisqa parvozlar uchun mos turbovintli samolyot</td>
                    </tr>
                    <tr>
                        <td>De Havilland Canada DHC-6 Twin Otter</td>
                        <td>3</td>
                        <td>Qiyin aerodromlar uchun turbovintli samolyot</td>
                    </tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar jadvali</h3>
            <p>Aurora Airlines O‘zbekistondan to‘g‘ridan-to‘g‘ri parvozlar amalga oshirmaydi. Moskva yoki Vladivostok orqali stykovkali reyslarni tavsiya qilamiz.</p>
            <h3>Qisqa xulosa</h3>
            <p>Aurora Airlines Rossiyaning Farqiy Osiyo va Sibir hududlarida yuqori chastotali mintaqaviy parvozlarni taʼminlaydi, lekin O‘zbekistondan to‘g‘ridan-to‘g‘ri reyslar mavjud emas.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4>
            <p>Rossiya</p>
            <h4>Ofis joylashuvi:</h4>
            <p>Yuzhno-Saxalinsk</p>
            <h4>Asosiy hub:</h4>
            <p>Vladivostok (VVO) va Yuzhno-Saxalinsk (UUS) aeroportlari</p>
            <h4>Vebsayt:</h4>
            <a href="https://www.flyaurora.ru" target="_blank" rel="noreferrer">flyaurora.ru</a>`,
        },
      ],
    },
    yamalAirlines: {
      pageKey: "yamalAirlinesInfo",
      imageUrl: "/images/AK/YC.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Yamal Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Yamal Airlines (OAV “Aviasiya transport kompaniyasi “Yamal”) — Rossiya aviakompaniyasi, 1997 yilda tashkil etilgan. Bosh qarorgohi Salyekharde, Yamalo-Nenetskiy avtonom okrugida joylashgan. Mintaqaviy va xalqaro yo‘lovchi parvozlarini amalga oshiradi.</p>
            <h3>Flot</h3>
            <p>2020 yil oktyabr holatiga floting tarkibi:</p>
            <table>
                <thead>
                    <tr>
                        <th>Samolyot turi</th>
                        <th>Soni (taxminan)</th>
                        <th>Xususiyatlari</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A320</td>
                        <td>8</td>
                        <td>O‘rta masofali reyslar</td>
                    </tr>
                    <tr>
                        <td>Airbus A321</td>
                        <td>3</td>
                        <td>O‘rta masofali reyslar</td>
                    </tr>
                    <tr>
                        <td>Sukhoi Superjet 100</td>
                        <td>15</td>
                        <td>Mintaqaviy va o‘rta masofali yo‘nalishlar</td>
                    </tr>
                    <tr>
                        <td>Bombardier CRJ200</td>
                        <td>9</td>
                        <td>Qisqa mintaqaviy reyslar</td>
                    </tr>
                    <tr>
                        <td>Bombardier Challenger 850</td>
                        <td>1</td>
                        <td>VIP turistik reyslar</td>
                    </tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar jadvali</h3>
            <p>Yamal Airlines O‘zbekistondan bevosita parvoz qilmaydi.</p>
            <h3>Qisqa xulosa</h3>
            <p>Yamal Airlines — Yamalo-Nenetskiy avtonom okrugining yetakchi hanaviakompaniyasi, lekin O‘zbekistondan to‘g‘ridan-to‘g‘ri reyslar yo‘q.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
      <h4>Davlat:</h4>
      <p>Rossiya</p>
      <h4>Ofis joylashuvi:</h4>
      <p>Salyekhard</p>
      <h4>Asosiy hub:</h4>
      <p>Tyumen–Roshchino xalqaro aeroporti (TJM)</p>
      <h4>Vebsayt:</h4>
      <a href="https://yamal.aero" target="_blank" rel="noreferrer">www.yamal.aero</a>`,
        },
      ],
    },
    yakutiaAirlines: {
      pageKey: "yakutiaAirlinesInfo",
      imageUrl: "/images/AK/R3.png",
      generalInfo: [
        {
          content: `<article>
            <h1>Yakutia Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>“Yakutia Airlines” 2002 yilda Sakha Avia va Yakut Airlines birlashuvi natijasida tashkil topgan. Kompaniya Respublika Saxa (Yakutiya) mulki hisoblanadi. </p>
            <h3>Flot</h3>
            <p>2025 yil fevral holatiga hava kemalari:</p>
            <table>
                <thead>
                    <tr>
                        <th>Samolyot turi</th>
                        <th>Soni (taxminan)</th>
                        <th>Xususiyatlari</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Boeing 737-700</td>
                        <td>2</td>
                        <td>O‘rta masofali samolyot, 126 yo‘lovchi</td>
                    </tr>
                    <tr>
                        <td>Boeing 737-800</td>
                        <td>2</td>
                        <td>Uzoq masofali parvozlar uchun</td>
                    </tr>
                    <tr>
                        <td>Sukhoi Superjet 100</td>
                        <td>5</td>
                        <td>Mintaqaviy va o‘rta masofali yo‘nalishlar</td>
                    </tr>
                    <tr>
                        <td>Irkut MC-21-300</td>
                        <td>0 (yetkazib berilishi kutilyapti)</td>
                        <td>Kelajakdagi uzoq masofali laynerlar</td>
                    </tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>To‘g‘ridan-to‘g‘ri reyslar yo‘q. Sankt-Peterburg (LED) yoki Moskva (SVO) orqali stykovkali reyslar tavsiya qilinadi.</p>
            <h3>Qisqa xulosa</h3>
            <p>Yakutia Airlines Rossiyaning Farqiy Osiyo va Sibir hududlarini bog‘lovchi asosiy mintaqaviy aviakompaniya, lekin O‘zbekistondan bevosita reyslar mavjud emas.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4>
            <p>Rossiya</p>
            <h4>Bosh qarorgoh:</h4>
            <p>Yakutsk</p>
            <h4>Asosiy hub:</h4>
            <p>Yakutsk aeroporti (YKS)</p>
            <h4>Vebsayt:</h4>
            <a href="https://yakutia.aero" target="_blank" rel="noreferrer">www.yakutia.aero</a>`,
        },
      ],
    },
    rossiyaAirlines: {
      pageKey: "rossiyaAirlinesInfo",
      imageUrl: "/images/AK/FV.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Rossiya Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Rossiya Airlines 1992 yilda Aэрофlot tarkibida tashkil etilgan. 2011–2016 yillarda to‘liq Aэрофlot guruhi tarkibiga kirdi va Rossiyaning asosiy mintaqaviy aviaperevozchisi bo‘ldi.  [oai_citation:1‡Wikipedia](https://en.wikipedia.org/wiki/Rossiya_Airlines)</p>
            <h3>Flot</h3>
            <p>2024 yil sentabr holatiga park tarkibi:</p>
            <table>
                <thead>
                    <tr>
                        <th>Samolyot turi</th>
                        <th>Soni (taxminan)</th>
                        <th>Xususiyatlari</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A319-100</td>
                        <td>18</td>
                        <td>Qisqa va o‘rta masofali yo‘nalishlar</td>
                    </tr>
                    <tr>
                        <td>Airbus A320-200</td>
                        <td>8</td>
                        <td>O‘rta masofali reyslar, yuqori sig‘im</td>
                    </tr>
                    <tr>
                        <td>Boeing 737-800</td>
                        <td>12</td>
                        <td>Eng ommabop tor fuselyajli samolyot</td>
                    </tr>
                    <tr>
                        <td>Sukhoi Superjet 100-95B/LR</td>
                        <td>78</td>
                        <td>Mintaqaviy marshrutlar, dunyodagi eng yirik operator</td>
                    </tr>
                </tbody>
            </table>
            <h3>O‘zbekiston yo‘nalishlari</h3>
            <p>Rossiya Airlines O‘zbekistondan bevosita parvozlarni amalga oshirmaydi. Rossiyaga uchish uchun Moskva (VKO) yoki Sankt-Peterburg (LED) orqali stykovkalar tavsiya etiladi.</p>
            <h3>Qisqa xulosa</h3>
            <p>Rossiya Airlines — Aэрофlot guruhi mintaqaviy aviaperevozchisi bo‘lib, zamonaviy floti bilan tanilgan, ammo O‘zbekistondan to‘g‘ridan-to‘g‘ri parvozlar yo‘q.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4>
            <p>Rossiya</p>
            <h4>Bosh qarorgoh:</h4>
            <p>Sankt-Peterburg</p>
            <h4>Asosiy hub:</h4>
            <p>Pulkovo (LED), Vnukovo (VKO)</p>
            <h4>Vebsayt:</h4>
            <a href="https://www.rossiya-airlines.com" target="_blank" rel="noreferrer">www.rossiya-airlines.com</a>`,
        },
      ],
    },
    nordwindAir: {
      pageKey: "nordwindAirInfo",
      imageUrl: "/images/AK/N4.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Nordwind Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Nordwind Airlines 2008 yilda Pegas Touristik’ning sho‘ba korxonalari tomonidan tashkil etilgan. Bugungi kunda kompaniya Rossiyadagi eng yirik charter aviakompaniyalardan biridir.</p>
            <h3>Nordwind Airlines floti</h3>
            <p>Flot 28 ta zamonaviy samolyotdan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A321-200</td><td>5</td><td>O‘rta masofali reyslar</td></tr>
                    <tr><td>Airbus A330-200/300</td><td>5</td><td>Uzoq masofali reyslar</td></tr>
                    <tr><td>Boeing 737-800</td><td>11</td><td>Charter yo‘nalishlari uchun</td></tr>
                    <tr><td>Boeing 777-200/300</td><td>4</td><td>Keng sig‘im va uzoq parvozlar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar jadvali</h3>
            <p>Yoz mavsumida Toshkent (TAS) – Antaliya va Bodrum yo‘nalishlarida haftasiga 2–3 marta charter reyslar amalga oshiriladi.</p>
            <h3>Qisqa xulosa</h3>
            <p>Nordwind Airlines — zamonaviy floti va keng turistik yo‘nalishlari bilan mashhur Rossiyaning yetakchi charter aviakompaniyasidir.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Rossiya</p>
            <h4>Bosh ofis:</h4><p>Moskva</p>
            <h4>Asosiy havo bandargohi:</h4><p>Sheremetyevo (SVO)</p>
            <h4>Rasmiy vebsayt:</h4><a href="https://nordwindairlines.ru" target="_blank" rel="noreferrer">www.nordwindairlines.ru</a>`,
        },
      ],
    },
    lufthansaAir: {
      pageKey: "lufthansaAirInfo",
      imageUrl: "/images/AK/LH.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Lufthansa</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Lufthansa (Deutsche Lufthansa AG) — Germaniyaning eng yirik va Yevropadagi yetakchi aviakompaniyalaridan biri. 1953 yilda tashkil etilgan, 1955 yilda ilk parvozini amalga oshirgan. Star Alliance alyansining asoschilaridan biri.</p>
            <h3>Lufthansa floti</h3>
            <p>280 dan ortiq samolyotdan iborat zamonaviy flot:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 oilasi</td><td>~150</td><td>Ichki va Yevropa reyslari</td></tr>
                    <tr><td>Airbus A350-900</td><td>~21</td><td>Uzoq masofali, yoqilg‘i tejamkor</td></tr>
                    <tr><td>Boeing 747-8</td><td>~19</td><td>Flagman, interkontinental yo‘nalishlar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar jadvali</h3>
            <p>Lufthansa Toshkent (TAS) — Frankfurt (FRA) yo‘nalishida haftasiga 3–4 marta parvozlarni amalga oshiradi. Yevropa va AQSHga qulay ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Lufthansa — bu ishonchlilik, qulaylik va O‘zbekistondan xalqaro yo‘nalishlar uchun keng imkoniyatlar.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Germaniya</p>
            <h4>Bosh ofis:</h4><p>Kyoln</p>
            <h4>Asosiy hub:</h4><p>Frankfurt aeroporti (FRA)</p>
            <h4>Rasmiy sayt:</h4><a href="https://www.lufthansa.com" target="_blank" rel="noreferrer">www.lufthansa.com</a>`,
        },
      ],
    },
    silkAir: {
      pageKey: "silkAirInfo",
      imageUrl: "/images/AK/MI.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SilkAir</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>SilkAir 1976 yilda Tradewinds Charters nomi bilan tashkil etilgan. 1989 yilda Singapore Airlines’ning mintaqaviy aviakompaniyasiga aylandi. 2021 yilda u Singapore Airlines tarkibiga to‘liq birlashtirildi.</p>
            <h3>SilkAir floti</h3>
            <p>U birlashuvgacha quyidagi samolyotlardan foydalangan:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>17</td><td>Yaqin masofali reyslar</td></tr>
                    <tr><td>Boeing 737 MAX 8</td><td>6</td><td>Zamonaviy va yoqilg‘i tejamkor</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>SilkAir O‘zbekistonga to‘g‘ridan-to‘g‘ri parvozlar amalga oshirmagan, ammo Singapore Airlines orqali ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>SilkAir Singapur aviatsiyasining ajralmas qismi bo‘lib, bugungi kunda uning yo‘nalishlari Singapore Airlines tarkibiga kiritilgan.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Singapur</p>
            <h4>Bosh ofis:</h4><p>Singapur</p>
            <h4>Asosiy hub:</h4><p>Changi aeroporti (SIN)</p>
            <h4>Vebsayt:</h4><a href="https://www.singaporeair.com" target="_blank" rel="noreferrer">www.singaporeair.com</a>`,
        },
      ],
    },
    tajikAir: {
      pageKey: "tajikAirInfo",
      imageUrl: "/images/AK/7J.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Tajik Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Tajik Air — Tojikistonning milliy aviakompaniyasi bo‘lib, 1924 yilda tashkil etilgan. U Markaziy Osiyodagi eng qadimgi aviakompaniyalardan biri hisoblanadi. 2023 yildan boshlab faoliyatini qayta tiklamoqda.</p>
            <h3>Tajik Air floti</h3>
            <p>Flot yangilanish jarayonida. Quyidagi samolyotlardan foydalanilgan:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-300/500</td><td>2</td><td>Mintaqaviy reyslar</td></tr>
                    <tr><td>An-26</td><td>1</td><td>Yuk tashish</td></tr>
                    <tr><td>Yak-40</td><td>-</td><td>Chiqarib tashlangan</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Toshkentdan Dushanbega bevosita parvozlar vaqti-vaqti bilan yoki buyurtma asosida amalga oshiriladi.</p>
            <h3>Qisqa xulosa</h3>
            <p>Tajik Air — uzoq tarixga ega aviakompaniya bo‘lib, Tojikistonni qo‘shni davlatlar bilan bog‘laydi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Tojikiston</p>
            <h4>Bosh ofis:</h4><p>Dushanbe</p>
            <h4>Asosiy hub:</h4><p>Dushanbe xalqaro aeroporti (DYU)</p>
            <h4>Rasmiy sayt:</h4><a href="https://tajikair.tj" target="_blank" rel="noreferrer">www.tajikair.tj</a>`,
        },
      ],
    },
    somonAir: {
      pageKey: "somonAirInfo",
      imageUrl: "/images/AK/SZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Somon Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Somon Air — 2007 yilda tashkil etilgan xususiy Tojikiston aviakompaniyasi. Bu mamlakatda muntazam xalqaro reyslarni yo‘lga qo‘ygan birinchi nodavlat aviakompaniyadir. Asosiy markazi Dushanbeda joylashgan.</p>
            <h3>Somon Air floti</h3>
            <p>2024 yil holatiga ko‘ra aviakompaniya flotida:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>4</td><td>O‘rta masofali yo‘nalishlar</td></tr>
                    <tr><td>Boeing 737-900ER</td><td>2</td><td>Keng sig‘imga ega</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Somon Air Toshkentdan Dushanbega vaqti-vaqti bilan parvozlar amalga oshiradi. Shuningdek, Tojikiston orqali boshqa yo‘nalishlarga tranzit imkoniyati mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Somon Air — zamonaviy flotga ega bo‘lgan va mintaqaviy aloqalarni mustahkamlovchi xususiy aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Tojikiston</p>
            <h4>Bosh ofis:</h4><p>Dushanbe</p>
            <h4>Asosiy hub:</h4><p>Dushanbe xalqaro aeroporti (DYU)</p>
            <h4>Vebsayt:</h4><a href="https://www.somonair.com" target="_blank" rel="noreferrer">www.somonair.com</a>`,
        },
      ],
    },
    kamair: {
      pageKey: "kamairInfo",
      imageUrl: "/images/AK/RQ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Kam Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Kam Air — Afg‘onistondagi birinchi xususiy aviakompaniya bo‘lib, 2003 yilda tashkil etilgan. Uning bosh ofisi Kobul shahrida joylashgan. Aviakompaniya Osiyo va Yaqin Sharqqa doimiy reyslar amalga oshiradi.</p>
            <h3>Kam Air floti</h3>
            <p>2024 yil holatiga floti quyidagilardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A340-300</td><td>2</td><td>Uzoq masofali reyslar</td></tr>
                    <tr><td>Boeing 737-300</td><td>2</td><td>Mintaqaviy parvozlar</td></tr>
                    <tr><td>Boeing 767-300ER</td><td>1</td><td>Xalqaro yo‘nalishlar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Kam Air Toshkentdan Kobulga mavsumiy va charter reyslarni amalga oshiradi.</p>
            <h3>Qisqa xulosa</h3>
            <p>Kam Air — Afg‘onistondagi ishonchli va faol rivojlanayotgan aviakompaniyalardan biri bo‘lib, mintaqaviy hamkorlikka hissa qo‘shmoqda.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Afg‘oniston</p>
            <h4>Bosh ofis:</h4><p>Kobul</p>
            <h4>Asosiy hub:</h4><p>Hamid Karzay xalqaro aeroporti (KBL)</p>
            <h4>Vebsayt:</h4><a href="https://www.kamair.com" target="_blank" rel="noreferrer">www.kamair.com</a>`,
        },
      ],
    },
    ikarAir: {
      pageKey: "ikarAirInfo",
      imageUrl: "/images/AK/IL.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Ikar Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Ikar Air — 2021 yilda Turkiyada tashkil etilgan xususiy aviakompaniya. Kompaniya Markaziy Osiyo va Yaqin Sharqqa yo‘naltirilgan charter va mintaqaviy reyslarga ixtisoslashgan.</p>
            <h3>Ikar Air floti</h3>
            <p>2024 yil holatiga floti kichik, ammo samarali:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Embraer E190</td><td>2</td><td>Qisqa va o‘rta masofali reyslar</td></tr>
                    <tr><td>Boeing 737-700</td><td>1</td><td>Turli yo‘nalishlar uchun mos</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Ikar Air yozgi mavsumda Toshkentdan Antaliya va Bokuga charter reyslar amalga oshirishni rejalashtirmoqda.</p>
            <h3>Qisqa xulosa</h3>
            <p>Ikar Air — mintaqaviy aviatashuvlarga ixtisoslashgan yangi va istiqbolli kompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Turkiya</p>
            <h4>Bosh ofis:</h4><p>Istanbul</p>
            <h4>Asosiy hub:</h4><p>Sabiha Gökçen aeroporti (SAW)</p>
            <h4>Vebsayt:</h4><a href="https://www.ikarair.com" target="_blank" rel="noreferrer">www.ikarair.com</a>`,
        },
      ],
    },
    flydubaiAir: {
      pageKey: "flydubaiAirInfo",
      imageUrl: "/images/AK/FZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>flydubai</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>flydubai — Birlashgan Arab Amirliklarining arzon aviakompaniyasi bo‘lib, 2008 yilda tashkil etilgan va 2009 yildan parvozlarni boshlagan. Kompaniya Emirates bilan yaqindan hamkorlik qiladi va 100 dan ortiq yo‘nalishga xizmat ko‘rsatadi.</p>
            <h3>flydubai floti</h3>
            <p>2024 yil holatiga quyidagicha flot mavjud:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>30+</td><td>Oddiy reyslar uchun</td></tr>
                    <tr><td>Boeing 737 MAX 8</td><td>40+</td><td>Tejamkor va zamonaviy</td></tr>
                    <tr><td>Boeing 737 MAX 9</td><td>~10</td><td>Uzoq masofa uchun</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>flydubai Toshkentdan Dubayga har kuni to‘g‘ridan-to‘g‘ri parvozlarni amalga oshiradi. Shuningdek, Samarqand va boshqa shaharlardan mavsumiy reyslar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>flydubai — O‘zbekistondan Dubay orqali dunyoga qulay va arzon parvozlarni taklif etuvchi ishonchli aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Birlashgan Arab Amirliklari</p>
            <h4>Bosh ofis:</h4><p>Dubay</p>
            <h4>Asosiy hub:</h4><p>Dubay xalqaro aeroporti (DXB), 2-terminal</p>
            <h4>Vebsayt:</h4><a href="https://www.flydubai.com" target="_blank" rel="noreferrer">www.flydubai.com</a>`,
        },
      ],
    },
    kuwaitAirways: {
      pageKey: "kuwaitAirwaysInfo",
      imageUrl: "/images/AK/KU.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Kuwait Airways</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Kuwait Airways — 1954 yilda tashkil etilgan va hozirda davlatga tegishli bo‘lgan milliy aviakompaniyadir. Kompaniya dunyoning 50 dan ortiq mamlakatiga parvozlarni amalga oshiradi.</p>
            <h3>Kuwait Airways floti</h3>
            <p>Floti zamonaviy va energiya tejamkor samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>11</td><td>O‘rta masofa uchun</td></tr>
                    <tr><td>Airbus A330-800neo</td><td>4</td><td>Yuqori qulaylik, uzoq masofa</td></tr>
                    <tr><td>Boeing 777-300ER</td><td>10</td><td>Xalqaro uzoq parvozlar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Toshkentdan Kuvaytga muntazam reyslar mavjud. Kuvayt orqali Hindiston, Yaqin Sharq va Yevropaga ulanishlar amalga oshiriladi.</p>
            <h3>Qisqa xulosa</h3>
            <p>Kuwait Airways — uzoq tarixga ega, zamonaviy flotli va sifatli xizmat ko‘rsatadigan ishonchli Yaqin Sharq aviakompaniyasidir.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Kuvayt</p>
            <h4>Bosh ofis:</h4><p>Kuvayt shahri</p>
            <h4>Asosiy hub:</h4><p>Kuvayt xalqaro aeroporti (KWI)</p>
            <h4>Rasmiy sayt:</h4><a href="https://www.kuwaitairways.com" target="_blank" rel="noreferrer">www.kuwaitairways.com</a>`,
        },
      ],
    },
    emiratesAir: {
      pageKey: "emiratesAirInfo",
      imageUrl: "/images/AK/EK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Emirates</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Emirates — Birlashgan Arab Amirliklarining eng yirik aviakompaniyasi bo‘lib, 1985 yilda tashkil etilgan. Dubayda joylashgan va dunyodagi eng nufuzli aviabrendlardan biri hisoblanadi.</p>
            <h3>Emirates floti</h3>
            <p>2024 yil holatiga kompaniyada quyidagi samolyotlar mavjud:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A380-800</td><td>100+</td><td>Ikki qavatli, yuqori darajadagi qulaylik</td></tr>
                    <tr><td>Boeing 777-300ER</td><td>130+</td><td>Uzoq masofali yo‘nalishlar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Emirates Toshkentdan Dubayga haftasiga 5–7 marta parvoz qiladi. Bu orqali Yevropa, AQSH, Osiyo va Avstraliyaga qulay ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Emirates — global darajadagi xizmat ko‘rsatadigan, O‘zbekistondan dunyoning istalgan nuqtasiga yetib borish imkonini beruvchi yetakchi aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Birlashgan Arab Amirliklari</p>
            <h4>Bosh ofis:</h4><p>Dubay</p>
            <h4>Asosiy hub:</h4><p>Dubay xalqaro aeroporti (DXB), 3-terminal</p>
            <h4>Vebsayt:</h4><a href="https://www.emirates.com" target="_blank" rel="noreferrer">www.emirates.com</a>`,
        },
      ],
    },
    centrumAir: {
      pageKey: "centrumAirInfo",
      imageUrl: "/images/AK/UT.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Centrum Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Centrum Air — 2023 yilda tashkil etilgan yangi O‘zbekiston aviakompaniyasi. Kompaniya arzon narxlar va qulay xizmatlar bilan ichki va xalqaro yo‘nalishlarga ixtisoslashgan.</p>
            <h3>Centrum Air floti</h3>
            <p>Floti hali shakllanish jarayonida:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>2+</td><td>O‘rta masofali reyslar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Centrum Air Toshkentdan viloyatlarga (Nukus, Urganch, Samarqand) hamda Rossiya, Turkiya va Qozog‘istonga parvozlarni amalga oshiradi.</p>
            <h3>Qisqa xulosa</h3>
            <p>Centrum Air — zamonaviy va arzon aviachipta taklif qiluvchi yangi O‘zbekiston aviakompaniyasi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>O‘zbekiston</p>
            <h4>Bosh ofis:</h4><p>Toshkent</p>
            <h4>Asosiy hub:</h4><p>Toshkent xalqaro aeroporti (TAS)</p>
            <h4>Vebsayt:</h4><a href="https://centrum.uz" target="_blank" rel="noreferrer">centrum.uz</a>`,
        },
      ],
    },
    egyptAir: {
      pageKey: "egyptAirInfo",
      imageUrl: "/images/AK/MS.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>EgyptAir</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>EgyptAir — Misrning milliy aviakompaniyasi bo‘lib, 1932 yilda tashkil etilgan. Bu dunyodagi eng qadimiy aviakompaniyalardan biri hisoblanadi. 2008 yildan beri Star Alliance a’zosi hisoblanadi.</p>
            <h3>EgyptAir floti</h3>
            <p>Flotida 65 dan ortiq samolyot mavjud:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A220-300</td><td>12</td><td>Yaqin va o‘rta masofali yo‘nalishlar</td></tr>
                    <tr><td>Airbus A320neo</td><td>8</td><td>Yangi avlod Yevropa yo‘nalishlari</td></tr>
                    <tr><td>Boeing 787-9</td><td>6</td><td>Uzoq masofali zamonaviy samolyot</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>EgyptAir Toshkentdan to‘g‘ridan-to‘g‘ri reyslar amalga oshirmaydi, ammo boshqa shaharlar orqali ulanishlar orqali Misrga va boshqa yo‘nalishlarga yetib borish mumkin.</p>
            <h3>Qisqa xulosa</h3>
            <p>EgyptAir — Afrika qit’asidagi eng yirik aviakompaniyalardan biri bo‘lib, global marshrut tarmog‘iga ega.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Misr</p>
            <h4>Bosh ofis:</h4><p>Qohira</p>
            <h4>Asosiy hub:</h4><p>Qohira xalqaro aeroporti (CAI)</p>
            <h4>Vebsayt:</h4><a href="https://www.egyptair.com" target="_blank" rel="noreferrer">www.egyptair.com</a>`,
        },
      ],
    },
    chinaSouthern: {
      pageKey: "chinaSouthernInfo",
      imageUrl: "/images/AK/CZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>China Southern Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>China Southern Airlines — Osiyodagi eng yirik aviakompaniyalardan biri bo‘lib, 1988 yilda tashkil etilgan. Kompaniyaning bosh ofisi Guanchjou shahrida joylashgan. 2019 yilgacha SkyTeam a’zosi bo‘lgan.</p>
            <h3>China Southern floti</h3>
            <p>600 dan ortiq samolyotdan iborat zamonaviy flot:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 oilasi</td><td>250+</td><td>Ichki va yaqin masofali parvozlar</td></tr>
                    <tr><td>Boeing 777-300ER</td><td>14</td><td>Uzoq masofali reyslar</td></tr>
                    <tr><td>Airbus A350-900</td><td>20+</td><td>Yangi avlod texnologiyasi</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>China Southern Toshkentdan Guanchjouga, Urumchi orqali Pekin, Shanxay va boshqa shaharlar yo‘nalishida parvozlar amalga oshiradi.</p>
            <h3>Qisqa xulosa</h3>
            <p>China Southern — Xitoyning yetakchi aviakompaniyasi bo‘lib, O‘zbekistondan Xitoy va Osiyoning boshqa hududlariga parvozlarni taklif etadi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Xitoy</p>
            <h4>Bosh ofis:</h4><p>Guanchjou</p>
            <h4>Asosiy hub:</h4><p>Guanchjou Bayyun aeroporti (CAN)</p>
            <h4>Vebsayt:</h4><a href="https://www.csair.com" target="_blank" rel="noreferrer">www.csair.com</a>`,
        },
      ],
    },
    pia: {
      pageKey: "piaInfo",
      imageUrl: "/images/AK/PK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Pakistan International Airlines (PIA)</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Pakistan International Airlines — Pokistonning milliy aviakompaniyasi bo‘lib, 1946 yilda tashkil etilgan. Bu Osiyodagi eng qadimgi aviakompaniyalardan biri bo‘lib, 1955 yildan beri xalqaro reyslar amalga oshiradi.</p>
            <h3>PIA floti</h3>
            <p>Floti 30 dan ortiq samolyotdan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>11</td><td>Ichki va yaqin masofali yo‘nalishlar</td></tr>
                    <tr><td>Boeing 777-200ER/-300ER</td><td>9</td><td>Uzoq masofali xalqaro parvozlar</td></tr>
                    <tr><td>ATR 42/72</td><td>12</td><td>Qisqa yo‘nalishlar bo‘yicha parvozlar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>PIA vaqti-vaqti bilan Toshkentdan Pokistonning Islomobod, Lahor va Karachi shaharlariga charter va mavsumiy reyslar amalga oshiradi.</p>
            <h3>Qisqa xulosa</h3>
            <p>PIA — uzoq tarixga ega davlat aviakompaniyasi bo‘lib, O‘zbekiston va Janubiy Osiyo o‘rtasidagi aloqalarni ta’minlaydi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Pokiston</p>
            <h4>Bosh ofis:</h4><p>Karachi</p>
            <h4>Asosiy hub:</h4><p>Jinnah xalqaro aeroporti (KHI)</p>
            <h4>Vebsayt:</h4><a href="https://www.piac.com.pk" target="_blank" rel="noreferrer">www.piac.com.pk</a>`,
        },
      ],
    },
    airblue: {
      pageKey: "airblueInfo",
      imageUrl: "/images/AK/PA.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Airblue</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Airblue — Pokistonning yirik xususiy aviakompaniyalaridan biri bo‘lib, 2003 yilda tashkil etilgan. Kompaniyaning bosh ofisi Islomobodda joylashgan va u raqamli xizmatlar va qulay narxlar bilan mashhur.</p>
            <h3>Airblue floti</h3>
            <p>2024 yil holatiga kompaniya flotida:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>5</td><td>Qisqa va o‘rta masofali yo‘nalishlar</td></tr>
                    <tr><td>Airbus A321</td><td>3</td><td>Keng sig‘imli samolyotlar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Airblue O‘zbekistonga parvozlarni yo‘lga qo‘yishni rejalashtirmoqda. Hozirda BAA va Saudiya Arabistoni orqali tranzit imkoniyatlari mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Airblue — zamonaviy, raqamlashtirilgan xizmatlarni taklif qiluvchi va raqobatbardosh tariflarga ega xususiy aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Pokiston</p>
            <h4>Bosh ofis:</h4><p>Islomobod</p>
            <h4>Asosiy hub:</h4><p>Benazir Bhutto xalqaro aeroporti (ISB)</p>
            <h4>Vebsayt:</h4><a href="https://www.airblue.com" target="_blank" rel="noreferrer">www.airblue.com</a>`,
        },
      ],
    },
    sereneAir: {
      pageKey: "sereneAirInfo",
      imageUrl: "/images/AK/ER.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SereneAir</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>SereneAir — Pokistonda 2016 yilda tashkil etilgan xususiy aviakompaniya. Qisqa vaqt ichida u xizmat sifati va qulaylik darajasi bilan mashhurlikka erishdi. Asosiy ofisi Islomobodda joylashgan.</p>
            <h3>SereneAir floti</h3>
            <p>2024 yil holatiga kompaniya flotida:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>5</td><td>O‘rta masofali yo‘nalishlar uchun</td></tr>
                    <tr><td>Airbus A330-200</td><td>1</td><td>Xalqaro parvozlar uchun keng samolyot</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Hozircha to‘g‘ridan-to‘g‘ri reyslar yo‘q, ammo Islomobod yoki Karachi yo‘nalishida charter reyslar va kelajakdagi yo‘nalishlar muhokama qilinmoqda.</p>
            <h3>Qisqa xulosa</h3>
            <p>SereneAir — sifat va qulaylikka urg‘u beruvchi, markaziy Osiyoga kirishni maqsad qilgan zamonaviy aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Pokiston</p>
            <h4>Bosh ofis:</h4><p>Islomobod</p>
            <h4>Asosiy hub:</h4><p>Benazir Bhutto xalqaro aeroporti (ISB)</p>
            <h4>Vebsayt:</h4><a href="https://www.sereneair.com" target="_blank" rel="noreferrer">www.sereneair.com</a>`,
        },
      ],
    },
    airIndia: {
      pageKey: "airIndiaInfo",
      imageUrl: "/images/AK/AI.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air India</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Air India — Hindistonning milliy aviakompaniyasi bo‘lib, 1932 yilda Tata Airlines nomi bilan tashkil etilgan. 1946 yildan beri Air India nomi bilan faoliyat yuritadi. 2022 yildan Tata Group tarkibiga qaytdi va floti yangilanmoqda.</p>
            <h3>Air India floti</h3>
            <p>2024 yil holatiga kompaniyada quyidagi samolyotlar mavjud:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 oilasi</td><td>70+</td><td>Ichki va mintaqaviy parvozlar</td></tr>
                    <tr><td>Boeing 787</td><td>27</td><td>Uzoq masofali parvozlar uchun</td></tr>
                    <tr><td>Boeing 777</td><td>15</td><td>Yevropa va AQSHga parvozlar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Hozirda Air India Toshkentga to‘g‘ridan-to‘g‘ri parvoz qilmaydi, biroq hamkorlar orqali Deli orqali ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Air India — Hindistonning eng yirik aviakompaniyasi bo‘lib, global yo‘nalishlar va zamonaviy samolyotlar bilan faoliyat yuritmoqda.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Hindiston</p>
            <h4>Bosh ofis:</h4><p>Dehli</p>
            <h4>Asosiy hub:</h4><p>Indira Gandi xalqaro aeroporti (DEL)</p>
            <h4>Vebsayt:</h4><a href="https://www.airindia.com" target="_blank" rel="noreferrer">www.airindia.com</a>`,
        },
      ],
    },
    vistara: {
      pageKey: "vistaraInfo",
      imageUrl: "/images/AK/UK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Vistara</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Vistara — Tata Sons va Singapore Airlines o‘rtasidagi hamkorlik natijasida 2013 yilda tashkil etilgan Hindistonning premium aviakompaniyasi. Parvozlar 2015 yilda boshlangan. Kompaniya sifatli xizmat va zamonaviy yondashuv bilan mashhur.</p>
            <h3>Vistara floti</h3>
            <p>2024 yil holatiga flot quyidagilardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>45+</td><td>Ichki va mintaqaviy yo‘nalishlar</td></tr>
                    <tr><td>Boeing 787-9</td><td>6</td><td>Uzoq masofa, yuqori qulaylik</td></tr>
                    <tr><td>Airbus A321neo</td><td>4</td><td>O‘rta masofali parvozlar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Vistara Toshkentdan to‘g‘ridan-to‘g‘ri parvozlar amalga oshirmaydi, ammo Deli orqali qulay ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Vistara — qulaylik va sifatni birlashtirgan Hindistonning premium aviakompaniyasi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Hindiston</p>
            <h4>Bosh ofis:</h4><p>Gurugram, Haryana</p>
            <h4>Asosiy hub:</h4><p>Indira Gandi xalqaro aeroporti (DEL), Dehli</p>
            <h4>Vebsayt:</h4><a href="https://www.airvistara.com" target="_blank" rel="noreferrer">www.airvistara.com</a>`,
        },
      ],
    },
    gulfAir: {
      pageKey: "gulfAirInfo",
      imageUrl: "/images/AK/GF.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Gulf Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Gulf Air — Bahrayn qirolligining milliy aviakompaniyasi bo‘lib, 1950 yilda tashkil etilgan. Yaqin Sharqdagi eng qadimiy aviakompaniyalardan biri hisoblanadi va global yo‘nalishlarga xizmat ko‘rsatadi.</p>
            <h3>Gulf Air floti</h3>
            <p>2024 yil holatiga flot quyidagilardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>10+</td><td>Qisqa va o‘rta masofali parvozlar</td></tr>
                    <tr><td>Airbus A321neo</td><td>8+</td><td>Kengroq samolyot, ko‘proq yo‘lovchi sig‘imi</td></tr>
                    <tr><td>Boeing 787-9</td><td>7+</td><td>Uzoq masofali yo‘nalishlar, yuqori qulaylik</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Gulf Air O‘zbekistonga parvozlarni yo‘lga qo‘yishni rejalashtirmoqda. Tashkent–Manama yo‘nalishi muhokama qilinmoqda. Hozircha tranzit orqali xizmatlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Gulf Air — Yaqin Sharqdagi ishonchli va qulay xizmat taklif etuvchi zamonaviy aviakompaniyalardan biri.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Bahrayn</p>
            <h4>Bosh ofis:</h4><p>Manama</p>
            <h4>Asosiy hub:</h4><p>Bahrayn xalqaro aeroporti (BAH)</p>
            <h4>Vebsayt:</h4><a href="https://www.gulfair.com" target="_blank" rel="noreferrer">www.gulfair.com</a>`,
        },
      ],
    },
    omanAir: {
      pageKey: "omanAirInfo",
      imageUrl: "/images/AK/WY.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Oman Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Oman Air — Ummon Sultonligining milliy aviakompaniyasi bo‘lib, 1993 yilda tashkil etilgan. Bugungi kunda u yuqori darajadagi xizmat ko‘rsatishi bilan mashhur xalqaro aviakompaniyadir.</p>
            <h3>Oman Air floti</h3>
            <p>2024 yil holatiga flot quyidagi samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800 / MAX</td><td>25+</td><td>Qisqa va o‘rta masofali parvozlar</td></tr>
                    <tr><td>Boeing 787-8 / -9</td><td>10+</td><td>Uzoq masofa, yuqori qulaylik</td></tr>
                    <tr><td>Airbus A330</td><td>bir nechta</td><td>Ishdan chiqarilmoqda</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Hozircha Oman Air Toshkentga to‘g‘ridan-to‘g‘ri parvozlar amalga oshirmaydi, ammo Dubay va Doha orqali Masqatga va undan Yevropa yoki Osiyoga ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Oman Air — arab mehmondo‘stligi va zamonaviy qulaylikni o‘zida mujassam etgan ishonchli aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Ummon</p>
            <h4>Bosh ofis:</h4><p>Masqat</p>
            <h4>Asosiy hub:</h4><p>Masqat xalqaro aeroporti (MCT)</p>
            <h4>Vebsayt:</h4><a href="https://www.omanair.com" target="_blank" rel="noreferrer">www.omanair.com</a>`,
        },
      ],
    },
    salamAir: {
      pageKey: "salamAirInfo",
      imageUrl: "/images/AK/OV.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SalamAir</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>SalamAir — Ummonning birinchi arzon narxli aviakompaniyasi bo‘lib, 2016 yilda tashkil etilgan. Kompaniya qisqa vaqt ichida ichki va xalqaro yo‘nalishlarda kengayib, sifatli va tejamkor xizmatlar ko‘rsatmoqda.</p>
            <h3>SalamAir floti</h3>
            <p>Floti quyidagilardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>6+</td><td>Tejamkor, qisqa va o‘rta masofa</td></tr>
                    <tr><td>Airbus A321neo</td><td>4+</td><td>Kengroq salonga ega, uzoqroq masofalar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>SalamAir Toshkent va Samarqanddan Masqatga mavsumiy va charter reyslarni amalga oshiradi. Shuningdek, Dubay va Karaчiga ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>SalamAir — arzon narxlarda parvoz qilmoqchi bo‘lgan yo‘lovchilar uchun ishonchli tanlovdir.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Ummon</p>
            <h4>Bosh ofis:</h4><p>Masqat</p>
            <h4>Asosiy hub:</h4><p>Masqat xalqaro aeroporti (MCT)</p>
            <h4>Vebsayt:</h4><a href="https://www.salamair.com" target="_blank" rel="noreferrer">www.salamair.com</a>`,
        },
      ],
    },
    iranAsemanAirlines: {
      pageKey: "iranAsemanAirlinesInfo",
      imageUrl: "/images/AK/EP.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Iran Aseman Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Iran Aseman Airlines — Eronning yirik hududiy aviakompaniyalaridan biri bo‘lib, 1980 yilda tashkil etilgan. U asosan Ichki va mintaqaviy yo‘nalishlarda qatnovlarni amalga oshiradi.</p>
            <h3>Floti</h3>
            <p>Floti asosan qisqa masofali samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>ATR 72-500</td><td>5+</td><td>Ichki qisqa masofali yo‘nalishlar</td></tr>
                    <tr><td>Fokker 100</td><td>15+</td><td>Mintaqaviy qatnovlar</td></tr>
                    <tr><td>Airbus A320</td><td>bir necha</td><td>Xalqaro reyslar uchun</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Iran Aseman Airlines Toshkentdan to‘g‘ridan-to‘g‘ri reyslar hozircha amalga oshirmaydi, biroq Tehron yoki Mashhaddagi ulanishlar orqali parvozlar mumkin.</p>
            <h3>Qisqa xulosa</h3>
            <p>Iran Aseman — Eron ichidagi mintaqaviy aloqalarni ta’minlaydigan ishonchli aviakompaniyadir.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Eron</p>
            <h4>Bosh ofis:</h4><p>Tehron</p>
            <h4>Asosiy hub:</h4><p>Mehrabad aeroporti (THR)</p>
            <h4>Vebsayt:</h4><a href="http://www.iaa.ir" target="_blank" rel="noreferrer">www.iaa.ir</a>`,
        },
      ],
    },
    kishAir: {
      pageKey: "kishAirInfo",
      imageUrl: "/images/AK/Y9.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Kish Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Kish Air — 1989 yilda tashkil etilgan Eronning mintaqaviy aviakompaniyasi. Dastlab u faqat Kesh oroliga xizmat ko‘rsatgan, keyinchalik Eronning boshqa hududlari va xalqaro yo‘nalishlarga kengaygan.</p>
            <h3>Kish Air floti</h3>
            <p>Floti qisqa va o‘rta masofali samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>McDonnell Douglas MD-82 / MD-83</td><td>10+</td><td>Ichki parvozlar uchun</td></tr>
                    <tr><td>Fokker 100</td><td>5+</td><td>Mintaqaviy qatnovlar</td></tr>
                    <tr><td>Airbus A321</td><td>bir necha</td><td>Xalqaro reyslar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Kish Air O‘zbekistonga to‘g‘ridan-to‘g‘ri parvoz qilmaydi, ammo Tehron orqali ichki qatnovlar uchun qulay tanlovdir.</p>
            <h3>Qisqa xulosa</h3>
            <p>Kish Air — Eron ichida sayohat qilish uchun ishonchli va maqbul variant, ayniqsa turistik yo‘nalishlarda.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Eron</p>
            <h4>Bosh ofis:</h4><p>Tehron / Kish</p>
            <h4>Asosiy hub:</h4><p>Kish oroli aeroporti (KIH), shuningdek Mehrabad (THR)</p>
            <h4>Vebsayt:</h4><a href="http://www.kishairlines.ir" target="_blank" rel="noreferrer">www.kishairlines.ir</a>`,
        },
      ],
    },
    qeshmAir: {
      pageKey: "qeshmAirInfo",
      imageUrl: "/images/AK/QF.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Qeshm Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Qeshm Air — 1993 yilda tashkil etilgan Eron aviakompaniyasi. Dastlab Keshm oroliga xizmat ko‘rsatish maqsadida ochilgan bo‘lsa-da, hozirda ichki va xalqaro yo‘nalishlarda parvozlar amalga oshiradi.</p>
            <h3>Qeshm Air floti</h3>
            <p>Floti o‘rta masofali samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A300-600</td><td>2+</td><td>Keng samolyot, xalqaro reyslar uchun</td></tr>
                    <tr><td>Fokker 100</td><td>7+</td><td>Ichki va mintaqaviy qatnovlar</td></tr>
                    <tr><td>RJ-85</td><td>bir nechta</td><td>Kichik aeroportlar uchun</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Hozircha to‘g‘ridan-to‘g‘ri reyslar mavjud emas, biroq Tehron orqali ulanishlar va charter reyslar amalga oshirilishi mumkin.</p>
            <h3>Qisqa xulosa</h3>
            <p>Qeshm Air — Eron ichki parvozlari uchun qulay, ishonchli aviakompaniyalardan biri.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Eron</p>
            <h4>Bosh ofis:</h4><p>Tehron</p>
            <h4>Asosiy hub:</h4><p>Mehrabad aeroporti (THR), Keshm aeroporti (GSM)</p>
            <h4>Vebsayt:</h4><a href="http://www.qeshm-air.com" target="_blank" rel="noreferrer">www.qeshm-air.com</a>`,
        },
      ],
    },
    syrianAir: {
      pageKey: "syrianAirInfo",
      imageUrl: "/images/AK/SY.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SyrianAir</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>SyrianAir — Suriya Arab Respublikasining milliy aviakompaniyasi bo‘lib, 1946 yilda tashkil etilgan. Mintaqadagi qiyinchiliklarga qaramay, aviakompaniya ichki va xalqaro parvozlarni davom ettirmoqda.</p>
            <h3>SyrianAir floti</h3>
            <p>Flot hozirda quyidagi samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>2</td><td>Xalqaro yo‘nalishlar uchun</td></tr>
                    <tr><td>Tu-134 / Yak-40</td><td>bir nechta</td><td>Ichki va charter reyslar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Hozircha to‘g‘ridan-to‘g‘ri reyslar yo‘q. Tehron, Istanbul yoki Dubay orqali Damasqqa SyrianAir reyslariga ulanish mumkin.</p>
            <h3>Qisqa xulosa</h3>
            <p>SyrianAir — uzoq tarixga ega milliy aviakompaniya bo‘lib, cheklangan imkoniyatlarga qaramay, parvozlarni davom ettirmoqda.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Suriya</p>
            <h4>Bosh ofis:</h4><p>Damashq</p>
            <h4>Asosiy hub:</h4><p>Damashq xalqaro aeroporti (DAM)</p>
            <h4>Vebsayt:</h4><a href="http://www.syriaair.com" target="_blank" rel="noreferrer">www.syriaair.com</a>`,
        },
      ],
    },
    middleEastAirlines: {
      pageKey: "middleEastAirlinesInfo",
      imageUrl: "/images/AK/ME.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Middle East Airlines (MEA)</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>MEA — Livanning milliy aviakompaniyasi bo‘lib, 1945 yilda tashkil etilgan. SkyTeam alyansining a’zosi bo‘lgan bu kompaniya Yaqin Sharqdagi eng ishonchli aviakompaniyalardan biri hisoblanadi.</p>
            <h3>MEA floti</h3>
            <p>2024 yil holatiga MEA floti quyidagi zamonaviy Airbus samolyotlaridan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo / A321neo</td><td>15+</td><td>Qisqa va o‘rta masofa reyslar</td></tr>
                    <tr><td>Airbus A330-200</td><td>5</td><td>Uzoq masofa yo‘nalishlari — Yevropa va Afrika</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>MEA hozircha Toshkentdan to‘g‘ridan-to‘g‘ri reyslarni amalga oshirmaydi, biroq Istanbul, Doha yoki Dubay orqali ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>MEA — Yevropa va Yaqin Sharqqa qulay sayohat qilish uchun ishonchli tanlov.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Livan</p>
            <h4>Bosh ofis:</h4><p>Beirut</p>
            <h4>Asosiy hub:</h4><p>Rafik Hariri xalqaro aeroporti (BEY)</p>
            <h4>Vebsayt:</h4><a href="https://www.mea.com.lb" target="_blank" rel="noreferrer">www.mea.com.lb</a>`,
        },
      ],
    },
    aircompanyArmenia: {
      pageKey: "aircompanyArmeniaInfo",
      imageUrl: "/images/AK/6A.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Aircompany Armenia</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Aircompany Armenia — Armanistonning milliy aviakompaniyasi bo‘lib, 2015 yil oxirida tashkil etilgan. Birinchi tijorat parvozi 2016 yil aprel oyida amalga oshirilgan. Kompaniya Armanistonni turli davlatlar bilan havo yo‘li orqali bog‘lashni maqsad qilgan.</p>
            <h3>Floti</h3>
            <p>Kompaniya floti quyidagi samolyotdan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-500</td><td>2</td><td>O‘rta masofali reyslar uchun</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Hozircha to‘g‘ridan-to‘g‘ri reyslar mavjud emas. Biroq Tbilisi, Mineralnye Vody yoki Moskva orqali Yerevanga qulay ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Aircompany Armenia — kichik, ammo ishonchli aviakompaniya bo‘lib, Armanistonni xalqaro yo‘nalishlar bilan bog‘laydi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Armaniston</p>
            <h4>Bosh ofis:</h4><p>Yerevan</p>
            <h4>Asosiy hub:</h4><p>Zvartnots xalqaro aeroporti (EVN)</p>
            <h4>Vebsayt:</h4><a href="https://www.armeniaairways.am" target="_blank" rel="noreferrer">www.armeniaairways.am</a>`,
        },
      ],
    },
    arianaAfghanAirlines: {
      pageKey: "arianaAfghanAirlinesInfo",
      imageUrl: "/images/AK/FG.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Ariana Afghan Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Ariana Afghan Airlines — Afg‘onistonning milliy aviakompaniyasi bo‘lib, 1955 yilda tashkil etilgan. Bu mamlakatdagi eng qadimiy aviakompaniya hisoblanadi va Afg‘onistonning xalqaro aviatashuvlarida muhim o‘rin tutadi.</p>
            <h3>Floti</h3>
            <p>2024 yil holatiga flot quyidagi samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-400 / 500</td><td>3+</td><td>Ichki va xalqaro yo‘nalishlar</td></tr>
                    <tr><td>Airbus A310</td><td>1</td><td>Uzoq masofa reyslar (chegaralangan)</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Ayni paytda Ariana Toshkentdan to‘g‘ridan-to‘g‘ri parvozlar bajarmaydi, biroq Kobul orqali ulanishlar mumkin.</p>
            <h3>Qisqa xulosa</h3>
            <p>Ariana Afghan Airlines — Afg‘oniston aviatsiyasi uchun muhim transport vositasi bo‘lib, ichki va mintaqaviy reyslar taklif etadi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Afg'oniston</p>
            <h4>Bosh ofis:</h4><p>Kobul</p>
            <h4>Asosiy hub:</h4><p>Kobul xalqaro aeroporti (KBL)</p>
            <h4>Vebsayt:</h4><a href="http://www.flyariana.com" target="_blank" rel="noreferrer">www.flyariana.com</a>`,
        },
      ],
    },
    georgianAirways: {
      pageKey: "georgianAirwaysInfo",
      imageUrl: "/images/AK/A9.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Georgian Airways</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Georgian Airways — Gruziyaning milliy aviakompaniyasi bo‘lib, 1994 yilda (Airzena nomi bilan) tashkil etilgan. 1999 yildan hozirgi nom bilan faoliyat yuritmoqda. Kompaniya Yevropa, Yaqin Sharq va MDH davlatlariga parvozlar amalga oshiradi.</p>
            <h3>Floti</h3>
            <p>2024 yil holatiga kompaniya quyidagi samolyotlarga ega:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Embraer 190</td><td>3</td><td>O‘rta masofa reyslari, 100 yo‘lovchigacha</td></tr>
                    <tr><td>Boeing 737-700</td><td>1</td><td>Yevropa va Yaqin Sharq reyslari</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Georgian Airways Toshkent–Tbilisi yo‘nalishi bo‘yicha haftasiga 2–3 marotaba reyslar bajaradi (mavsumiy). Yevropaga Tbilisi orqali ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Georgian Airways — O‘zbekiston bilan Janubiy Kavkazni bog‘lovchi ishonchli aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Gruziya</p>
            <h4>Bosh ofis:</h4><p>Tbilisi</p>
            <h4>Asosiy hub:</h4><p>Tbilisi xalqaro aeroporti (TBS)</p>
            <h4>Vebsayt:</h4><a href="https://www.georgian-airways.com" target="_blank" rel="noreferrer">www.georgian-airways.com</a>`,
        },
      ],
    },
    myWayAirlines: {
      pageKey: "myWayAirlinesInfo",
      imageUrl: "/images/AK/MW.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>MyWay Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>MyWay Airlines — 2018 yilda tashkil etilgan xususiy Gruziya aviakompaniyasi. Kompaniya arzon aviachiptalar taklif etadi va MDH hamda Yaqin Sharq yo‘nalishlariga e’tibor qaratadi.</p>
            <h3>Floti</h3>
            <p>2024 yil holatiga flot quyidagilardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>2</td><td>O‘rta masofali, yo‘lovchi tashishga mo‘ljallangan</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>MyWay Airlines avval Toshkent va Samarqanddan Tbilisiga charter reyslar bajargan. 2024 yilda reyslar mavsumiy yoki talabga ko‘ra amalga oshiriladi.</p>
            <h3>Qisqa xulosa</h3>
            <p>MyWay Airlines — Gruziyaga va undan tashqariga byudjet parvozlarni taklif etuvchi moslashuvchan aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Gruziya</p>
            <h4>Bosh ofis:</h4><p>Tbilisi</p>
            <h4>Asosiy hub:</h4><p>Tbilisi xalqaro aeroporti (TBS)</p>
            <h4>Vebsayt:</h4><a href="https://www.mywayairlines.com" target="_blank" rel="noreferrer">www.mywayairlines.com</a>`,
        },
      ],
    },
    koreanAir: {
      pageKey: "koreanAirInfo",
      imageUrl: "/images/AK/KE.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Korean Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Korean Air — Janubiy Koreyaning eng yirik va nufuzli aviakompaniyasi bo‘lib, 1969 yilda tashkil etilgan. Kompaniya SkyTeam alyansiga a’zo va dunyo bo‘ylab yuzlab yo‘nalishlarga parvozlar amalga oshiradi.</p>
            <h3>Floti</h3>
            <p>2024 yil holatiga kompaniya quyidagi samolyotlarga ega:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 777-200/300</td><td>25+</td><td>Uzoq masofali reyslar</td></tr>
                    <tr><td>Airbus A330</td><td>20+</td><td>Osiyo yo‘nalishlari</td></tr>
                    <tr><td>Boeing 747-8i / Airbus A380</td><td>10+</td><td>Eng yirik yo‘nalishlar uchun</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Korean Air Toshkentdan Seulga (Incheon) haftasiga bir necha marta to‘g‘ridan-to‘g‘ri reyslar amalga oshiradi. Osiyo bo‘ylab eng qulay yo‘nalishlardan biri hisoblanadi.</p>
            <h3>Qisqa xulosa</h3>
            <p>Korean Air — yuqori darajadagi xizmat ko‘rsatadigan, to‘g‘ridan-to‘g‘ri reyslari mavjud va global yo‘nalishlar tarmog‘iga ega aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Janubiy Koreya</p>
            <h4>Bosh ofis:</h4><p>Seul</p>
            <h4>Asosiy hub:</h4><p>Incheon xalqaro aeroporti (ICN)</p>
            <h4>Vebsayt:</h4><a href="https://www.koreanair.com" target="_blank" rel="noreferrer">www.koreanair.com</a>`,
        },
      ],
    },
    jazeeraAirways: {
      pageKey: "jazeeraAirwaysInfo",
      imageUrl: "/images/AK/J9.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Jazeera Airways</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Jazeera Airways — 2004 yilda tashkil etilgan va Ko‘rfaz mintaqasidagi birinchi xususiy yo‘lovchi aviakompaniyasi hisoblanadi. Keng yo‘nalishlar tarmog‘i va arzon narxlari bilan mashhur.</p>
            <h3>Floti</h3>
            <p>Kompaniya Airbus A320 va A320neo samolyotlaridan iborat zamonaviy flotga ega:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 / A320neo</td><td>20+</td><td>Yoqilg‘i sarfi past, qisqa va o‘rta masofa reyslar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Jazeera Airways Toshkentdan KXBTga haftasiga bir necha bor to‘g‘ridan-to‘g‘ri reyslarni amalga oshiradi. Shuningdek, boshqa yo‘nalishlarga ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Jazeera Airways — Osiyo va Yaqin Sharqqa arzon va qulay parvozlar uchun ishonchli tanlov.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Kuvayt</p>
            <h4>Bosh ofis:</h4><p>Kuvayt shahri</p>
            <h4>Asosiy hub:</h4><p>Kuvayt xalqaro aeroporti (KWI), 5-terminal</p>
            <h4>Vebsayt:</h4><a href="https://www.jazeeraairways.com" target="_blank" rel="noreferrer">www.jazeeraairways.com</a>`,
        },
      ],
    },
    mahanAir: {
      pageKey: "mahanAirInfo",
      imageUrl: "/images/AK/W5.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Mahan Air</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Mahan Air — 1991 yilda tashkil etilgan Eronning eng yirik xususiy aviakompaniyalaridan biri. Asosiy bazasi Tehronda joylashgan. Aviakompaniya ichki va xalqaro yo‘nalishlarda muntazam qatnovlar amalga oshiradi.</p>
            <h3>Floti</h3>
            <p>Flot quyidagi samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A310 / A300</td><td>20+</td><td>Uzoq masofa va charter reyslar</td></tr>
                    <tr><td>BAe 146</td><td>5+</td><td>Qisqa masofa, kichik aeroportlar</td></tr>
                    <tr><td>Airbus A340</td><td>10+</td><td>Uzoq xalqaro yo‘nalishlar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Mahan Air 2024 yilda Tehronga (IKA) Tashkentdan mavsumiy reyslar amalga oshirmoqda. Tehron orqali Turkiya, Xitoy va Livanga ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Mahan Air — Eronning yirik va ishonchli aviakompaniyasi bo‘lib, O‘zbekiston bilan muntazam aviaaloqalarni ta’minlaydi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Eron</p>
            <h4>Bosh ofis:</h4><p>Tehron</p>
            <h4>Asosiy hub:</h4><p>Imom Xomeyni xalqaro aeroporti (IKA)</p>
            <h4>Vebsayt:</h4><a href="https://www.mahanair.ir" target="_blank" rel="noreferrer">www.mahanair.ir</a>`,
        },
      ],
    },
    indigoAirlines: {
      pageKey: "indigoAirlinesInfo",
      imageUrl: "/images/AK/6E.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>IndiGo Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>IndiGo — Hindistonning eng yirik aviakompaniyasi bo‘lib, 2006 yilda tashkil etilgan. Kompaniya arzon narxlar, muntazamlik va keng yo‘nalishlar tarmog‘i bilan mashhur.</p>
            <h3>Floti</h3>
            <p>IndiGo floti quyidagi samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo / A321neo</td><td>300+</td><td>Qisqa va o‘rta masofa reyslar uchun</td></tr>
                    <tr><td>ATR 72-600</td><td>40+</td><td>Ichki va mintaqaviy yo‘nalishlar uchun</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>2023 yildan boshlab IndiGo Toshkent — Dehli yo‘nalishida muntazam reyslarni amalga oshirmoqda. Hindiston bo‘ylab ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>IndiGo — O‘zbekiston va Hindiston o‘rtasida arzon va ishonchli aviaxizmatlarni taklif etuvchi aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Hindiston</p>
            <h4>Bosh ofis:</h4><p>Gurugram, Haryana</p>
            <h4>Asosiy hub:</h4><p>Indira Gandi xalqaro aeroporti (DEL)</p>
            <h4>Vebsayt:</h4><a href="https://www.goindigo.in" target="_blank" rel="noreferrer">www.goindigo.in</a>`,
        },
      ],
    },
    alrosaAirlines: {
      pageKey: "alrosaAirlinesInfo",
      imageUrl: "/images/AK/6R.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Alrosa Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Alrosa Airlines — Rossiyaning mintaqaviy aviakompaniyasi bo‘lib, 1992 yilda tashkil etilgan. ALROSA kompaniyasiga qarashli bo‘lib, asosan Yaqutiya va Sibir mintaqalariga xizmat ko‘rsatadi.</p>
            <h3>Floti</h3>
            <p>Flot ekstremal sharoitlarga moslashtirilgan samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Tu-154M</td><td>1</td><td>Dunyodagi so‘nggi ishlayotgan Tu-154lardan biri</td></tr>
                    <tr><td>Boeing 737-800</td><td>3+</td><td>O‘rta masofali yo‘nalishlar</td></tr>
                    <tr><td>An-24 / An-38</td><td>5+</td><td>Qisqa uchish-qo‘nish yo‘laklari uchun mos</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Hozircha Alrosa Uzbekistan bilan doimiy reyslar bajarmaydi, biroq mavsumiy charterlar bo‘lishi mumkin.</p>
            <h3>Qisqa xulosa</h3>
            <p>Alrosa — Rossiyaning shimoliy va chekka hududlarini bog‘lovchi ishonchli havo tashuvchisi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Rossiya</p>
            <h4>Bosh ofis:</h4><p>Mirniy, Saxa Respublikasi</p>
            <h4>Asosiy hub:</h4><p>Mirniy aeroporti (MJZ)</p>
            <h4>Vebsayt:</h4><a href="https://www.alrosa.aero" target="_blank" rel="noreferrer">www.alrosa.aero</a>`,
        },
      ],
    },
    turkmenistanAirlines: {
      pageKey: "turkmenistanAirlinesInfo",
      imageUrl: "/images/AK/T5.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Turkmenistan Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Turkmenistan Airlines — 1992 yilda tashkil etilgan va Turkmenistonning yagona milliy aviakompaniyasidir. Kompaniya ichki va xalqaro yo‘nalishlarda parvozlarni amalga oshiradi, jumladan Yevropa, Osiyo va MDH davlatlariga.</p>
            <h3>Floti</h3>
            <p>Flot asosan Boeing samolyotlaridan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-700/800</td><td>10+</td><td>Qisqa va o‘rta masofa yo‘nalishlar</td></tr>
                    <tr><td>Boeing 757-200</td><td>3</td><td>O‘rta masofa reyslar</td></tr>
                    <tr><td>Boeing 777-200LR</td><td>3</td><td>Uzoq masofa yo‘nalishlar — London, Pekin</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Turkmenistan Airlines Tashkent — Ashxobod yo‘nalishida mavsumiy reyslarni amalga oshiradi. Ashxobod orqali boshqa yo‘nalishlarga ham ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Turkmenistan Airlines — Markaziy Osiyoni boshqa mintaqalar bilan bog‘laydigan ishonchli davlat aviakompaniyasi.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Turkmaniston</p>
            <h4>Bosh ofis:</h4><p>Ashxobod</p>
            <h4>Asosiy hub:</h4><p>Ashxobod xalqaro aeroporti (ASB)</p>
            <h4>Vebsayt:</h4><a href="https://turkmenistanairlines.tm" target="_blank" rel="noreferrer">turkmenistanairlines.tm</a>`,
        },
      ],
    },
    saudiaAirlines: {
      pageKey: "saudiaAirlinesInfo",
      imageUrl: "/images/AK/SV.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Saudia Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Saudia — Saudiya Arabistonining milliy aviakompaniyasi bo‘lib, 1945 yilda tashkil etilgan. SkyTeam alyansi a’zosi va mintaqadagi eng yirik aviakompaniyalardan biri hisoblanadi.</p>
            <h3>Floti</h3>
            <p>2024 yil holatiga quyidagi zamonaviy samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 777-300ER</td><td>30+</td><td>Uzoq masofa, yuqori qulaylik</td></tr>
                    <tr><td>Airbus A330</td><td>30+</td><td>Yevropa va Osiyoga reyslar</td></tr>
                    <tr><td>Airbus A320/A321</td><td>50+</td><td>Mintaqaviy va ichki reyslar</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Saudia Toshkentdan Jidda shahriga to‘g‘ridan-to‘g‘ri reyslarni amalga oshiradi, ayniqsa haj va umra mavsumida. Shuningdek, boshqa shaharlar orqali ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Saudia — Saudiya Arabistoniga va undan tashqariga qulay, zamonaviy va xavfsiz parvozlarni taklif qiluvchi milliy aviakompaniya.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Saudiya Arabistoni</p>
            <h4>Bosh ofis:</h4><p>Jidda</p>
            <h4>Asosiy hub:</h4><p>Qirol Abdulaziz xalqaro aeroporti (JED)</p>
            <h4>Vebsayt:</h4><a href="https://www.saudia.com" target="_blank" rel="noreferrer">www.saudia.com</a>`,
        },
      ],
    },
    pegasusAir: {
      pageKey: "pegasusAirInfo",
      imageUrl: "/images/AK/PC.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Pegasus Airlines</h1>
            <h2>Tashkil etilgan sana va tarix</h2>
            <p>Pegasus Airlines — 1990 yilda tashkil etilgan Turkiyaning yirik arzon aviakompaniyasi. Kompaniya Yevropa, Osiyo va Yaqin Sharq bo‘ylab keng yo‘nalishlar tarmog‘iga ega.</p>
            <h3>Floti</h3>
            <p>Floti quyidagi samolyotlardan iborat:</p>
            <table>
                <thead>
                    <tr><th>Samolyot turi</th><th>Soni</th><th>Xususiyatlari</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo / A321neo</td><td>90+</td><td>Yoqilg‘i tejovchi, o‘rta va uzoq masofa</td></tr>
                    <tr><td>Boeing 737-800</td><td>30+</td><td>Qisqa masofa reyslari uchun</td></tr>
                </tbody>
            </table>
            <h3>O‘zbekistondan parvozlar</h3>
            <p>Pegasus Airlines Toshkent — Istanbul (SAW) yo‘nalishi bo‘yicha muntazam reyslar amalga oshiradi. Istanbul orqali boshqa mamlakatlarga ham ulanishlar mavjud.</p>
            <h3>Qisqa xulosa</h3>
            <p>Pegasus — Turkiya va Yevropaga byudjetli, qulay va tez parvozlarni taqdim etuvchi ishonchli tanlov.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Davlat:</h4><p>Turkiya</p>
            <h4>Bosh ofis:</h4><p>Istanbul</p>
            <h4>Asosiy hub:</h4><p>Sabiha Gökçen aeroporti (SAW)</p>
            <h4>Vebsayt:</h4><a href="https://www.flypgs.com" target="_blank" rel="noreferrer">www.flypgs.com</a>`,
        },
      ],
    },
  },
  en: {
    aeroflot: {
      name: "Aeroflot",
      pageKey: "aeroflotInfo",
      imageUrl: "/images/AK/SU.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Aeroflot</h1>
            <h2>Foundation and History</h2>
            <p>Aeroflot (PJSC "Aeroflot – Russian Airlines") is one of the oldest airlines in the world, founded in 1923. Over its long history, it has evolved from a Soviet-era monopoly to a major international carrier, offering flight tickets (aviabilet) for numerous routes, including services to Uzbekistan.</p>
            <h3>Aeroflot Fleet</h3>
            <table>
              <thead>
                <tr>
                  <th>Aircraft Type</th>
                  <th>Approx. Number</th>
                  <th>Key Features</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320/321</td>
                  <td>~100</td>
                  <td>Short- and medium-haul routes</td>
                </tr>
                <tr>
                  <td>Airbus A330</td>
                  <td>~20</td>
                  <td>Long-haul flights, enhanced comfort</td>
                </tr>
                <tr>
                  <td>Boeing 777</td>
                  <td>~20</td>
                  <td>Intercontinental routes, spacious cabins</td>
                </tr>
              </tbody>
            </table>
            <p>Aeroflot operates a modern fleet primarily consisting of Airbus and Boeing aircraft. This includes the short- and medium-haul Airbus A320/321 series, as well as the long-haul Boeing 777 and Airbus A330.</p>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Aeroflot operates direct flights from these Uzbek cities to Moscow (Sheremetyevo):</p>
            <ul>
              <li>
                <b>Tashkent (TAS):</b> typically daily (7 times a week).
              </li>
              <li>
                <b>Samarkand (SKD):</b> 2–3 times a week.
              </li>
              <li>
                <b>Bukhara (BHK):</b> 1–2 times a week.
              </li>
            </ul>
            <p>Check tickets and the latest departure days on the official website or 
            <a href="https://biletbor.me" target="_blank" rel="noreferrer">biletbor.me</a>.</p>
            <h3>Summary</h3>
            <p>Aeroflot combines decades of experience, an extensive route network, and a modern fleet. If you are looking for flight tickets (aviabilet) to Moscow or other destinations, make sure to compare prices and take advantage of available promotions on biletbor.me or through the official website.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4>
            <p>Russia</p>
            <h4>Headquarters:</h4>
            <p>Moscow</p>
            <h4>Main Hub:</h4>
            <p>Sheremetyevo International Airport (Terminals B/C), serving most international and regional flights</p>
            <h4>Website:</h4>
            <a href="https://www.aeroflot.ru" target="_blank" rel="noreferrer">www.aeroflot.ru</a>
          `,
        },
      ],
    },
    uzairways: {
      pageKey: "uzairwaysInfo",
      imageUrl: "/images/AK/HY.svg",
      generalInfo: [
        {
          content: `<article>
            <h1><a href="https://biletbor.me/airlines/uzairways" target="_blank">Uzbekistan Airways</a></h1>
            <h2>Foundation and History</h2>
            <p>Uzbekistan Airways is the national airline of Uzbekistan, established in 1992 following the country’s independence. Since its inception, the airline has expanded its network, offering international and domestic flights at competitive prices with online ticket options (aviabilet).</p>
            <h2>Country of Registration, Headquarters & Hub</h2>
            <p>The airline is registered in Uzbekistan with its headquarters in Tashkent. The main hub is Tashkent International Airport (TAS).</p>
            <h3>Uzbekistan Airways Fleet</h3>
            <p>UzAirways operates a modern fleet of Boeing and Airbus aircraft, suitable for various route types including long-haul, regional and domestic flights.</p>
            <table>
              <thead>
                <tr>
                  <th>Aircraft Type</th>
                  <th>Approximate Number</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Boeing 787 Dreamliner</td>
                  <td>~7</td>
                  <td>Long-haul, high comfort levels</td>
                </tr>
                <tr>
                  <td>Airbus A320neo</td>
                  <td>~10</td>
                  <td>Efficient and reliable for short/medium distances</td>
                </tr>
                <tr>
                  <td>Il-114-100</td>
                  <td>~5</td>
                  <td>Short regional connections</td>
                </tr>
              </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Uzbekistan Airways operates flights from cities such as Tashkent, Samarkand, Urgench, and Bukhara to destinations in Europe, Asia, and the Middle East. Visit our <a href="https://biletbor.me/scoreboard" target="_blank">live scoreboard</a> for real-time schedules.</p>
            <h3>Conclusion</h3>
            <p>Uzbekistan Airways blends national heritage with modern service standards, making it a solid choice for both domestic and international travelers. Compare prices easily via <a href="https://biletbor.me/aviabilet-tashkent">biletbor.me</a>.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4>
            <p>Uzbekistan</p>
            <h4>Headquarters:</h4>
            <p>Tashkent</p>
            <h4>Main hub:</h4>
            <p>Tashkent International Airport (TAS)</p>
            <h4>Website:</h4>
            <a href="https://www.uzairways.com" target="_blank">www.uzairways.com</a>
          `,
        },
      ],
    },
    turkishAirlines: {
      pageKey: "turkishAirlinesInfo",
      imageUrl: "/images/AK/TK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Turkish Airlines – Turkey’s Flag Carrier</h1>
            <h2>Founded and History</h2>
            <p>Turkish Airlines was established in 1933 and is now one of the largest global airlines, flying to over 300 destinations in 120+ countries, based out of Istanbul.</p>
            <h3>Fleet Overview</h3>
            <p>Turkish Airlines operates a large fleet of Airbus and Boeing aircraft for both regional and long-haul flights.</p>
            <table>
              <thead>
                <tr><th>Aircraft Type</th><th>Count</th><th>Highlights</th></tr>
              </thead>
              <tbody>
                <tr><td>Airbus A321</td><td>~90</td><td>European and domestic routes</td></tr>
                <tr><td>Boeing 737</td><td>~80</td><td>Medium-haul flights</td></tr>
                <tr><td>Boeing 777 / A350</td><td>~60</td><td>Long-haul intercontinental travel</td></tr>
              </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Turkish Airlines operates frequent flights to Istanbul from:</p>
            <ul>
              <li><b>Tashkent (TAS):</b> daily</li>
              <li><b>Samarkand (SKD):</b> 3–4 times a week</li>
              <li><b>Fergana (FEG):</b> twice a week</li>
            </ul>
            <p>Check fares and flight times at <a href="https://biletbor.me" target="_blank">biletbor.me</a>.</p>
            <h3>Summary</h3>
            <p>Turkish Airlines offers global access via Istanbul, ideal for connecting flights and travel worldwide from Uzbekistan.</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Turkey</p>
            <h4>Headquarters:</h4><p>Istanbul</p>
            <h4>Main Hub:</h4><p>Istanbul Airport (IST)</p>
            <h4>Website:</h4><a href="https://www.turkishairlines.com" target="_blank">www.turkishairlines.com</a>`,
        },
      ],
    },
    belavia: {
      pageKey: "belaviaInfo",
      imageUrl: "/images/AK/B2.svg",
      generalInfo: [
        {
          content: `<article>
          <h1><a href="https://biletbor.me/airlines/belavia" target="_blank">Belavia</a></h1>
          <h2>Foundation and History</h2>
          <p>Belavia is the national airline of Belarus, established in 1996. After the dissolution of the Soviet Union, Belavia emerged as an independent carrier, growing its international and regional network, especially across Europe, the CIS, and the Middle East.</p>
          <h2>Country of Registration, Headquarters & Main Hub</h2>
          <p>The airline is registered in the Republic of Belarus. Its headquarters is located in Minsk, with the main hub at Minsk National Airport (MSQ).</p>
          <h3>Belavia Fleet</h3>
          <p>Belavia operates a modern fleet consisting of Embraer and Boeing aircraft, suited for short and medium-haul flights.</p>
          <table>
            <thead>
              <tr>
                <th>Aircraft Type</th>
                <th>Approximate Quantity</th>
                <th>Features</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Embraer E195/E175</td>
                <td>~12</td>
                <td>Efficient and ideal for regional routes</td>
              </tr>
              <tr>
                <td>Boeing 737-800/737-300</td>
                <td>~8</td>
                <td>Medium-haul routes</td>
              </tr>
            </tbody>
          </table>
          <h3>Flight Schedule from Uzbekistan</h3>
          <p>Belavia operates direct flights from Tashkent (TAS) to Minsk (MSQ) several times per week. You can find updated schedules and ticket prices on <a href="https://biletbor.me/scoreboard" target="_blank">biletbor.me</a>.</p>
          <h3>Conclusion</h3>
          <p>Belavia is a reliable and convenient airline for traveling between Uzbekistan, Belarus, and Europe. Check and compare ticket prices via <a href="https://biletbor.me/aviabilet-tashkent">biletbor.me</a>.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
          <h4>Country:</h4>
          <p>Belarus</p>
          <h4>Headquarters:</h4>
          <p>Minsk</p>
          <h4>Main Hub:</h4>
          <p>Minsk National Airport (MSQ)</p>
          <h4>Website:</h4>
          <a href="https://www.belavia.by" target="_blank">www.belavia.by</a>
        `,
        },
      ],
    },
    uralairlines: {
      pageKey: "uralairlinesInfo",
      imageUrl: "/images/AK/U6.svg",
      generalInfo: [
        {
          content: `<article>
          <h1><a href="https://biletbor.me/airlines/ural" target="_blank">Ural Airlines</a></h1>
          <h2>Foundation and History</h2>
          <p>Ural Airlines is a Russian airline founded in 1993, originally as part of Aeroflot in Yekaterinburg. It became an independent airline and is now among the largest private carriers in Russia, operating both domestic and international routes.</p>
          <h2>Country of Registration, Headquarters & Hub</h2>
          <p>Registered in Russia, the airline's headquarters is located in Yekaterinburg. Its main hub is Koltsovo Airport (SVX).</p>
          <h3>Ural Airlines Fleet</h3>
          <p>The fleet is primarily composed of narrow-body Airbus aircraft.</p>
          <table>
            <thead>
              <tr>
                <th>Aircraft Type</th>
                <th>Approximate Number</th>
                <th>Features</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Airbus A320</td>
                <td>~25</td>
                <td>Short- and medium-haul routes</td>
              </tr>
              <tr>
                <td>Airbus A321</td>
                <td>~15</td>
                <td>Higher capacity, increased comfort</td>
              </tr>
            </tbody>
          </table>
          <h3>Flight Schedule from Uzbekistan</h3>
          <p>Ural Airlines operates flights from Tashkent, Samarkand, and Urgench to Yekaterinburg, Moscow, and Saint Petersburg. Visit <a href="https://biletbor.me/scoreboard" target="_blank">biletbor.me</a> for the latest schedule.</p>
          <h3>Conclusion</h3>
          <p>Ural Airlines is a reliable choice for traveling across Russia and nearby countries. Compare and book tickets via <a href="https://biletbor.me/aviabilet-tashkent">biletbor.me</a>.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
          <h4>Country:</h4>
          <p>Russia</p>
          <h4>Headquarters:</h4>
          <p>Yekaterinburg</p>
          <h4>Main Hub:</h4>
          <p>Koltsovo Airport (SVX)</p>
          <h4>Website:</h4>
          <a href="https://www.uralairlines.ru" target="_blank">www.uralairlines.ru</a>
        `,
        },
      ],
    },
    s7: {
      pageKey: "s7Info",
      imageUrl: "/images/AK/S7.svg",
      generalInfo: [
        {
          content: `<article>
          <h1><a href="https://biletbor.me/airlines/s7" target="_blank">S7 Airlines</a></h1>
          <h2>Foundation and History</h2>
          <p>S7 Airlines, formerly known as Sibir Airlines, is one of the largest private airlines in Russia. Founded in 1992, the company adopted the S7 brand in 2005 and is a member of the global Oneworld alliance.</p>
          <h2>Country of Registration, Headquarters & Hub</h2>
          <p>The airline is registered in Russia, with its headquarters in Ob, Novosibirsk region. Its main hub is Tolmachevo Airport (OVB).</p>
          <h3>S7 Airlines Fleet</h3>
          <p>The fleet includes modern and fuel-efficient aircraft, primarily Airbus and Embraer models.</p>
          <table>
            <thead>
              <tr>
                <th>Aircraft Type</th>
                <th>Approximate Number</th>
                <th>Features</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Airbus A320neo/A321neo</td>
                <td>~50</td>
                <td>Fuel efficiency, comfort, new technology</td>
              </tr>
              <tr>
                <td>Embraer 170</td>
                <td>~17</td>
                <td>Ideal for regional flights, up to 78 passengers</td>
              </tr>
            </tbody>
          </table>
          <h3>Flight Schedule from Uzbekistan</h3>
          <p>S7 operates regular flights from Tashkent to Novosibirsk, Irkutsk, and Moscow. Check up-to-date schedules at <a href="https://biletbor.me/scoreboard" target="_blank">biletbor.me</a>.</p>
          <h3>Conclusion</h3>
          <p>S7 Airlines offers a high level of service, a modern fleet, and a broad network. An excellent choice for travel within Russia and beyond. Book tickets at <a href="https://biletbor.me/aviabilet-tashkent">biletbor.me</a>.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
          <h4>Country:</h4>
          <p>Russia</p>
          <h4>Headquarters:</h4>
          <p>Ob, Novosibirsk region</p>
          <h4>Main Hub:</h4>
          <p>Tolmachevo Airport (OVB)</p>
          <h4>Website:</h4>
          <a href="https://www.s7.ru" target="_blank">www.s7.ru</a>
        `,
        },
      ],
    },
    qanotsharq: {
      pageKey: "qanotsharqInfo",
      imageUrl: "/images/AK/HH.svg",
      generalInfo: [
        {
          content: `<article>
            <h1><a href="https://biletbor.me/airlines/qanotsharq" target="_blank">Qanot Sharq</a></h1>
            <h2>Foundation and History</h2>
            <p>Qanot Sharq is a private Uzbek airline founded in 1998. It initially operated charter flights but has recently expanded into regular scheduled services both domestically and internationally.</p>
            <h2>Country of Registration, Headquarters & Main Hub</h2>
            <p>The airline is registered in Uzbekistan, with its headquarters in Tashkent. Its main hub is Tashkent International Airport (TAS).</p>
            <h3>Qanot Sharq Fleet</h3>
            <p>The airline operates modern narrow-body aircraft suitable for short and medium-haul routes.</p>
            <table>
              <thead>
                <tr>
                  <th>Aircraft Type</th>
                  <th>Approximate Number</th>
                  <th>Features</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320</td>
                  <td>~2</td>
                  <td>Modern cabin with comfortable seating</td>
                </tr>
              </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Qanot Sharq operates flights from Tashkent to cities in Kazakhstan, the UAE, Turkey, and other countries. View the latest schedule at <a href="https://biletbor.me/scoreboard" target="_blank">biletbor.me</a>.</p>
            <h3>Conclusion</h3>
            <p>Qanot Sharq is a fast-growing Uzbek airline offering safe and convenient flights. Book tickets online at <a href="https://biletbor.me/aviabilet-tashkent">biletbor.me</a>.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4>
            <p>Uzbekistan</p>
            <h4>Headquarters:</h4>
            <p>Tashkent</p>
            <h4>Main Hub:</h4>
            <p>Tashkent International Airport (TAS)</p>
            <h4>Website:</h4>
            <a href="https://qanotsharq.com" target="_blank">www.qanotsharq.com</a>
          `,
        },
      ],
    },
    pobeda: {
      pageKey: "pobedaInfo",
      imageUrl: "/images/AK/DP.svg",
      generalInfo: [
        {
          content: `<article>
            <h1><a href="https://biletbor.me/airlines/pobeda" target="_blank">Pobeda Airlines</a></h1>
            <h2>Foundation and History</h2>
            <p>Pobeda is a Russian low-cost airline and a subsidiary of Aeroflot Group. Founded in 2014, the airline quickly gained popularity for offering affordable flights across Russia and neighboring countries.</p>
            <h2>Country of Registration, Headquarters & Hub</h2>
            <p>The airline is registered in Russia, with its headquarters in Moscow. Its main hub is Vnukovo Airport (VKO).</p>
            <h3>Pobeda Fleet</h3>
            <p>Pobeda operates a single-type fleet of Boeing 737-800 aircraft, ideal for low-cost, short- to medium-haul routes.</p>
            <table>
              <thead>
                <tr>
                  <th>Aircraft Type</th>
                  <th>Approximate Number</th>
                  <th>Features</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Boeing 737-800</td>
                  <td>~41</td>
                  <td>High-density layout, low-cost configuration</td>
                </tr>
              </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Pobeda operates direct budget flights from Tashkent to Moscow (Vnukovo). Check the schedule at <a href="https://biletbor.me/scoreboard" target="_blank">biletbor.me</a>.</p>
            <h3>Conclusion</h3>
            <p>Pobeda is a solid choice for budget-conscious travelers. Book cheap tickets from Uzbekistan on <a href="https://biletbor.me/aviabilet-tashkent">biletbor.me</a> and fly affordably.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4>
            <p>Russia</p>
            <h4>Headquarters:</h4>
            <p>Moscow</p>
            <h4>Main Hub:</h4>
            <p>Vnukovo Airport (VKO)</p>
            <h4>Website:</h4>
            <a href="https://www.pobeda.aero" target="_blank">www.pobeda.aero</a>
          `,
        },
      ],
    },
    airastana: {
      pageKey: "airastanaInfo",
      imageUrl: "/images/AK/KC.svg",
      generalInfo: [
        {
          content: `<article>
            <h1><a href="https://biletbor.me/airlines/airastana" target="_blank">Air Astana</a></h1>
            <h2>Foundation and History</h2>
            <p>Air Astana is the national airline of Kazakhstan, founded in 2001. Since its inception, it has grown to become the leading carrier in Central Asia, known for its service quality and modern fleet.</p>
            <h2>Country of Registration, Headquarters & Main Hub</h2>
            <p>The airline is registered in Kazakhstan. Its headquarters is located in Almaty, with primary hubs in Almaty International Airport (ALA) and Astana International Airport (NQZ).</p>
            <h3>Air Astana Fleet</h3>
            <p>Air Astana operates a fleet of Airbus, Boeing, and Embraer aircraft serving both domestic and international destinations.</p>
            <table>
              <thead>
                <tr>
                  <th>Aircraft Type</th>
                  <th>Approximate Number</th>
                  <th>Features</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Airbus A320/A321neo</td>
                  <td>~20</td>
                  <td>Medium-haul, fuel-efficient, modern interiors</td>
                </tr>
                <tr>
                  <td>Boeing 767</td>
                  <td>~3</td>
                  <td>Long-haul, comfortable seating</td>
                </tr>
                <tr>
                  <td>Embraer E190-E2</td>
                  <td>~5</td>
                  <td>Regional connectivity, reliable for short routes</td>
                </tr>
              </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Air Astana operates regular flights from Tashkent to Almaty and Astana. Check live schedules at <a href="https://biletbor.me/scoreboard" target="_blank">biletbor.me</a>.</p>
            <h3>Conclusion</h3>
            <p>Air Astana is a trusted choice for travel across Kazakhstan and beyond. Enjoy seamless service and modern aircraft. Book your ticket via <a href="https://biletbor.me/aviabilet-tashkent">biletbor.me</a>.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4>
            <p>Kazakhstan</p>
            <h4>Headquarters:</h4>
            <p>Almaty</p>
            <h4>Main Hubs:</h4>
            <p>Almaty (ALA) and Astana (NQZ) airports</p>
            <h4>Website:</h4>
            <a href="https://airastana.com" target="_blank">www.airastana.com</a>
          `,
        },
      ],
    },
    flyaristan: {
      pageKey: "flyaristanInfo",
      imageUrl: "/images/AK/7L.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>FlyArystan</h1>
            <h2>Founding Date and History</h2>
            <p>FlyArystan is Kazakhstan’s first low-cost airline, founded in 2018 as a subsidiary of Air Astana. Since April 2019, it has offered affordable airline tickets on domestic and nearby international routes, including flights to Uzbekistan.</p>
            <h3>Fleet</h3>
            <p>FlyArystan’s fleet consists exclusively of modern narrow-body Airbus A320neo aircraft, which reduce fuel costs and keep fares low.</p>
            <table>
                <thead>
                    <tr>
                        <th>Aircraft Type</th>
                        <th>Quantity (approx.)</th>
                        <th>Features</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A320neo</td>
                        <td>~20</td>
                        <td>Low fares, high fuel efficiency</td>
                    </tr>
                </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>FlyArystan currently operates flights from Tashkent to the following Kazakh cities:</p>
            <ul>
                <li><b>Tashkent (TAS) — Almaty (ALA):</b> 3 times per week.</li>
                <li><b>Tashkent (TAS) — Nur-Sultan (NQZ):</b> 2 times per week.</li>
            </ul>
            <p>Check the current schedule and book at the official website: <a href="https://flyarystan.com" target="_blank" rel="noreferrer">flyarystan.com</a>.</p>
            <h3>Brief Conclusion</h3>
            <p>FlyArystan offers low fares and a modern Airbus A320neo fleet — an excellent choice for budget travel between Uzbekistan and Kazakhstan.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4>
            <p>Kazakhstan</p>
            <h4>Headquarters:</h4>
            <p>Almaty</p>
            <h4>Main Hub:</h4>
            <p>Almaty International Airport (ALA)</p>
            <h4>Website:</h4>
            <a href="https://flyarystan.com" target="_blank" rel="noreferrer">flyarystan.com</a>`,
        },
      ],
    },
    aircairo: {
      pageKey: "airCairoInfo",
      imageUrl: "/images/AK/SM.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air Cairo – Egypt’s Low-Cost Carrier</h1>
            <h2>Founded and Overview</h2>
            <p>Air Cairo, founded in 2003, is Egypt’s leading low-cost airline. It specializes in international charters and scheduled flights across the Middle East, Central Asia, and Europe.</p>
            <h3>Fleet</h3>
            <p>The airline operates a modern fleet of Airbus A320 aircraft, optimized for regional and medium-haul operations.</p>
            <table>
              <thead>
                <tr><th>Aircraft Type</th><th>Count</th><th>Features</th></tr>
              </thead>
              <tbody>
                <tr><td>Airbus A320</td><td>~30</td><td>Short- and medium-haul routes</td></tr>
              </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Air Cairo offers charter flights to Egypt from Uzbekistan during peak travel seasons:</p>
            <ul>
              <li><b>Tashkent (TAS):</b> 1–2 times weekly to Cairo and Sharm El-Sheikh</li>
              <li><b>Samarkand (SKD):</b> seasonal</li>
            </ul>
            <p>Tickets available at <a href="https://biletbor.me" target="_blank">biletbor.me</a>.</p>
            <h3>Summary</h3>
            <p>Air Cairo is a convenient and affordable option for flying to Egypt — great for tourists and travelers from Uzbekistan.</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Egypt</p>
            <h4>Headquarters:</h4><p>Cairo</p>
            <h4>Main Hub:</h4><p>Cairo International Airport (CAI)</p>
            <h4>Website:</h4><a href="https://www.flyaircairo.com" target="_blank">www.flyaircairo.com</a>`,
        },
      ],
    },
    airchina: {
      pageKey: "airChinaInfo",
      imageUrl: "/images/AK/CA.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air China – Flag Carrier of the People's Republic of China</h1>
            <h2>Foundation and Overview</h2>
            <p>Air China was established in 1988 and is China’s national airline. It is a member of Star Alliance and connects Beijing to major cities in Asia, Europe, and North America.</p>
            <h3>Fleet Overview</h3>
            <p>Air China operates both narrow-body and wide-body aircraft including Boeing 737, 777, 787, and Airbus A330 and A350 models.</p>
            <table>
              <thead>
                <tr><th>Aircraft Type</th><th>Count</th><th>Use Case</th></tr>
              </thead>
              <tbody>
                <tr><td>Boeing 737</td><td>~120</td><td>Regional and domestic routes</td></tr>
                <tr><td>Airbus A330 / A350</td><td>~70</td><td>Medium and long-haul routes</td></tr>
                <tr><td>Boeing 777 / 787</td><td>~60</td><td>Long-haul international flights</td></tr>
              </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Air China has resumed flights from Tashkent:</p>
            <ul>
              <li><b>Tashkent (TAS):</b> 2–3 times a week to Beijing</li>
            </ul>
            <p>Book online at <a href="https://biletbor.me" target="_blank">biletbor.me</a>.</p>
            <h3>Summary</h3>
            <p>Air China offers smooth and reliable connections between Uzbekistan and China, with global access via Beijing.</p>
            </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>China</p>
            <h4>Headquarters:</h4><p>Beijing</p>
            <h4>Main Hub:</h4><p>Beijing Capital International Airport (PEK)</p>
            <h4>Website:</h4><a href="https://www.airchina.com.cn" target="_blank">airchina.com.cn</a>`,
        },
      ],
    },
    airmanas: {
      pageKey: "airmanasInfo",
      imageUrl: "/images/AK/ZM.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air Manas</h1>
            <h2>Founding Date and History</h2>
            <p>Air Manas is Kyrgyzstan’s low-cost airline, founded in 2006 and commencing operations in May 2009 as a joint venture between the Kyrgyz Republic government and Pegasus Airlines. It offers affordable flights on regional routes, including Uzbekistan.</p>
            <h3>Fleet</h3>
            <p>The fleet consists of Boeing 737-800 aircraft, ideal for short- and medium-haul travel.</p>
            <table>
                <thead>
                    <tr>
                        <th>Aircraft Type</th>
                        <th>Quantity (approx.)</th>
                        <th>Features</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Boeing 737-800</td>
                        <td>3</td>
                        <td>High fuel efficiency, comfortable for short sectors</td>
                    </tr>
                </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Air Manas operates flights from Tashkent to Bishkek (Manas Airport):</p>
            <ul>
                <li><b>Tashkent (TAS) — Bishkek (FRU):</b> three times per week.</li>
            </ul>
            <p>Check schedules and book at <a href="https://airmanas.com" target="_blank" rel="noreferrer">airmanas.com</a>.</p>
            <h3>Brief Conclusion</h3>
            <p>Air Manas provides budget-friendly flights between Uzbekistan and Kyrgyzstan on modern Boeing 737-800 aircraft — an excellent choice for cost-conscious travelers.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
                <h4>Country:</h4>
                <p>Kyrgyzstan</p>
                <h4>Headquarters:</h4>
                <p>Bishkek</p>
                <h4>Main Hub:</h4>
                <p>Manas International Airport (FRU)</p>
                <h4>Website:</h4>
                <a href="https://airmanas.com" target="_blank" rel="noreferrer">airmanas.com</a>`,
        },
      ],
    },
    asianaAirlines: {
      pageKey: "asianaAirlinesInfo",
      imageUrl: "/images/AK/OZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Asiana Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Asiana Airlines is South Korea’s second-largest carrier, founded in February 1988. It has since grown into an international airline serving Asia, Europe, and North America, including regular flights to Uzbekistan.</p>
            <h3>Fleet</h3>
            <p>The fleet comprises modern Airbus and Boeing aircraft:</p>
            <table>
                <thead>
                    <tr>
                        <th>Aircraft Type</th>
                        <th>Quantity (approx.)</th>
                        <th>Features</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A321</td>
                        <td>~50</td>
                        <td>Short- and medium-haul routes</td>
                    </tr>
                    <tr>
                        <td>Airbus A330</td>
                        <td>~20</td>
                        <td>Long-haul flights</td>
                    </tr>
                    <tr>
                        <td>Boeing 777</td>
                        <td>~20</td>
                        <td>Intercontinental routes</td>
                    </tr>
                    <tr>
                        <td>Boeing 787</td>
                        <td>~10</td>
                        <td>New long-haul liners</td>
                    </tr>
                </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Asiana Airlines operates direct flights from Tashkent to Seoul (Incheon) three times per week:</p>
            <ul>
                <li><b>Monday:</b> flight OZ574 departs 21:40 — arrives 07:30 (+1).</li>
                <li><b>Wednesday:</b> flight OZ574.</li>
                <li><b>Friday:</b> flight OZ574.</li>
            </ul>
            <p>Check schedules and book at the official website: <a href="https://flyasiana.com" target="_blank" rel="noreferrer">flyasiana.com</a>.</p>
            <h3>Brief Conclusion</h3>
            <p>Asiana Airlines offers comfortable and reliable flights between Uzbekistan and South Korea on a modern fleet.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
                <h4>Country:</h4>
                <p>South Korea</p>
                <h4>Headquarters:</h4>
                <p>Seoul</p>
                <h4>Main Hub:</h4>
                <p>Incheon International Airport (ICN)</p>
                <h4>Website:</h4>
                <a href="https://flyasiana.com" target="_blank" rel="noreferrer">flyasiana.com</a>`,
        },
      ],
    },
    aviaTraffic: {
      pageKey: "aviaTrafficInfo",
      imageUrl: "/images/AK/YK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Avia Traffic Company</h1>
            <h2>Founding Date and History</h2>
            <p>Avia Traffic Company is a Kyrgyz airline founded in 2003. Headquartered in Bishkek with its main hub at Manas International Airport, it operates scheduled passenger flights on domestic and international routes.</p>
            <h3>Fleet</h3>
            <p>As of March 2022, the fleet includes:</p>
            <table>
                <thead>
                    <tr>
                        <th>Aircraft Type</th>
                        <th>Quantity</th>
                        <th>Seating Capacity</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A320-200</td>
                        <td>2</td>
                        <td>180</td>
                    </tr>
                    <tr>
                        <td>Boeing 737-300</td>
                        <td>2</td>
                        <td>149</td>
                    </tr>
                </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Avia Traffic Company does not operate direct flights from Uzbekistan. Passengers can connect via Bishkek or use other carriers on the Tashkent–Bishkek route.</p>
            <h3>Brief Conclusion</h3>
            <p>Avia Traffic Company offers reliable service with a modern fleet and a broad network across Central Asia and Russia.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4>
            <p>Kyrgyzstan</p>
            <h4>Headquarters:</h4>
            <p>Bishkek</p>
            <h4>Main Hub:</h4>
            <p>Manas International Airport (FRU)</p>
            <h4>Website:</h4>
            <a href="http://www.aero.kg" target="_blank" rel="noreferrer">www.aero.kg</a>`,
        },
      ],
    },
    auroraAirlines: {
      pageKey: "auroraAirlinesInfo",
      imageUrl: "/images/AK/HZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Aurora Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Aurora Airlines is a Russian regional carrier established in 2013 and commencing operations on December 8, 2013. It was formed by merging SAT Airlines and Vladivostok Avia under the Sakhalin Region Development Corporation and Aeroflot.</p>
            <h3>Fleet</h3>
            <p>As of 2024, Aurora’s fleet includes:</p>
            <table>
                <thead>
                    <tr>
                        <th>Aircraft Type</th>
                        <th>Quantity (approx.)</th>
                        <th>Features</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A319-100</td>
                        <td>8</td>
                        <td>Medium-haul jets, up to 128 passengers</td>
                    </tr>
                    <tr>
                        <td>Bombardier Dash 8 Q400</td>
                        <td>5</td>
                        <td>Turboprop optimized for short runways</td>
                    </tr>
                    <tr>
                        <td>De Havilland Canada DHC-6 Twin Otter</td>
                        <td>3</td>
                        <td>Turboprop for remote airfields</td>
                    </tr>
                </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Aurora Airlines does not operate direct flights from Uzbekistan. Connections via Moscow or Vladivostok are recommended for travel to Russia’s Far East and Siberia.</p>
            <h3>Brief Conclusion</h3>
            <p>Aurora Airlines specializes in high-frequency regional service across Russia’s Far East and Siberia, but offers no direct international routes from Uzbekistan.</p>
        </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4>
            <p>Russia</p>
            <h4>Headquarters:</h4>
            <p>Yuzhno-Sakhalinsk</p>
            <h4>Main Hub:</h4>
            <p>Vladivostok International Airport (VVO) and Yuzhno-Sakhalinsk (UUS)</p>
            <h4>Website:</h4>
            <a href="https://www.flyaurora.ru" target="_blank" rel="noreferrer">flyaurora.ru</a>`,
        },
      ],
    },
    yamalAirlines: {
      pageKey: "yamalAirlinesInfo",
      imageUrl: "/images/AK/YC.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Yamal Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Yamal Airlines (JSC “Aviation Transport Company Yamal”) is a Russian carrier established in 1997 and headquartered in Salekhard, Yamalo-Nenets Autonomous Okrug. It operates regional and international passenger services.</p>
            <h3>Fleet</h3>
            <p>As of October 2020, the fleet consists of:</p>
            <table>
                <thead>
                    <tr>
                        <th>Aircraft Type</th>
                        <th>Quantity (approx.)</th>
                        <th>Features</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A320</td>
                        <td>8</td>
                        <td>Medium-haul jets</td>
                    </tr>
                    <tr>
                        <td>Airbus A321</td>
                        <td>3</td>
                        <td>Medium-haul jets</td>
                    </tr>
                    <tr>
                        <td>Sukhoi Superjet 100</td>
                        <td>15</td>
                        <td>Regional and medium-haul routes</td>
                    </tr>
                    <tr>
                        <td>Bombardier CRJ200</td>
                        <td>9</td>
                        <td>Short-haul regional flights</td>
                    </tr>
                    <tr>
                        <td>Bombardier Challenger 850</td>
                        <td>1</td>
                        <td>VIP charters</td>
                    </tr>
                </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Yamal Airlines does not operate direct flights from Uzbekistan.</p>
            <h3>Brief Conclusion</h3>
            <p>Yamal Airlines is the leading regional carrier in the Yamalo-Nenets region of Russia, but offers no direct routes from Uzbekistan.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
      <h4>Country:</h4>
      <p>Russia</p>
      <h4>Headquarters:</h4>
      <p>Salekhard</p>
      <h4>Main Hub:</h4>
      <p>Tyumen–Roshchino International Airport (TJM)</p>
      <h4>Website:</h4>
      <a href="https://yamal.aero" target="_blank" rel="noreferrer">yamal.aero</a>`,
        },
      ],
    },
    yakutiaAirlines: {
      pageKey: "yakutiaAirlinesInfo",
      imageUrl: "/images/AK/R3.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Yakutia Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Yakutia Airlines JSC was formed in 2002 by merging Sakha Avia and Yakut Airlines. It is majority-owned by the Republic of Sakha (Yakutia). </p>
            <h3>Fleet</h3>
            <p>As of February 2025, the fleet comprises:</p>
            <table>
                <thead>
                    <tr>
                        <th>Aircraft Type</th>
                        <th>Quantity (approx.)</th>
                        <th>Features</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Boeing 737-700</td>
                        <td>2</td>
                        <td>Medium-haul jets, 126 seats</td>
                    </tr>
                    <tr>
                        <td>Boeing 737-800</td>
                        <td>2</td>
                        <td>Extended range capability</td>
                    </tr>
                    <tr>
                        <td>Sukhoi Superjet 100</td>
                        <td>5</td>
                        <td>Regional and medium-haul routes</td>
                    </tr>
                    <tr>
                        <td>Irkut MC-21-300</td>
                        <td>0 (pending delivery)</td>
                        <td>Future long-range airliners</td>
                    </tr>
                </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>No direct flights from Uzbekistan. Connections via Moscow (SVO) or Novosibirsk (OVB) are recommended.</p>
            <h3>Brief Conclusion</h3>
            <p>Yakutia Airlines is a principal regional carrier of Russia’s Far East and Siberia with a modern fleet, but offers no direct services from Uzbekistan.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4>
            <p>Russia</p>
            <h4>Headquarters:</h4>
            <p>Yakutsk</p>
            <h4>Main Hub:</h4>
            <p>Yakutsk Airport (YKS)</p>
            <h4>Website:</h4>
            <a href="https://yakutia.aero" target="_blank" rel="noreferrer">www.yakutia.aero</a>`,
        },
      ],
    },
    rossiyaAirlines: {
      pageKey: "rossiyaAirlinesInfo",
      imageUrl: "/images/AK/FV.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Rossiya Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Rossiya Airlines was established in 1992 as an Aeroflot subsidiary. From 2011 to 2016 it fully integrated into the Aeroflot Group, becoming its main regional carrier across Russia and neighboring countries.  [oai_citation:2‡Wikipedia](https://en.wikipedia.org/wiki/Rossiya_Airlines)</p>
            <h3>Fleet</h3>
            <p>As of September 2024, the fleet comprises:</p>
            <table>
                <thead>
                    <tr>
                        <th>Aircraft Type</th>
                        <th>Quantity (approx.)</th>
                        <th>Features</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Airbus A319-100</td>
                        <td>18</td>
                        <td>Short- and medium-haul routes</td>
                    </tr>
                    <tr>
                        <td>Airbus A320-200</td>
                        <td>8</td>
                        <td>Medium-haul, higher capacity</td>
                    </tr>
                    <tr>
                        <td>Boeing 737-800</td>
                        <td>12</td>
                        <td>Popular narrow-body for domestic service</td>
                    </tr>
                    <tr>
                        <td>Sukhoi Superjet 100-95B/LR</td>
                        <td>78</td>
                        <td>Regional routes, world’s largest operator</td>
                    </tr>
                </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Rossiya Airlines does not operate direct flights from Uzbekistan. Connections via Moscow (VKO) or St. Petersburg (LED) are recommended.</p>
            <h3>Brief Conclusion</h3>
            <p>Rossiya Airlines is the Aeroflot Group’s main regional carrier with a modern fleet, but offers no direct services from Uzbekistan.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4>
            <p>Russia</p>
            <h4>Headquarters:</h4>
            <p>Saint Petersburg</p>
            <h4>Main Hubs:</h4>
            <p>Pulkovo (LED), Vnukovo (VKO)</p>
            <h4>Website:</h4>
            <a href="https://www.rossiya-airlines.com" target="_blank" rel="noreferrer">www.rossiya-airlines.com</a>`,
        },
      ],
    },
    nordwindAir: {
      pageKey: "nordwindAirInfo",
      imageUrl: "/images/AK/N4.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Nordwind Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Nordwind Airlines was founded in 2008 by subsidiaries of Pegas Touristik. Today, it is one of the top Russian charter airlines serving international vacation destinations.</p>
            <h3>Fleet of Nordwind Airlines</h3>
            <p>The fleet includes 28 aircraft as of 2023:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Quantity</th><th>Features</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A321-200</td><td>5</td><td>Medium-haul flights</td></tr>
                    <tr><td>Airbus A330-200/300</td><td>5</td><td>Long-haul wide-body aircraft</td></tr>
                    <tr><td>Boeing 737-800</td><td>11</td><td>Popular for charter operations</td></tr>
                    <tr><td>Boeing 777-200/300</td><td>4</td><td>High-capacity long-range jets</td></tr>
                </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>During the summer season, Nordwind Airlines operates 2–3 weekly charter flights from Tashkent (TAS) to Antalya and Bodrum.</p>
            <h3>Brief Conclusion</h3>
            <p>Nordwind Airlines is a leading Russian charter airline offering modern aircraft and direct leisure routes from Uzbekistan.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Russia</p>
            <h4>Headquarters:</h4><p>Moscow</p>
            <h4>Main Hub:</h4><p>Sheremetyevo Airport (SVO)</p>
            <h4>Website:</h4><a href="https://nordwindairlines.ru" target="_blank" rel="noreferrer">www.nordwindairlines.ru</a>`,
        },
      ],
    },
    lufthansaAir: {
      pageKey: "lufthansaAirInfo",
      imageUrl: "/images/AK/LH.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Lufthansa</h1>
            <h2>Founding Date and History</h2>
            <p>Lufthansa (Deutsche Lufthansa AG) is Germany’s largest airline and one of Europe’s leading carriers. Founded in 1953, it launched operations in 1955. It is a founding member of Star Alliance.</p>
            <h3>Lufthansa Fleet</h3>
            <p>The fleet includes over 280 aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Quantity</th><th>Features</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 Family</td><td>~150</td><td>European and domestic flights</td></tr>
                    <tr><td>Airbus A350-900</td><td>~21</td><td>Fuel-efficient long-haul</td></tr>
                    <tr><td>Boeing 747-8</td><td>~19</td><td>Flagship for intercontinental routes</td></tr>
                </tbody>
            </table>
            <h3>Flight Schedule from Uzbekistan</h3>
            <p>Lufthansa offers 3–4 weekly flights from Tashkent (TAS) to Frankfurt (FRA), with seamless connections across Europe and to the US.</p>
            <h3>Brief Conclusion</h3>
            <p>Lufthansa combines comfort and reliability for travelers from Uzbekistan heading to Europe and beyond.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Germany</p>
            <h4>Headquarters:</h4><p>Cologne</p>
            <h4>Main Hub:</h4><p>Frankfurt Airport (FRA)</p>
            <h4>Website:</h4><a href="https://www.lufthansa.com" target="_blank" rel="noreferrer">www.lufthansa.com</a>`,
        },
      ],
    },
    silkAir: {
      pageKey: "silkAirInfo",
      imageUrl: "/images/AK/MI.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SilkAir</h1>
            <h2>Founding Date and History</h2>
            <p>SilkAir was established in 1976 as Tradewinds Charters and became the regional wing of Singapore Airlines in 1989. In 2021, it was fully merged into Singapore Airlines.</p>
            <h3>Fleet of SilkAir</h3>
            <p>Before the merger, SilkAir operated the following aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Quantity</th><th>Features</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>17</td><td>Regional narrow-body jets</td></tr>
                    <tr><td>Boeing 737 MAX 8</td><td>6</td><td>Fuel-efficient, modern cabin</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>SilkAir did not operate direct flights from Uzbekistan, but connections via Singapore Airlines are available through Changi Airport.</p>
            <h3>Brief Conclusion</h3>
            <p>SilkAir was a trusted regional carrier in Southeast Asia and is now part of Singapore Airlines’ network.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Singapore</p>
            <h4>Headquarters:</h4><p>Singapore</p>
            <h4>Main Hub:</h4><p>Changi Airport (SIN)</p>
            <h4>Website:</h4><a href="https://www.singaporeair.com" target="_blank" rel="noreferrer">www.singaporeair.com</a>`,
        },
      ],
    },
    tajikAir: {
      pageKey: "tajikAirInfo",
      imageUrl: "/images/AK/7J.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Tajik Air</h1>
            <h2>Founding Date and History</h2>
            <p>Tajik Air is the national airline of Tajikistan, established in 1924. It is one of the oldest airlines in Central Asia and is currently restoring operations since 2023.</p>
            <h3>Tajik Air Fleet</h3>
            <p>The fleet is being modernized, previously including:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-300/500</td><td>2</td><td>Short and medium haul</td></tr>
                    <tr><td>Antonov An-26</td><td>1</td><td>Cargo transport</td></tr>
                    <tr><td>Yak-40 (retired)</td><td>-</td><td>No longer in service</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Non-regular or charter flights operate from Tashkent to Dushanbe. Passengers should confirm schedules in advance.</p>
            <h3>Brief Conclusion</h3>
            <p>Tajik Air is a historic carrier connecting Tajikistan with neighboring countries and re-emerging in the regional aviation market.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Tajikistan</p>
            <h4>Headquarters:</h4><p>Dushanbe</p>
            <h4>Main Hub:</h4><p>Dushanbe International Airport (DYU)</p>
            <h4>Website:</h4><a href="https://tajikair.tj" target="_blank" rel="noreferrer">www.tajikair.tj</a>`,
        },
      ],
    },
    somonAir: {
      pageKey: "somonAirInfo",
      imageUrl: "/images/AK/SZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Somon Air</h1>
            <h2>Founding Date and History</h2>
            <p>Somon Air is a privately owned airline based in Tajikistan, established in 2007. It was the first private airline in the country to operate international flights and is headquartered in Dushanbe.</p>
            <h3>Fleet of Somon Air</h3>
            <p>As of 2024, the fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Quantity</th><th>Features</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>4</td><td>Medium-haul routes</td></tr>
                    <tr><td>Boeing 737-900ER</td><td>2</td><td>High capacity variant</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Somon Air offers occasional flights from Tashkent to Dushanbe, with possible transit connections via Tajikistan to other destinations.</p>
            <h3>Brief Conclusion</h3>
            <p>Somon Air is a growing regional airline connecting Tajikistan with Central Asia and beyond using a modern Boeing fleet.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Tajikistan</p>
            <h4>Headquarters:</h4><p>Dushanbe</p>
            <h4>Main Hub:</h4><p>Dushanbe International Airport (DYU)</p>
            <h4>Website:</h4><a href="https://www.somonair.com" target="_blank" rel="noreferrer">www.somonair.com</a>`,
        },
      ],
    },
    kamair: {
      pageKey: "kamairInfo",
      imageUrl: "/images/AK/RQ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Kam Air</h1>
            <h2>Founding Date and History</h2>
            <p>Kam Air is Afghanistan’s first private airline, founded in 2003. Based in Kabul, it operates domestic and international routes across Asia and the Middle East. The airline has expanded steadily despite challenges in the region.</p>
            <h3>Fleet of Kam Air</h3>
            <p>As of 2024, Kam Air’s fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A340-300</td><td>2</td><td>Long-haul international routes</td></tr>
                    <tr><td>Boeing 737-300</td><td>2</td><td>Regional flights</td></tr>
                    <tr><td>Boeing 767-300ER</td><td>1</td><td>Transcontinental capacity</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Kam Air offers seasonal or chartered flights from Tashkent to Kabul, depending on demand and conditions.</p>
            <h3>Brief Conclusion</h3>
            <p>Kam Air is a key Afghan carrier serving routes throughout the region and rebuilding aviation links with Central Asia.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Afghanistan</p>
            <h4>Headquarters:</h4><p>Kabul</p>
            <h4>Main Hub:</h4><p>Hamid Karzai International Airport (KBL)</p>
            <h4>Website:</h4><a href="https://www.kamair.com" target="_blank" rel="noreferrer">www.kamair.com</a>`,
        },
      ],
    },
    ikarAir: {
      pageKey: "ikarAirInfo",
      imageUrl: "/images/AK/IL.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Ikar Air</h1>
            <h2>Founding Date and History</h2>
            <p>Ikar Air is a private Turkish airline founded in 2021. It focuses on regional and seasonal charter flights across Central Asia and the Middle East. Headquartered in Istanbul, it is expanding operations gradually.</p>
            <h3>Fleet of Ikar Air</h3>
            <p>As of 2024, the fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Quantity</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Embraer E190</td><td>2</td><td>Short- and mid-range routes</td></tr>
                    <tr><td>Boeing 737-700</td><td>1</td><td>Flexible routing</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Ikar Air plans seasonal charter flights from Tashkent to Antalya and Baku. Scheduled flights are under development.</p>
            <h3>Brief Conclusion</h3>
            <p>Ikar Air is a promising regional airline offering flexible and affordable services in growing travel markets.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Turkey</p>
            <h4>Headquarters:</h4><p>Istanbul</p>
            <h4>Main Hub:</h4><p>Sabiha Gökçen Airport (SAW)</p>
            <h4>Website:</h4><a href="https://www.ilkarair.com" target="_blank" rel="noreferrer">www.ilkarair.com</a>`,
        },
      ],
    },
    flydubaiAir: {
      pageKey: "flydubaiAirInfo",
      imageUrl: "/images/AK/FZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>flydubai</h1>
            <h2>Founding Date and History</h2>
            <p>flydubai is a government-owned low-cost airline based in the UAE, established in 2008. It began operations in 2009 and has grown to serve over 100 destinations, working closely with Emirates for global connections.</p>
            <h3>flydubai Fleet</h3>
            <p>As of 2024, its fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Features</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>30+</td><td>Standard regional use</td></tr>
                    <tr><td>Boeing 737 MAX 8</td><td>40+</td><td>New generation, fuel-efficient</td></tr>
                    <tr><td>Boeing 737 MAX 9</td><td>~10</td><td>Longer range</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>flydubai offers daily direct flights from Tashkent to Dubai, and seasonal services from Samarkand and other cities.</p>
            <h3>Brief Conclusion</h3>
            <p>flydubai is a smart choice for affordable and reliable travel from Uzbekistan to the UAE and beyond, with Emirates codeshare options.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>United Arab Emirates</p>
            <h4>Headquarters:</h4><p>Dubai</p>
            <h4>Main Hub:</h4><p>Dubai International Airport (DXB), Terminal 2</p>
            <h4>Website:</h4><a href="https://www.flydubai.com" target="_blank" rel="noreferrer">www.flydubai.com</a>`,
        },
      ],
    },
    kuwaitAirways: {
      pageKey: "kuwaitAirwaysInfo",
      imageUrl: "/images/AK/KU.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Kuwait Airways</h1>
            <h2>Founding Date and History</h2>
            <p>Kuwait Airways is the national airline of the State of Kuwait, founded in 1954. Once private, it was soon nationalized and today offers flights to over 50 destinations worldwide, including Europe, Asia, and the Middle East.</p>
            <h3>Fleet of Kuwait Airways</h3>
            <p>The modern and expanding fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>11</td><td>Short & medium-haul</td></tr>
                    <tr><td>Airbus A330-800neo</td><td>4</td><td>Long-range, modern comfort</td></tr>
                    <tr><td>Boeing 777-300ER</td><td>10</td><td>Flagship long-haul aircraft</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Kuwait Airways operates regular flights from Tashkent to Kuwait City with easy connections to India, the Gulf, and Europe.</p>
            <h3>Brief Conclusion</h3>
            <p>Kuwait Airways is a trusted Gulf carrier with a long history, quality service, and a rapidly modernizing fleet.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Kuwait</p>
            <h4>Headquarters:</h4><p>Kuwait City</p>
            <h4>Main Hub:</h4><p>Kuwait International Airport (KWI)</p>
            <h4>Website:</h4><a href="https://www.kuwaitairways.com" target="_blank" rel="noreferrer">www.kuwaitairways.com</a>`,
        },
      ],
    },
    emiratesAir: {
      pageKey: "emiratesAirInfo",
      imageUrl: "/images/AK/EK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Emirates</h1>
            <h2>Founding Date and History</h2>
            <p>Emirates is the largest airline in the United Arab Emirates, founded in 1985. Based in Dubai, it is globally renowned for premium service and operates one of the world's largest fleets of wide-body aircraft.</p>
            <h3>Fleet of Emirates</h3>
            <p>As of 2024, Emirates operates:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A380-800</td><td>100+</td><td>Double-deck, flagship service</td></tr>
                    <tr><td>Boeing 777-300ER</td><td>130+</td><td>Long-haul operations</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Emirates offers direct flights from Tashkent to Dubai 5–7 times per week, with connections to Europe, the USA, Asia, and Australia.</p>
            <h3>Brief Conclusion</h3>
            <p>Emirates is a premium global airline connecting Uzbekistan to the world with unmatched service and comfort.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>United Arab Emirates</p>
            <h4>Headquarters:</h4><p>Dubai</p>
            <h4>Main Hub:</h4><p>Dubai International Airport (DXB), Terminal 3</p>
            <h4>Website:</h4><a href="https://www.emirates.com" target="_blank" rel="noreferrer">www.emirates.com</a>`,
        },
      ],
    },
    centrumAir: {
      pageKey: "centrumAirInfo",
      imageUrl: "/images/AK/UT.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Centrum Air</h1>
            <h2>Founding Date and History</h2>
            <p>Centrum Air is a newly established low-cost airline from Uzbekistan, launched in 2023. Based in Tashkent, it focuses on affordable domestic and international flights with a modern fleet.</p>
            <h3>Fleet of Centrum Air</h3>
            <p>The airline is building its fleet, currently operating:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>2+</td><td>Short and medium-range routes</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Centrum Air operates flights from Tashkent to regions such as Nukus, Samarkand, and Urgench, as well as international destinations in Russia, Turkey, and Kazakhstan.</p>
            <h3>Brief Conclusion</h3>
            <p>Centrum Air is a promising low-cost carrier aiming to expand travel opportunities for Uzbekistani passengers at affordable prices.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Uzbekistan</p>
            <h4>Headquarters:</h4><p>Tashkent</p>
            <h4>Main Hub:</h4><p>Tashkent International Airport (TAS)</p>
            <h4>Website:</h4><a href="https://centrum.uz" target="_blank" rel="noreferrer">centrum.uz</a>`,
        },
      ],
    },
    egyptAir: {
      pageKey: "egyptAirInfo",
      imageUrl: "/images/AK/MS.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>EgyptAir</h1>
            <h2>Founding Date and History</h2>
            <p>EgyptAir is Egypt’s national flag carrier, founded in 1932. One of the oldest airlines in the world, it joined the Star Alliance network in 2008 and operates globally from its base in Cairo.</p>
            <h3>Fleet of EgyptAir</h3>
            <p>Its fleet includes over 65 aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A220-300</td><td>12</td><td>Short-haul efficiency</td></tr>
                    <tr><td>Airbus A320neo</td><td>8</td><td>Fuel-efficient medium range</td></tr>
                    <tr><td>Boeing 787-9 Dreamliner</td><td>6</td><td>Long-haul wide-body</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>EgyptAir offers connections from Tashkent to Cairo via partner hubs, with further destinations across Africa, Europe, and North America.</p>
            <h3>Brief Conclusion</h3>
            <p>EgyptAir is a legacy airline with a strong presence in Africa and a modern fleet offering global connectivity.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Egypt</p>
            <h4>Headquarters:</h4><p>Cairo</p>
            <h4>Main Hub:</h4><p>Cairo International Airport (CAI)</p>
            <h4>Website:</h4><a href="https://www.egyptair.com" target="_blank" rel="noreferrer">www.egyptair.com</a>`,
        },
      ],
    },
    chinaSouthern: {
      pageKey: "chinaSouthernInfo",
      imageUrl: "/images/AK/CZ.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>China Southern Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>China Southern Airlines is one of the largest airlines in Asia, founded in 1988 and headquartered in Guangzhou, China. Formerly part of the SkyTeam alliance, it now operates independently with over 200 destinations worldwide.</p>
            <h3>Fleet of China Southern</h3>
            <p>The airline operates one of the largest fleets in Asia:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 Family</td><td>250+</td><td>Domestic and short-haul routes</td></tr>
                    <tr><td>Boeing 777-300ER</td><td>14</td><td>Flagship long-haul aircraft</td></tr>
                    <tr><td>Airbus A350-900</td><td>20+</td><td>Fuel efficient, new-generation widebody</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>China Southern operates flights from Tashkent to Guangzhou and offers connections via Urumqi to Beijing, Shanghai, and other major cities in China.</p>
            <h3>Brief Conclusion</h3>
            <p>China Southern is a leading Chinese airline providing reliable service and global connectivity for travelers from Uzbekistan.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>China</p>
            <h4>Headquarters:</h4><p>Guangzhou</p>
            <h4>Main Hub:</h4><p>Guangzhou Baiyun International Airport (CAN)</p>
            <h4>Website:</h4><a href="https://www.csair.com" target="_blank" rel="noreferrer">www.csair.com</a>`,
        },
      ],
    },
    pia: {
      pageKey: "piaInfo",
      imageUrl: "/images/AK/PK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Pakistan International Airlines (PIA)</h1>
            <h2>Founding Date and History</h2>
            <p>PIA is Pakistan’s national flag carrier, founded in 1946. One of Asia’s oldest airlines, it launched international operations in 1955 and is headquartered in Karachi.</p>
            <h3>Fleet of PIA</h3>
            <p>As of 2024, PIA operates a mixed fleet of over 30 aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>11</td><td>Domestic and regional routes</td></tr>
                    <tr><td>Boeing 777-200ER/-300ER</td><td>9</td><td>Long-haul international services</td></tr>
                    <tr><td>ATR 42/72</td><td>12</td><td>Short-haul routes</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>PIA operates seasonal or charter flights from Tashkent to cities such as Islamabad, Lahore, and Karachi depending on demand.</p>
            <h3>Brief Conclusion</h3>
            <p>PIA is a historic state-owned airline offering key connections between Pakistan and Central Asia, the Middle East, and beyond.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Pakistan</p>
            <h4>Headquarters:</h4><p>Karachi</p>
            <h4>Main Hub:</h4><p>Jinnah International Airport (KHI)</p>
            <h4>Website:</h4><a href="https://www.piac.com.pk" target="_blank" rel="noreferrer">www.piac.com.pk</a>`,
        },
      ],
    },
    airblue: {
      pageKey: "airblueInfo",
      imageUrl: "/images/AK/PA.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Airblue</h1>
            <h2>Founding Date and History</h2>
            <p>Airblue is one of Pakistan’s leading private airlines, established in 2003. Headquartered in Islamabad, it’s known for digital innovation and affordable domestic and international service.</p>
            <h3>Fleet of Airblue</h3>
            <p>As of 2024, the fleet consists of:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>5</td><td>Short and medium-haul operations</td></tr>
                    <tr><td>Airbus A321</td><td>3</td><td>Higher capacity for regional demand</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Airblue is planning to expand into Central Asia, with potential routes to Tashkent. Currently, indirect connections are available via the UAE and Saudi Arabia.</p>
            <h3>Brief Conclusion</h3>
            <p>Airblue is a progressive private carrier offering affordable flights and digital customer experiences between South and Central Asia.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Pakistan</p>
            <h4>Headquarters:</h4><p>Islamabad</p>
            <h4>Main Hub:</h4><p>Benazir Bhutto International Airport (ISB)</p>
            <h4>Website:</h4><a href="https://www.airblue.com" target="_blank" rel="noreferrer">www.airblue.com</a>`,
        },
      ],
    },
    sereneAir: {
      pageKey: "sereneAirInfo",
      imageUrl: "/images/AK/ER.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SereneAir</h1>
            <h2>Founding Date and History</h2>
            <p>SereneAir is a private Pakistani airline founded in 2016. Known for high-quality service and on-time performance, it quickly gained popularity in the domestic market. Its base is in Islamabad.</p>
            <h3>Fleet of SereneAir</h3>
            <p>As of 2024, the fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>5</td><td>Medium-haul routes with premium comfort</td></tr>
                    <tr><td>Airbus A330-200</td><td>1</td><td>Wide-body for long-haul international flights</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Currently, there are no direct flights from Tashkent, but SereneAir is exploring charter and future scheduled services to Islamabad or Karachi.</p>
            <h3>Brief Conclusion</h3>
            <p>SereneAir is a rising airline in Pakistan with a focus on comfort and quality, preparing to expand into the Central Asian market.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Pakistan</p>
            <h4>Headquarters:</h4><p>Islamabad</p>
            <h4>Main Hub:</h4><p>Benazir Bhutto International Airport (ISB)</p>
            <h4>Website:</h4><a href="https://www.sereneair.com" target="_blank" rel="noreferrer">www.sereneair.com</a>`,
        },
      ],
    },
    airIndia: {
      pageKey: "airIndiaInfo",
      imageUrl: "/images/AK/AI.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Air India</h1>
            <h2>Founding Date and History</h2>
            <p>Air India is the flag carrier of India, founded in 1932 as Tata Airlines. Renamed in 1946, it became a major international airline. In 2022, it rejoined the Tata Group and began fleet modernization.</p>
            <h3>Fleet of Air India</h3>
            <p>As of 2024, the fleet is expanding and includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 family</td><td>70+</td><td>Domestic and short-haul routes</td></tr>
                    <tr><td>Boeing 787 Dreamliner</td><td>27</td><td>Long-haul destinations</td></tr>
                    <tr><td>Boeing 777</td><td>15</td><td>Europe and US flagship services</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Air India does not currently offer direct flights from Tashkent, but connecting routes via partners and hubs to Delhi are available.</p>
            <h3>Brief Conclusion</h3>
            <p>Air India is India’s largest state-owned airline, offering extensive global routes and a growing modern fleet.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>India</p>
            <h4>Headquarters:</h4><p>New Delhi</p>
            <h4>Main Hub:</h4><p>Indira Gandhi International Airport (DEL)</p>
            <h4>Website:</h4><a href="https://www.airindia.com" target="_blank" rel="noreferrer">www.airindia.com</a>`,
        },
      ],
    },
    vistara: {
      pageKey: "vistaraInfo",
      imageUrl: "/images/AK/UK.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Vistara</h1>
            <h2>Founding Date and History</h2>
            <p>Vistara is a premium Indian airline, established in 2013 as a joint venture between Tata Sons and Singapore Airlines. It began operations in 2015 and quickly earned a reputation for comfort and top-tier service.</p>
            <h3>Fleet of Vistara</h3>
            <p>As of 2024, the fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>45+</td><td>Domestic and regional flights</td></tr>
                    <tr><td>Boeing 787-9 Dreamliner</td><td>6</td><td>Long-haul luxury routes</td></tr>
                    <tr><td>Airbus A321neo</td><td>4</td><td>Medium-haul with extended range</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Vistara currently does not operate direct flights from Tashkent, but offers convenient connections via Delhi to major destinations in Asia, Europe, and the Gulf.</p>
            <h3>Brief Conclusion</h3>
            <p>Vistara is India’s premium airline known for its exceptional service, modern fleet, and expanding global reach.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>India</p>
            <h4>Headquarters:</h4><p>Gurugram, Haryana</p>
            <h4>Main Hub:</h4><p>Indira Gandhi International Airport (DEL)</p>
            <h4>Website:</h4><a href="https://www.airvistara.com" target="_blank" rel="noreferrer">www.airvistara.com</a>`,
        },
      ],
    },
    gulfAir: {
      pageKey: "gulfAirInfo",
      imageUrl: "/images/AK/GF.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Gulf Air</h1>
            <h2>Founding Date and History</h2>
            <p>Gulf Air is the national airline of the Kingdom of Bahrain, founded in 1950. It is one of the oldest carriers in the Middle East and serves destinations across Europe, Asia, and Africa from its hub in Manama.</p>
            <h3>Fleet of Gulf Air</h3>
            <p>As of 2024, the fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>10+</td><td>Short- and medium-haul efficiency</td></tr>
                    <tr><td>Airbus A321neo</td><td>8+</td><td>Higher capacity, regional operations</td></tr>
                    <tr><td>Boeing 787-9 Dreamliner</td><td>7+</td><td>Long-haul, premium service</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Gulf Air is considering launching direct Tashkent–Manama flights. Currently, connections are available via partner hubs in Dubai and Delhi.</p>
            <h3>Brief Conclusion</h3>
            <p>Gulf Air is a trusted Gulf carrier with a modern fleet and strategic connections between Central Asia and the world.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Bahrain</p>
            <h4>Headquarters:</h4><p>Manama</p>
            <h4>Main Hub:</h4><p>Bahrain International Airport (BAH)</p>
            <h4>Website:</h4><a href="https://www.gulfair.com" target="_blank" rel="noreferrer">www.gulfair.com</a>`,
        },
      ],
    },
    omanAir: {
      pageKey: "omanAirInfo",
      imageUrl: "/images/AK/WY.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Oman Air</h1>
            <h2>Founding Date and History</h2>
            <p>Oman Air is the national airline of the Sultanate of Oman, founded in 1993. It has grown into a respected full-service carrier known for its hospitality, comfort, and reliability.</p>
            <h3>Fleet of Oman Air</h3>
            <p>As of 2024, Oman Air’s fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800 / MAX</td><td>25+</td><td>Short- and medium-haul operations</td></tr>
                    <tr><td>Boeing 787-8 / -9 Dreamliner</td><td>10+</td><td>Long-haul luxury service</td></tr>
                    <tr><td>Airbus A330</td><td>few remaining</td><td>Being phased out</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>As of now, Oman Air does not operate direct flights from Tashkent, but offers seamless connections via Dubai or Doha to Muscat and onward destinations in Asia and Europe.</p>
            <h3>Brief Conclusion</h3>
            <p>Oman Air combines Arabian hospitality with premium service — ideal for travelers from Uzbekistan heading to the Gulf or beyond.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Oman</p>
            <h4>Headquarters:</h4><p>Muscat</p>
            <h4>Main Hub:</h4><p>Muscat International Airport (MCT)</p>
            <h4>Website:</h4><a href="https://www.omanair.com" target="_blank" rel="noreferrer">www.omanair.com</a>`,
        },
      ],
    },
    salamAir: {
      pageKey: "salamAirInfo",
      imageUrl: "/images/AK/OV.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SalamAir</h1>
            <h2>Founding Date and History</h2>
            <p>SalamAir is Oman’s first low-cost airline, launched in 2016. The airline quickly expanded to serve both domestic and international destinations with a focus on affordability and reliability.</p>
            <h3>Fleet of SalamAir</h3>
            <p>As of 2024, the fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo</td><td>6+</td><td>Fuel-efficient, short/medium-haul</td></tr>
                    <tr><td>Airbus A321neo</td><td>4+</td><td>Longer range, higher capacity</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>SalamAir operates seasonal and charter flights from Tashkent and Samarkand to Muscat. Convenient connections to Dubai, Karachi, and Colombo are also available.</p>
            <h3>Brief Conclusion</h3>
            <p>SalamAir is a reliable budget airline offering Central Asian travelers affordable options to the Gulf region and beyond.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Oman</p>
            <h4>Headquarters:</h4><p>Muscat</p>
            <h4>Main Hub:</h4><p>Muscat International Airport (MCT)</p>
            <h4>Website:</h4><a href="https://www.salamair.com" target="_blank" rel="noreferrer">www.salamair.com</a>`,
        },
      ],
    },
    iranAsemanAirlines: {
      pageKey: "iranAsemanAirlinesInfo",
      imageUrl: "/images/AK/EP.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Iran Aseman Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Iran Aseman Airlines is one of Iran’s leading regional carriers, founded in 1980. Based in Tehran, the airline serves hard-to-reach areas across the country and plays a key role in domestic connectivity.</p>
            <h3>Fleet of Iran Aseman</h3>
            <p>The fleet mainly consists of short- and medium-haul aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>ATR 72-500</td><td>5+</td><td>Short-haul domestic routes</td></tr>
                    <tr><td>Fokker 100</td><td>15+</td><td>Regional service</td></tr>
                    <tr><td>Airbus A320</td><td>several</td><td>Limited international flights</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Currently, there are no direct flights from Uzbekistan, but connections via Tehran or Mashhad are possible through partner routes or charters.</p>
            <h3>Brief Conclusion</h3>
            <p>Iran Aseman Airlines is a key domestic and regional airline in Iran, offering essential services with a modest fleet.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Iran</p>
            <h4>Headquarters:</h4><p>Tehran</p>
            <h4>Main Hub:</h4><p>Mehrabad Airport (THR)</p>
            <h4>Website:</h4><a href="http://www.iaa.ir" target="_blank" rel="noreferrer">www.iaa.ir</a>`,
        },
      ],
    },
    kishAir: {
      pageKey: "kishAirInfo",
      imageUrl: "/images/AK/Y9.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Kish Air</h1>
            <h2>Founding Date and History</h2>
            <p>Kish Air is a regional Iranian airline founded in 1989. Initially focused on serving the island of Kish, it has expanded to offer domestic and some international flights from hubs like Tehran and Mashhad.</p>
            <h3>Fleet of Kish Air</h3>
            <p>The airline operates mostly short- and medium-haul aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>McDonnell Douglas MD-82 / MD-83</td><td>10+</td><td>Domestic use</td></tr>
                    <tr><td>Fokker 100</td><td>5+</td><td>Regional routes</td></tr>
                    <tr><td>Airbus A321</td><td>several</td><td>Used on international flights</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>As of 2024, Kish Air does not operate direct flights from Uzbekistan but can be used for internal connections after arrival in Iran via Tehran or other carriers.</p>
            <h3>Brief Conclusion</h3>
            <p>Kish Air is a dependable regional airline within Iran, offering useful connections to tourist destinations like Kish Island.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Iran</p>
            <h4>Headquarters:</h4><p>Tehran / Kish Island</p>
            <h4>Main Hub:</h4><p>Kish International Airport (KIH), also Tehran Mehrabad (THR)</p>
            <h4>Website:</h4><a href="http://www.kishairlines.ir" target="_blank" rel="noreferrer">www.kishairlines.ir</a>`,
        },
      ],
    },
    qeshmAir: {
      pageKey: "qeshmAirInfo",
      imageUrl: "/images/AK/QF.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Qeshm Air</h1>
            <h2>Founding Date and History</h2>
            <p>Qeshm Air is an Iranian airline founded in 1993. Originally launched to serve Qeshm Island, it has grown to cover a wide range of domestic and select international routes.</p>
            <h3>Fleet of Qeshm Air</h3>
            <p>The fleet is focused on medium-haul service:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A300-600</td><td>2+</td><td>Widebody used for international routes</td></tr>
                    <tr><td>Fokker 100</td><td>7+</td><td>Domestic and regional use</td></tr>
                    <tr><td>RJ-85</td><td>several</td><td>Ideal for small regional airports</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Qeshm Air does not currently operate direct flights from Uzbekistan but offers domestic Iranian services accessible via Tehran or Mashhad.</p>
            <h3>Brief Conclusion</h3>
            <p>Qeshm Air is a flexible and regionally focused Iranian airline, ideal for exploring domestic destinations in Iran.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Iran</p>
            <h4>Headquarters:</h4><p>Tehran</p>
            <h4>Main Hub:</h4><p>Mehrabad Airport (THR), Qeshm Airport (GSM)</p>
            <h4>Website:</h4><a href="http://www.qeshm-air.com" target="_blank" rel="noreferrer">www.qeshm-air.com</a>`,
        },
      ],
    },
    syrianAir: {
      pageKey: "syrianAirInfo",
      imageUrl: "/images/AK/SY.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>SyrianAir</h1>
            <h2>Founding Date and History</h2>
            <p>SyrianAir, officially Syrian Arab Airlines, is the national airline of Syria, founded in 1946. Despite regional challenges, it continues to operate domestic and international flights from Damascus to various destinations.</p>
            <h3>Fleet of SyrianAir</h3>
            <p>The current fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320</td><td>2</td><td>International routes</td></tr>
                    <tr><td>Tupolev Tu-134 / Yak-40</td><td>several</td><td>Domestic and charter operations</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>No direct flights from Uzbekistan are currently operated, but connections to Damascus are possible via Tehran, Istanbul, or Dubai.</p>
            <h3>Brief Conclusion</h3>
            <p>SyrianAir remains a symbol of national air transport in Syria, continuing to serve essential routes with resilience.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Syria</p>
            <h4>Headquarters:</h4><p>Damascus</p>
            <h4>Main Hub:</h4><p>Damascus International Airport (DAM)</p>
            <h4>Website:</h4><a href="http://www.syriaair.com" target="_blank" rel="noreferrer">www.syriaair.com</a>`,
        },
      ],
    },
    middleEastAirlines: {
      pageKey: "middleEastAirlinesInfo",
      imageUrl: "/images/AK/ME.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Middle East Airlines (MEA)</h1>
            <h2>Founding Date and History</h2>
            <p>Middle East Airlines, or MEA, is the national carrier of Lebanon, founded in 1945. A member of the SkyTeam alliance, it is known for reliable service across the Middle East, Europe, and Africa.</p>
            <h3>Fleet of MEA</h3>
            <p>As of 2024, MEA operates a modern Airbus fleet:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo / A321neo</td><td>15+</td><td>Short- and medium-haul routes</td></tr>
                    <tr><td>Airbus A330-200</td><td>5</td><td>Long-haul to Europe and Africa</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>MEA does not currently operate direct flights from Uzbekistan but offers convenient connections to Beirut via Istanbul, Doha, or Dubai through SkyTeam partners.</p>
            <h3>Brief Conclusion</h3>
            <p>MEA is a trusted and prestigious airline, offering smooth travel between Central Asia and the Middle East, Europe, and Africa.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Lebanon</p>
            <h4>Headquarters:</h4><p>Beirut</p>
            <h4>Main Hub:</h4><p>Rafic Hariri International Airport (BEY)</p>
            <h4>Website:</h4><a href="https://www.mea.com.lb" target="_blank" rel="noreferrer">www.mea.com.lb</a>`,
        },
      ],
    },
    aircompanyArmenia: {
      pageKey: "aircompanyArmeniaInfo",
      imageUrl: "/images/AK/6A.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Aircompany Armenia</h1>
            <h2>Founding Date and History</h2>
            <p>Aircompany Armenia is the national carrier of Armenia, established in December 2015. The first commercial flight took place in April 2016. The airline connects Armenia with key regional and international destinations.</p>
            <h3>Fleet of Aircompany Armenia</h3>
            <p>The airline operates a small but reliable fleet:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-500</td><td>2</td><td>Short- and medium-haul routes</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>No direct flights from Uzbekistan as of 2024. However, convenient connections to Yerevan are available via Tbilisi, Moscow, or Mineralnye Vody.</p>
            <h3>Brief Conclusion</h3>
            <p>Aircompany Armenia is a small yet dependable airline linking Armenia with important destinations through reliable regional hubs.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Armenia</p>
            <h4>Headquarters:</h4><p>Yerevan</p>
            <h4>Main Hub:</h4><p>Zvartnots International Airport (EVN)</p>
            <h4>Website:</h4><a href="https://www.armeniaairways.am" target="_blank" rel="noreferrer">www.armeniaairways.am</a>`,
        },
      ],
    },
    arianaAfghanAirlines: {
      pageKey: "arianaAfghanAirlinesInfo",
      imageUrl: "/images/AK/FG.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Ariana Afghan Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Ariana Afghan Airlines is the national flag carrier of Afghanistan, founded in 1955. It is the country’s oldest airline and has played a vital role in connecting Afghanistan with regional and international destinations.</p>
            <h3>Fleet of Ariana</h3>
            <p>As of 2024, the fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-400 / 500</td><td>3+</td><td>Short and medium-haul operations</td></tr>
                    <tr><td>Airbus A310</td><td>1</td><td>Previously used for long-haul routes</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>There are no direct flights from Uzbekistan at the moment, but Ariana offers possible connections via Kabul or regional hubs.</p>
            <h3>Brief Conclusion</h3>
            <p>Ariana Afghan Airlines remains a critical transportation link for Afghanistan, offering basic international and domestic services.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Afghanistan</p>
            <h4>Headquarters:</h4><p>Kabul</p>
            <h4>Main Hub:</h4><p>Kabul International Airport (KBL)</p>
            <h4>Website:</h4><a href="http://www.flyariana.com" target="_blank" rel="noreferrer">www.flyariana.com</a>`,
        },
      ],
    },
    georgianAirways: {
      pageKey: "georgianAirwaysInfo",
      imageUrl: "/images/AK/A9.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Georgian Airways</h1>
            <h2>Founding Date and History</h2>
            <p>Georgian Airways is the national airline of Georgia, founded in 1994 under the name Airzena and rebranded in 1999. It operates scheduled and charter flights across Europe, the Middle East, and the CIS from its base in Tbilisi.</p>
            <h3>Fleet of Georgian Airways</h3>
            <p>As of 2024, the fleet consists of:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Embraer 190</td><td>3</td><td>Medium-haul routes, 100 seats</td></tr>
                    <tr><td>Boeing 737-700</td><td>1</td><td>Used on flights to Europe and the Middle East</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Georgian Airways operates seasonal direct flights between Tashkent and Tbilisi (2–3 times per week). Further connections to Europe are available via Tbilisi.</p>
            <h3>Brief Conclusion</h3>
            <p>Georgian Airways is a stable South Caucasus carrier offering convenient travel between Uzbekistan and Georgia.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Georgia</p>
            <h4>Headquarters:</h4><p>Tbilisi</p>
            <h4>Main Hub:</h4><p>Tbilisi International Airport (TBS)</p>
            <h4>Website:</h4><a href="https://www.georgian-airways.com" target="_blank" rel="noreferrer">www.georgian-airways.com</a>`,
        },
      ],
    },
    myWayAirlines: {
      pageKey: "myWayAirlinesInfo",
      imageUrl: "/images/AK/MW.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>MyWay Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>MyWay Airlines is a privately-owned Georgian low-cost carrier, founded in 2018. It focuses on connecting Georgia with the CIS region, the Middle East, and Central Asia.</p>
            <h3>Fleet of MyWay Airlines</h3>
            <p>As of 2024, its small fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-800</td><td>2</td><td>Medium-haul routes</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>MyWay Airlines previously operated charter flights from Tashkent and Samarkand to Tbilisi. As of 2024, flights depend on seasonal demand.</p>
            <h3>Brief Conclusion</h3>
            <p>MyWay Airlines is a flexible and affordable carrier connecting Georgia with key destinations in the region.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Georgia</p>
            <h4>Headquarters:</h4><p>Tbilisi</p>
            <h4>Main Hub:</h4><p>Tbilisi International Airport (TBS)</p>
            <h4>Website:</h4><a href="https://www.mywayairlines.com" target="_blank" rel="noreferrer">www.mywayairlines.com</a>`,
        },
      ],
    },
    koreanAir: {
      pageKey: "koreanAirInfo",
      imageUrl: "/images/AK/KE.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Korean Air</h1>
            <h2>Founding Date and History</h2>
            <p>Korean Air is the flag carrier and largest airline of South Korea, founded in 1969. A member of the SkyTeam alliance, it operates an extensive global network with high standards of service.</p>
            <h3>Fleet of Korean Air</h3>
            <p>As of 2024, the fleet includes:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 777-200/300</td><td>25+</td><td>Long-haul international flights</td></tr>
                    <tr><td>Airbus A330</td><td>20+</td><td>Regional and Asian routes</td></tr>
                    <tr><td>Boeing 747-8i / Airbus A380</td><td>10+</td><td>High-demand flagship routes</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Korean Air operates several weekly direct flights from Tashkent to Seoul (Incheon), offering one of the best connections to East Asia.</p>
            <h3>Brief Conclusion</h3>
            <p>Korean Air is a world-class airline with a modern fleet, premium service, and direct access from Uzbekistan to Korea and beyond.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>South Korea</p>
            <h4>Headquarters:</h4><p>Seoul</p>
            <h4>Main Hub:</h4><p>Incheon International Airport (ICN)</p>
            <h4>Website:</h4><a href="https://www.koreanair.com" target="_blank" rel="noreferrer">www.koreanair.com</a>`,
        },
      ],
    },
    jazeeraAirways: {
      pageKey: "jazeeraAirwaysInfo",
      imageUrl: "/images/AK/J9.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Jazeera Airways</h1>
            <h2>Founding Date and History</h2>
            <p>Jazeera Airways is a Kuwaiti low-cost airline established in 2004. It became the first non-government airline in the Gulf region to operate independently and offers affordable travel options across the Middle East, Asia, and Europe.</p>
            <h3>Fleet of Jazeera Airways</h3>
            <p>Its fleet consists entirely of modern Airbus aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320 / A320neo</td><td>20+</td><td>Efficient narrow-body aircraft for short- and medium-haul routes</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Jazeera Airways operates direct flights from Tashkent to Kuwait City (KWI) multiple times a week. Further connections are available to Dubai, Riyadh, Jeddah, Mumbai, and Istanbul.</p>
            <h3>Brief Conclusion</h3>
            <p>Jazeera Airways is an affordable and dependable Gulf carrier, offering direct flights from Uzbekistan and wide regional access.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Kuwait</p>
            <h4>Headquarters:</h4><p>Kuwait City</p>
            <h4>Main Hub:</h4><p>Kuwait International Airport (KWI), Terminal 5</p>
            <h4>Website:</h4><a href="https://www.jazeeraairways.com" target="_blank" rel="noreferrer">www.jazeeraairways.com</a>`,
        },
      ],
    },
    mahanAir: {
      pageKey: "mahanAirInfo",
      imageUrl: "/images/AK/W5.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Mahan Air</h1>
            <h2>Founding Date and History</h2>
            <p>Mahan Air is one of Iran’s largest private airlines, established in 1991. Based in Tehran, the airline operates a wide network of domestic and international routes across Asia and Europe.</p>
            <h3>Fleet of Mahan Air</h3>
            <p>The fleet includes both wide-body and regional aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A310 / A300</td><td>20+</td><td>Long-haul and charter flights</td></tr>
                    <tr><td>BAe 146</td><td>5+</td><td>Short routes, small airports</td></tr>
                    <tr><td>Airbus A340</td><td>10+</td><td>Intercontinental routes</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>As of 2024, Mahan Air operates seasonal flights from Tashkent to Tehran (IKA), with further connections to Turkey, China, and Lebanon.</p>
            <h3>Brief Conclusion</h3>
            <p>Mahan Air is a major Iranian airline with a solid fleet and strong connections, including flights to Central Asia.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Iran</p>
            <h4>Headquarters:</h4><p>Tehran</p>
            <h4>Main Hub:</h4><p>Imam Khomeini International Airport (IKA)</p>
            <h4>Website:</h4><a href="https://www.mahanair.ir" target="_blank" rel="noreferrer">www.mahanair.ir</a>`,
        },
      ],
    },
    indigoAirlines: {
      pageKey: "indigoAirlinesInfo",
      imageUrl: "/images/AK/6E.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>IndiGo Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>IndiGo is India’s largest airline, founded in 2006. It is widely known for its punctuality, affordable fares, and extensive domestic and international route network.</p>
            <h3>Fleet of IndiGo</h3>
            <p>IndiGo operates one of the youngest and largest narrow-body fleets in the world:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo / A321neo</td><td>300+</td><td>Short- and medium-haul, fuel-efficient</td></tr>
                    <tr><td>ATR 72-600</td><td>40+</td><td>Regional operations across India</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>IndiGo launched direct flights from Tashkent to Delhi in 2023. Passengers can conveniently connect to dozens of Indian cities.</p>
            <h3>Brief Conclusion</h3>
            <p>IndiGo is a reliable and cost-effective airline, ideal for travel between Uzbekistan and India with excellent connectivity.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>India</p>
            <h4>Headquarters:</h4><p>Gurugram, Haryana</p>
            <h4>Main Hub:</h4><p>Indira Gandhi International Airport (DEL)</p>
            <h4>Website:</h4><a href="https://www.goindigo.in" target="_blank" rel="noreferrer">www.goindigo.in</a>`,
        },
      ],
    },
    alrosaAirlines: {
      pageKey: "alrosaAirlinesInfo",
      imageUrl: "/images/AK/6R.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Alrosa Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Alrosa Airlines is a regional Russian carrier established in 1992. A subsidiary of the diamond mining giant ALROSA, it focuses on connecting remote areas of Yakutia and Siberia with the rest of Russia.</p>
            <h3>Fleet of Alrosa</h3>
            <p>The airline operates rugged aircraft suited for harsh northern conditions:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Tupolev Tu-154M</td><td>1</td><td>One of the last active Tu-154s in commercial service</td></tr>
                    <tr><td>Boeing 737-800</td><td>3+</td><td>Regional Russian routes</td></tr>
                    <tr><td>Antonov An-24 / An-38</td><td>5+</td><td>Short takeoff/landing airfields</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>As of 2024, Alrosa does not operate regular flights from Uzbekistan but may offer seasonal charter connections.</p>
            <h3>Brief Conclusion</h3>
            <p>Alrosa Airlines plays a vital role in connecting remote northern territories of Russia and remains a key regional operator.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Russia</p>
            <h4>Headquarters:</h4><p>Mirny, Sakha Republic (Yakutia)</p>
            <h4>Main Hub:</h4><p>Mirny Airport (MJZ)</p>
            <h4>Website:</h4><a href="https://www.alrosa.aero" target="_blank" rel="noreferrer">www.alrosa.aero</a>`,
        },
      ],
    },
    turkmenistanAirlines: {
      pageKey: "turkmenistanAirlinesInfo",
      imageUrl: "/images/AK/T5.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Turkmenistan Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Turkmenistan Airlines is the national airline of Turkmenistan, established in 1992. As the sole carrier in the country, it operates both domestic and international flights across Europe, Asia, and the CIS region.</p>
            <h3>Fleet of Turkmenistan Airlines</h3>
            <p>The fleet consists entirely of Boeing aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 737-700/800</td><td>10+</td><td>Short and medium-haul flights</td></tr>
                    <tr><td>Boeing 757-200</td><td>3</td><td>Mid-range international routes</td></tr>
                    <tr><td>Boeing 777-200LR</td><td>3</td><td>Long-haul flights including to London and Beijing</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>As of 2024, Turkmenistan Airlines offers seasonal direct flights from Tashkent to Ashgabat, with onward connections to other countries via Ashgabat.</p>
            <h3>Brief Conclusion</h3>
            <p>Turkmenistan Airlines is a reliable state-owned carrier connecting Central Asia with international destinations using a modern Boeing fleet.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Turkmenistan</p>
            <h4>Headquarters:</h4><p>Ashgabat</p>
            <h4>Main Hub:</h4><p>Ashgabat International Airport (ASB)</p>
            <h4>Website:</h4><a href="https://turkmenistanairlines.tm" target="_blank" rel="noreferrer">turkmenistanairlines.tm</a>`,
        },
      ],
    },
    saudiaAirlines: {
      pageKey: "saudiaAirlinesInfo",
      imageUrl: "/images/AK/SV.svg",
      generalInfo: [
        {
          content: `<article>
            <h1>Saudia Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Saudia, formerly known as Saudi Arabian Airlines, is the flag carrier of Saudi Arabia. Established in 1945, it is a SkyTeam member and among the largest carriers in the Middle East, offering global connectivity and premium service.</p>
            <h3>Fleet of Saudia</h3>
            <p>Its fleet includes modern wide-body and narrow-body aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Boeing 777-300ER</td><td>30+</td><td>Long-haul routes with premium seating</td></tr>
                    <tr><td>Airbus A330</td><td>30+</td><td>Regional and long-haul flights</td></tr>
                    <tr><td>Airbus A320/A321</td><td>50+</td><td>Short- and medium-haul regional operations</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Saudia offers direct flights from Tashkent to Jeddah (JED), especially during Hajj and Umrah seasons. Connections to Riyadh, Dammam, and Medina are also available.</p>
            <h3>Brief Conclusion</h3>
            <p>Saudia is a trusted full-service airline offering convenient connections from Uzbekistan to Saudi Arabia and beyond.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Saudi Arabia</p>
            <h4>Headquarters:</h4><p>Jeddah</p>
            <h4>Main Hub:</h4><p>King Abdulaziz International Airport (JED)</p>
            <h4>Website:</h4><a href="https://www.saudia.com" target="_blank" rel="noreferrer">www.saudia.com</a>`,
        },
      ],
    },
    pegasusAir: {
      pageKey: "pegasusAirInfo",
      imageUrl: "/images/AK/PC.png",
      generalInfo: [
        {
          content: `<article>
            <h1>Pegasus Airlines</h1>
            <h2>Founding Date and History</h2>
            <p>Pegasus Airlines is a major Turkish low-cost carrier founded in 1990. It operates flights across Europe, the Middle East, and Asia, offering affordable and reliable air travel.</p>
            <h3>Fleet of Pegasus Airlines</h3>
            <p>The fleet consists of modern narrow-body aircraft:</p>
            <table>
                <thead>
                    <tr><th>Aircraft Type</th><th>Count</th><th>Details</th></tr>
                </thead>
                <tbody>
                    <tr><td>Airbus A320neo / A321neo</td><td>90+</td><td>Fuel-efficient, medium to long-haul routes</td></tr>
                    <tr><td>Boeing 737-800</td><td>30+</td><td>Short-haul routes</td></tr>
                </tbody>
            </table>
            <h3>Flights from Uzbekistan</h3>
            <p>Pegasus Airlines operates direct flights from Tashkent to Istanbul (Sabiha Gökçen Airport) with connections to various international destinations.</p>
            <h3>Brief Conclusion</h3>
            <p>Pegasus is one of the best low-cost options for travelers flying from Uzbekistan to Turkey and Europe with modern aircraft and competitive pricing.</p>
          </article>`,
        },
      ],
      origin: [
        {
          content: `
            <h4>Country:</h4><p>Turkey</p>
            <h4>Headquarters:</h4><p>Istanbul</p>
            <h4>Main Hub:</h4><p>Sabiha Gökçen International Airport (SAW)</p>
            <h4>Website:</h4><a href="https://www.flypgs.com" target="_blank" rel="noreferrer">www.flypgs.com</a>`,
        },
      ],
    },
  },
};
